<template>
    <!-- <div class="live-stats-container" style="min-width: 1275px;"> -->
    <div class="live-stats-container">
        <!--        <div class="d-flex justify-content-center" style="height: 500px" v-if="!eventArray.length" >-->
        <!--            <div class="spinner-border" role="status" style="margin: auto">-->
        <!--                <span class="sr-only">Loading...</span>-->
        <!--            </div>-->
        <!--        </div>-->
        <b-modal id="modal-1"  hide-footer hide-header centered no-close-on-backdrop>
            <b-progress value="100" max="100" animated variant="secondary"></b-progress>
        </b-modal>
        <div v-if="!isload" style="height: 10px;">
            <b-progress :value="current_counter" :max="counter" animated></b-progress>
        </div>
        <CCard body-wrapper>
            <CTabs variant="tabs" :active-tab="1">
                <CTab @click.native="scheduled_tab()" :title="$t('Scheduled Games') + '('+scheduleLength+')'">
                    <div class="filter">
                        <label style="font-weight: bold; color: red; float: left;">Filter: </label>
                        <div style="width: 150px; float: left;">
                            <CSelect
                                    :options="sort_by"
                                    @update:value="sort_filter"
                            >
                            </CSelect>
                        </div>
                    </div>
                    <div style="clear: left;">
                    </div>
                    <div class="tab-pane-wrapper">
                        <div class="tab-pane-table-content">
                            <div v-for="(item, index) in scheduleArray">
                            
                            <div v-if="item.events.length > 0" class="schedule-header" style="display: flex; height: 30px; background: #d6d8d9; font-weight: 700; font-size: 15px; padding: 3px 5px;">
                                <div style="width: 35px">
                                    <input
                                        class="check-box0"
                                        type="checkbox"
                                        style="margin-top: -2px"
                                        @change='checkscheduleParent($event, index)'
                                    >
                                    
                                </div>
                                <div style="flex: 3;">{{item.league}}</div>
                                <div style="flex: 1;"></div>
                                <div style="flex: 0.5; text-align: center;">
                                    Matches
                                </div>
                                <div style="flex: 1; text-align: center;">
                                    1X2
                                </div>
                                <div style="flex: 1; text-align: center;">
                                    O/U 0.5
                                </div>
                                <div style="flex: 1; text-align: center;">
                                    O/U 1.5
                                </div>
                                <div style="flex: 1; text-align: center;">
                                    O/U 2.5
                                </div>
                                <div style="flex: 1; text-align: center;">
                                    O/U 3.5
                                </div>

                                <div style="flex: 1; text-align: center;">
                                    O/U 0.5 (ht)
                                </div>

                                <div style="flex: 1; text-align: center; padding-right: 20px;">
                                    BTS Yes/No
                                </div>
                                
                            </div>

                            <div v-for="(item1, rowIndex) in item.events" class="event-content" :style="{'height': 'auto', 'font-size': '16px', 'background': background_row[rowIndex % 2 + 2]}">

                                <div style="display: flex; width: 100%">
                                    <div style="width: 35px">
                                        <input
                                            class="check-box0"
                                            type="checkbox"
                                            style="margin-top: -2px"
                                            v-model="user_scheduled_ids"
                                            :value = "item1._id"
                                            checked="item.id"
                                        >
                                        
                                    </div>
                                    <div style="flex: 1; float: left;">
                                        {{item1.time.starting_at.date_time}}
                                    </div>
                                    <div style="flex: 1; float: left; text-align: right; padding-right: 2%;">
                                        {{item1.localTeamName}}
                                    </div>
                                    <div style="flex: 1; float: left; text-align: left; padding-left: 0%;">
                                        {{item1.visitorTeamName}}
                                    </div>
                                    
                                    <div style="flex: 1; float: left;">
                                        <div >                                        
                                            <div
                                                @click="SetCollapse1(item1.index0)"
                                                duration="100" class="column-league-content-link"
                                                style="display: inline-block;"
                                            >
                                                <img v-b-modal.modal-center src="/img/info_icon.png" @click="callHistoricalData1(item1.localTeamId, item1.visitorTeamId, item1.season_id, item1.localTeamName + ' v ' + item1.visitorTeamName, 0, 0, 0, 0, item1._id)" width="13px;" style="margin-top: -1px;" />
                                            </div>
                                            <a v-if="item1.com_url"  :href="item1.com_url" target="_blank" class="column-league-content-link">
                                                <img src="/img/bf.com_icon.png" style="margin-top: -2px;" />
                                            </a>                                            
                                        
                                            <a v-if="item1.it_url"  :href="item1.it_url" target="_blank"  class="column-league-content-link">
                                                <img src="/img/bf.it_icon_new.png" style="margin-top: -2px;" />
                                            </a>
                                            <div style="display: inline-block;">
                                                <span class="postTipBtn" @click="callPostTip(item1, item.league)" style="display: inline-block;">post</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="flex: 0.5; float: left; text-align: center; padding-left: 0%;">
                                        {{item1.sampleMatches}}
                                    </div>
                                    <div style="flex: 1; float: left; text-align: left; padding-left: 0%;">
                                        <div v-if="item1.match_1 != null" class="shedule-number-column">
                                            <span class="shedule-tab-match-number" style="background: #6c757d; padding: 0px 5px; font-weight: bold; border-radius: 3px; color: white;">{{item1.match_1}}</span>
                                            <span class="shedule-tab-match-number" style="background: #6c757d; padding: 0px 5px; font-weight: bold; border-radius: 3px; color: white;">{{item1.match_3}}</span>
                                            <span class="shedule-tab-match-number" style="background: #6c757d; padding: 0px 5px; font-weight: bold; border-radius: 3px; color: white;">{{item1.match_2}}</span>
                                        </div>
                                        <div v-else style="text-align: center">
                                            ...
                                        </div>
                                        <div v-if="item1.prob_home != null" class="shedule-number-column">
                                            <span v-if="item1.prob_home_tt2 > 10" class="shedule-tab-match-number green-label" style="padding: 0px 5px; border-radius: 3px; " :id="item1.uuid + 'hw'">{{item1.prob_home + '%'}}</span>
                                            <span v-else class="shedule-tab-match-number" style="padding: 0px 5px; border-radius: 3px; "  :id="item1.uuid + 'hw'">{{item1.prob_home + '%'}}</span>

                                            <span v-if="item1.prob_draw_tt2 > 10" class="shedule-tab-match-number green-label" style="padding: 0px 5px;  border-radius: 3px; "  :id="item1.uuid + 'dw'">{{item1.prob_draw + '%'}}</span>
                                            <span v-else class="shedule-tab-match-number" style="padding: 0px 5px;  border-radius: 3px; " :id="item1.uuid + 'dw'">{{item1.prob_draw + '%'}}</span>

                                            <span v-if="item1.prob_away_tt2 > 10"  class="shedule-tab-match-number green-label"  style="padding: 0px 5px; border-radius: 3px; "  :id="item1.uuid + 'aw'">{{item1.prob_away + '%'}}</span>
                                            <span v-else class="shedule-tab-match-number" style="padding: 0px 5px; border-radius: 3px; " :id="item1.uuid + 'aw'">{{item1.prob_away + '%'}}</span>
                                        </div>
                                        <div v-else style="text-align: center">
                                            ...
                                        </div>

                                        <b-tooltip v-if="item1.prob_home_tt1" :target="item1.uuid + 'hw'" triggers="hover">
                                            <span>True Odds: {{item1.prob_home_tt1}}</span><br>
                                            <span>Value: {{item1.prob_home_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="item1.prob_draw_tt1" :target="item1.uuid + 'dw'" triggers="hover">
                                            <span>True Odds: {{item1.prob_draw_tt1}}</span><br>
                                            <span>Value: {{item1.prob_draw_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="item1.prob_away_tt1" :target="item1.uuid + 'aw'" triggers="hover">
                                            <span>True Odds: {{item1.prob_away_tt1}}</span><br>
                                            <span>Value: {{item1.prob_away_tt2}}%</span>
                                        </b-tooltip>



                                    </div>
                                    

                                    <div  style="flex: 1; float: left; text-align: left; padding-left: 1%;">
                                        <div v-if="item1.odds_over05 != null" class="shedule-number-column">
                                            <span class="shedule-tab-match-number" style="background: #6c757d; padding: 0px 5px; font-weight: bold; border-radius: 3px; color: white;">{{item1.odds_over05}}</span>
                                            <span class="shedule-tab-match-number" style="background: #6c757d; padding: 0px 5px; font-weight: bold; border-radius: 3px; color: white;">{{item1.odds_under05}}</span>
                                        </div>
                                        <div v-else style="text-align: center">
                                            ...
                                        </div>
                                        <div v-if="item1.prob_over05 != null" class="shedule-number-column">
                                            <span v-if="item1.prob_over05_tt2 > 10" class="shedule-tab-match-number green-label" style="padding: 0px 5px; border-radius: 3px; " :id="item1.uuid + 'ov05'">{{item1.prob_over05 + '%'}}</span>
                                            <span v-else class="shedule-tab-match-number" style="padding: 0px 5px; border-radius: 3px; " :id="item1.uuid + 'ov05'">{{item1.prob_over05 + '%'}}</span>
                                            <span v-if="item1.prob_under05_tt2 > 10"  class="shedule-tab-match-number green-label" style="padding: 0px 5px;  border-radius: 3px; " :id="item1.uuid + 'un05'">{{item1.prob_under05 + '%'}}</span>
                                            <span v-else class="shedule-tab-match-number" style="padding: 0px 5px;  border-radius: 3px; " :id="item1.uuid + 'un05'">{{item1.prob_under05 + '%'}}</span>
                                        </div>
                                        <div v-else style="text-align: center">
                                            ...
                                        </div>

                                        <b-tooltip v-if="item1.prob_over05_tt1" :target="item1.uuid + 'ov05'" triggers="hover">
                                            <span>True Odds: {{item1.prob_over05_tt1}}</span><br>
                                            <span>Value: {{item1.prob_over05_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="item1.prob_under05_tt1" :target="item1.uuid + 'un05'" triggers="hover">
                                            <span>True Odds: {{item1.prob_under05_tt1}}</span><br>
                                            <span>Value: {{item1.prob_under05_tt2}}%</span>
                                        </b-tooltip>

                                    </div>
                                    

                                    <div style="flex: 1; float: left; text-align: left; padding-left: 1%;">
                                        <div v-if="item1.odds_over15 != null" class="shedule-number-column">
                                            <span class="shedule-tab-match-number" style="background: #6c757d; padding: 0px 5px; font-weight: bold; border-radius: 3px; color: white;">{{item1.odds_over15}}</span>
                                            <span class="shedule-tab-match-number" style="background: #6c757d; padding: 0px 5px; font-weight: bold; border-radius: 3px; color: white;">{{item1.odds_under15}}</span>
                                        </div>
                                        <div v-else style="text-align: center">
                                            ...
                                        </div>
                                        <div v-if="item1.prob_over15 != null" class="shedule-number-column">
                                            <span v-if="item1.prob_over15_tt2 > 10" class="shedule-tab-match-number green-label" style="padding: 0px 5px; border-radius: 3px; " :id="item1.uuid + 'ov15'">{{item1.prob_over15 + '%'}}</span>
                                            <span v-else class="shedule-tab-match-number" style="padding: 0px 5px; border-radius: 3px; " :id="item1.uuid + 'ov15'">{{item1.prob_over15 + '%'}}</span>
                                            <span v-if="item1.prob_under15_tt2 > 10" class="shedule-tab-match-number green-label" style="padding: 0px 5px;  border-radius: 3px; " :id="item1.uuid + 'un15'">{{item1.prob_under15 + '%'}}</span>
                                            <span v-else class="shedule-tab-match-number" style="padding: 0px 5px;  border-radius: 3px; "  :id="item1.uuid + 'un15'">{{item1.prob_under15 + '%'}}</span>
                                        </div>
                                        <div v-else style="text-align: center">
                                            ...
                                        </div>

                                        <b-tooltip v-if="item1.prob_over15_tt1" :target="item1.uuid + 'ov15'" triggers="hover">
                                            <span>True Odds: {{item1.prob_over15_tt1}}</span><br>
                                            <span>Value: {{item1.prob_over15_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="item1.prob_under15_tt1" :target="item1.uuid + 'un15'" triggers="hover">
                                            <span>True Odds: {{item1.prob_under15_tt1}}</span><br>
                                            <span>Value: {{item1.prob_under15_tt2}}%</span>
                                        </b-tooltip>

                                    </div>
                                    

                                    <div style="flex: 1; float: left; text-align: left; padding-left: 1%;">
                                        <div v-if="item1.odds_over25 != null"  class="shedule-number-column">
                                            <span class="shedule-tab-match-number" style="background: #6c757d; padding: 0px 5px; font-weight: bold; border-radius: 3px; color: white;" >{{item1.odds_over25}}</span>
                                            
                                            <span class="shedule-tab-match-number" style="background: #6c757d; padding: 0px 5px; font-weight: bold; border-radius: 3px; color: white;">{{item1.odds_under25}}</span>
                                           
                                        </div>
                                        <div v-else style="text-align: center">
                                            ...
                                        </div>
                                        <div v-if="item1.prob_over25 != null" class="shedule-number-column">
                                            <span v-if="item1.prob_over25_tt2 > 10"  class="shedule-tab-match-number green-label" style="padding: 0px 5px; border-radius: 3px; "  :id="item1.uuid + 'ov25'">{{item1.prob_over25 + '%'}}</span>
                                            <span v-else  class="shedule-tab-match-number" style="padding: 0px 5px; border-radius: 3px; "  :id="item1.uuid + 'ov25'">{{item1.prob_over25 + '%'}}</span>
                                            <span v-if="item1.prob_under25_tt2 > 10" class="shedule-tab-match-number green-label" style="padding: 0px 5px;  border-radius: 3px; "  :id="item1.uuid + 'un25'">{{item1.prob_under25 + '%'}}</span>
                                            <span v-else class="shedule-tab-match-number" style="padding: 0px 5px;  border-radius: 3px; "  :id="item1.uuid + 'un25'">{{item1.prob_under25 + '%'}}</span>
                                        </div>
                                        <div v-else style="text-align: center">
                                            ...
                                        </div>

                                        <b-tooltip v-if="item1.prob_over25_tt1" :target="item1.uuid + 'ov25'" triggers="hover">
                                            <span>True Odds: {{item1.prob_over25_tt1}}</span><br>
                                            <span>Value: {{item1.prob_over25_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="item1.prob_under25_tt1" :target="item1.uuid + 'un25'" triggers="hover">
                                            <span>True Odds: {{item1.prob_under25_tt1}}</span><br>
                                            <span>Value: {{item1.prob_under25_tt2}}%</span>
                                        </b-tooltip>

                                    </div>
                                    

                                    <div style="flex: 1; float: left; text-align: left; padding-left: 1%;">
                                        <div v-if="item1.odds_over35 != null" class="shedule-number-column">
                                            <span class="shedule-tab-match-number" style="background: #6c757d; padding: 0px 5px; font-weight: bold; border-radius: 3px; color: white;">{{item1.odds_over35}}</span>
                                            <span class="shedule-tab-match-number" style="background: #6c757d; padding: 0px 5px; font-weight: bold; border-radius: 3px; color: white;">{{item1.odds_under35}}</span>
                                        </div>
                                        <div v-else style="text-align: center">
                                            ...
                                        </div>
                                        <div v-if="item1.prob_over35 != null" class="shedule-number-column">
                                            <span v-if="item1.prob_over35_tt2 > 10"  class="shedule-tab-match-number green-label" style="padding: 0px 5px; border-radius: 3px; "  :id="item1.uuid + 'ov35'">{{item1.prob_over35 + '%'}}</span>
                                            <span v-else class="shedule-tab-match-number" style="padding: 0px 5px; border-radius: 3px; "  :id="item1.uuid + 'ov35'">{{item1.prob_over35 + '%'}}</span>
                                            <span v-if="item1.prob_under35_tt2 > 10"  class="shedule-tab-match-number green-label" style="padding: 0px 5px;  border-radius: 3px; "  :id="item1.uuid + 'un35'">{{item1.prob_under35 + '%'}}</span>
                                            <span v-else class="shedule-tab-match-number" style="padding: 0px 5px;  border-radius: 3px; "  :id="item1.uuid + 'un35'">{{item1.prob_under35 + '%'}}</span>
                                        </div>
                                        <div v-else style="text-align: center">
                                            ...
                                        </div>

                                        <b-tooltip v-if="item1.prob_over35_tt1" :target="item1.uuid + 'ov35'" triggers="hover">
                                            <span>True Odds: {{item1.prob_over35_tt1}}</span><br>
                                            <span>Value: {{item1.prob_over35_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="item1.prob_under35_tt1" :target="item1.uuid + 'un35'" triggers="hover">
                                            <span>True Odds: {{item1.prob_under35_tt1}}</span><br>
                                            <span>Value: {{item1.prob_under35_tt2}}%</span>
                                        </b-tooltip>

                                    </div>
                                    

                                    <div  style="flex: 1; float: left; text-align: left; padding-left: 1%;">
                                        <div v-if="item1.odds_over05_ht != null" class="shedule-number-column">
                                            <span class="shedule-tab-match-number" style="background: #6c757d; padding: 0px 5px; font-weight: bold; border-radius: 3px; color: white;">{{item1.odds_over05_ht}}</span>
                                            <span class="shedule-tab-match-number" style="background: #6c757d; padding: 0px 5px; font-weight: bold; border-radius: 3px; color: white;">{{item1.odds_under05_ht}}</span>
                                        </div>
                                        <div v-else style="text-align: center">
                                            ...
                                        </div>
                                        <div v-if="item1.prob_over05_ht != null" class="shedule-number-column">
                                            <span  v-if="item1.prob_over05_ht_tt2 > 10" class="shedule-tab-match-number green-label" style="padding: 0px 5px; border-radius: 3px; "  :id="item1.uuid + 'ov05ht'">{{item1.prob_over05_ht + '%'}}</span>
                                            <span v-else class="shedule-tab-match-number" style="padding: 0px 5px; border-radius: 3px; "  :id="item1.uuid + 'ov05ht'">{{item1.prob_over05_ht + '%'}}</span>
                                            <span  v-if="item1.prob_under05_ht_tt2 > 10"  class="shedule-tab-match-number green-label" style="padding: 0px 5px;  border-radius: 3px; "  :id="item1.uuid + 'un05ht'">{{item1.prob_under05_ht + '%'}}</span>
                                            <span v-else class="shedule-tab-match-number" style="padding: 0px 5px;  border-radius: 3px; "  :id="item1.uuid + 'un05ht'">{{item1.prob_under05_ht + '%'}}</span>
                                        </div>
                                        <div v-else style="text-align: center">
                                            ...
                                        </div>

                                        <b-tooltip v-if="item1.prob_over05_ht_tt1" :target="item1.uuid + 'ov05ht'" triggers="hover">
                                            <span>True Odds: {{item1.prob_over05_ht_tt1}}</span><br>
                                            <span>Value: {{item1.prob_over05_ht_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="item1.prob_under05_ht_tt1" :target="item1.uuid + 'un05ht'" triggers="hover">
                                            <span>True Odds: {{item1.prob_under05_ht_tt1}}</span><br>
                                            <span>Value: {{item1.prob_under05_ht_tt2}}%</span>
                                        </b-tooltip>

                                    </div>
                                    

                                    <div style="flex: 1; float: left; text-align: left; padding-left: 1%;">
                                        <div v-if="item1.odds_bts_yes != null" class="shedule-number-column" >
                                            <span class="shedule-tab-match-number" style="background: #6c757d; padding: 0px 5px; font-weight: bold; border-radius: 3px; color: white;">{{item1.odds_bts_yes}}</span>
                                            <span class="shedule-tab-match-number" style="background: #6c757d; padding: 0px 5px; font-weight: bold; border-radius: 3px; color: white;">{{item1.odds_bts_no}}</span>
                                        </div>
                                        <div v-else style="text-align: center">
                                            ...
                                        </div>
                                        <div v-if="item1.prob_bts != null" class="shedule-number-column">
                                            <span  v-if="item1.prob_bts_tt2 > 10" class="shedule-tab-match-number green-label" style="padding: 0px 5px; border-radius: 3px; "  :id="item1.uuid + 'bts'">{{item1.prob_bts + '%'}}</span>
                                            <span v-else class="shedule-tab-match-number" style="padding: 0px 5px; border-radius: 3px; "  :id="item1.uuid + 'bts'">{{item1.prob_bts + '%'}}</span>
                                            <span  v-if="item1.prob_bts_no_tt2 > 10" class="shedule-tab-match-number green-label" style="padding: 0px 5px;  border-radius: 3px; "  :id="item1.uuid + 'btsno'">{{item1.prob_bts_no + '%'}}</span>
                                            <span v-else class="shedule-tab-match-number" style="padding: 0px 5px;  border-radius: 3px; "  :id="item1.uuid + 'btsno'">{{item1.prob_bts_no + '%'}}</span>
                                        </div>
                                        <div v-else style="text-align: center">
                                            ...
                                        </div>

                                        <b-tooltip v-if="item1.prob_bts_tt1" :target="item1.uuid + 'bts'" triggers="hover">
                                            <span>True Odds: {{item1.prob_bts_tt1}}</span><br>
                                            <span>Value: {{item1.prob_bts_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="item1.prob_bts_no_tt1" :target="item1.uuid + 'btsno'" triggers="hover">
                                            <span>True Odds: {{item1.prob_bts_no_tt1}}</span><br>
                                            <span>Value: {{item1.prob_bts_no_tt2}}%</span>
                                        </b-tooltip>

                                    </div>
                                    
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                    <CCol sm="4" style="position:fixed; bottom: 0;">
                        <CButton
                            color="info"
                            class="m-2 save_match_data"
                            @click="save_scheduled"
                        >
                            {{ $t("Save to My Game") }}
                        </CButton>

                    </CCol>
                </CTab>
                <CTab :title="$t('LIVE Games') + '('+liveNumbers+')'">
                     <div style="margin:  20px;">
                        
                        <div v-if="advanced_search" class="advanced_search" id="top-element">
                            <CRow>
                                <CCol sm="4">
                                    <label>{{ $t("Leagues") }}</label>
                                    <multiselect 
                                        v-model="search_filters.league" 
                                        :options="leagueOptions" 
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        group-values="leagues" 
                                        group-label="all" 
                                        :group-select="true" 
                                        :placeholder="$t('Type to search')" 
                                        track-by="league_name" 
                                        label="league_name">
                                        <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} leagues selected</span></template>
                                        <template slot="tag">{{ '' }}</template>
                                    </multiselect>
                                    
                                </CCol>
                                <CCol sm="4">
                                    <label>{{ $t("Time min") }}</label>
                                    <CInput style="margin-bottom:  0px; height: 38px; " type="number" :value.sync="search_model.time_min"></CInput>
                                    
                                </CCol>
                                <CCol sm="4">
                                    <label>{{ $t("Time max") }} </label>
                                    <CInput style="margin-bottom:  0px; height: 38px; " type="number" :value.sync="search_model.time_max"></CInput>
                                    
                                </CCol>
                            </CRow>
                            <CRow style="margin-top: 10px;">
                                <CCol sm="12">
                                    <table class="search-table">
                                        <tr>
                                            <th colspan="16" style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white;">{{ $t('Total Game') }}
                                            </th>
                                            <th colspan="11" style="background: rgba(193, 176, 215, 0.75); border-left: 1px solid white;">{{ $t('Last 10 minutes') }}
                                            </th>
                                        </tr>
                                        <tr style="background: #b7eafc;">
                                            <th>
                                            </th>
                                            <!-- <th class="dualHeader1 " v-b-tooltip.hover = "$t(' Rank ')" colspan="1"><span>Rank</span></th>
                                            <th class="dualHeader1 " v-b-tooltip.hover.top = "$t(' Score ')" colspan="1"><span>Score</span></th>
                                            <th class="dualHeader1 " v-b-tooltip.hover.top = "$t(' On ')" colspan="1"><span>On</span></th>
                                            <th class="dualHeader1 " v-b-tooltip.hover.top = "$t(' Off ')" colspan="1"><span>Off</span></th>
                                            <th class="dualHeader1 " v-b-tooltip.hover.top = "$t(' Blk ')" colspan="1"><span>Blk</span></th>
                                            <th class="dualHeader1 " v-b-tooltip.hover.top = "$t(' In ')" colspan="1"><span>In</span></th>
                                            <th class="dualHeader1 " v-b-tooltip.hover.top = "$t(' Out ')" colspan="1"><span>Out</span></th>
                                            <th class="dualHeader1 " v-b-tooltip.hover.top = "$t(' Cnr ')" colspan="1"><span>Cnr</span></th>
                                            <th class="dualHeader1 " v-b-tooltip.hover.top = "$t(' DA ')" colspan="1"><span>DA</span></th>
                                            <th class="dualHeader1 " v-b-tooltip.hover.top = "$t(' Poss ')" colspan="1"><span>Poss</span></th>
                                            <th class="dualHeader1 " v-b-tooltip.hover.top = "$t(' Red ')" colspan="1"><span>Red</span></th>
                                            <th class="dualHeader1 " v-b-tooltip.hover.top = "$t(' Yel ')" colspan="1"><span>Yel</span></th>
                                            <th class="dualHeader1 " v-b-tooltip.hover.top = "$t(' Sbst ')" colspan="1"><span>Sbst</span></th>
                                            <th class="dualHeader1 " v-b-tooltip.hover.top = "$t(' Ini ')" colspan="1"><span>Ini</span></th>
                                            <th class="dualHeader1 " v-b-tooltip.hover.top = "$t(' PFM ')" colspan="1"><span>PFM</span></th>

                                            <th class="dualHeader1 " v-b-tooltip.hover.top = "$t(' On ')" colspan="1"><span>On</span></th>
                                            <th class="dualHeader1 " v-b-tooltip.hover.top = "$t(' Off ')" colspan="1"><span>Off</span></th>
                                            <th class="dualHeader1 " v-b-tooltip.hover.top = "$t(' Blk ')" colspan="1"><span>Blk</span></th>
                                            <th class="dualHeader1 " v-b-tooltip.hover.top = "$t(' In ')" colspan="1"><span>In</span></th>
                                            <th class="dualHeader1 " v-b-tooltip.hover.top = "$t(' Out ')" colspan="1"><span>Out</span></th>
                                            <th class="dualHeader1 " v-b-tooltip.hover.top = "$t(' Cnr ')" colspan="1"><span>Cnr</span></th>
                                            <th class="dualHeader1 " v-b-tooltip.hover.top = "$t(' DA ')" colspan="1"><span>DA</span></th>
                                            <th class="dualHeader1 " v-b-tooltip.hover.top = "$t(' Poss ')" colspan="1"><span>Poss</span></th>
                                            <th class="dualHeader1 " v-b-tooltip.hover.top = "$t(' Sbst ')" colspan="1"><span>Sbst</span></th>
                                            <th class="dualHeader1 " v-b-tooltip.hover.top = "$t(' Goal ')" colspan="1"><span>Goal</span></th>
                                            <th class="dualHeader1 " v-b-tooltip.hover.top = "$t(' Rtg ')" colspan="1"><span>Rtg</span></th> -->

                                            <th class="dualHeader1 " colspan="1"><span>Rank</span></th>
                                            <th class="dualHeader1 " colspan="1"><span>Score</span></th>
                                            <th class="dualHeader1 " colspan="1"><span>On</span></th>
                                            <th class="dualHeader1 " colspan="1"><span>Off</span></th>
                                            <th class="dualHeader1 " colspan="1"><span>Blk</span></th>
                                            <th class="dualHeader1 " colspan="1"><span>In</span></th>
                                            <th class="dualHeader1 " colspan="1"><span>Out</span></th>
                                            <th class="dualHeader1 " colspan="1"><span>Cnr</span></th>
                                            <th class="dualHeader1 " colspan="1"><span>DA</span></th>
                                            <th class="dualHeader1 " colspan="1"><span>Poss</span></th>
                                            <th class="dualHeader1 " colspan="1"><span>Red</span></th>
                                            <th class="dualHeader1 " colspan="1"><span>Yel</span></th>
                                            <th class="dualHeader1 " colspan="1"><span>Sbst</span></th>
                                            <th class="dualHeader1 " colspan="1"><span>Ini</span></th>
                                            <th class="dualHeader1 " colspan="1"><span>PFM</span></th>

                                            <th class="dualHeader1 " colspan="1"><span>On</span></th>
                                            <th class="dualHeader1 " colspan="1"><span>Off</span></th>
                                            <th class="dualHeader1 " colspan="1"><span>Blk</span></th>
                                            <th class="dualHeader1 " colspan="1"><span>In</span></th>
                                            <th class="dualHeader1 " colspan="1"><span>Out</span></th>
                                            <th class="dualHeader1 " colspan="1"><span>Cnr</span></th>
                                            <th class="dualHeader1 " colspan="1"><span>DA</span></th>
                                            <th class="dualHeader1 " colspan="1"><span>Poss</span></th>
                                            <th class="dualHeader1 " colspan="1"><span>Sbst</span></th>
                                            <th class="dualHeader1 " colspan="1"><span>Goal</span></th>
                                            <th class="dualHeader1 " colspan="1"><span>Rtg</span></th>
                                        </tr>
                                        <tr>
                                            <td class="table_pre_row">{{ $t("H/A") }}</td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="ha_options"
                                                    :value.sync="search_model_total.rank.ha_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="ha_options"
                                                    :value.sync="search_model_total.score.ha_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="ha_options"
                                                    :value.sync="search_model_total.on.ha_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="ha_options"
                                                    :value.sync="search_model_total.off.ha_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="ha_options"
                                                    :value.sync="search_model_total.blk.ha_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="ha_options"
                                                    :value.sync="search_model_total.in.ha_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="ha_options"
                                                    :value.sync="search_model_total.out.ha_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="ha_options"
                                                    :value.sync="search_model_total.cnr.ha_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="ha_options"
                                                    :value.sync="search_model_total.da.ha_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="ha_options"
                                                    :value.sync="search_model_total.poss.ha_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="ha_options"
                                                    :value.sync="search_model_total.red.ha_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="ha_options"
                                                    :value.sync="search_model_total.yel.ha_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="ha_options"
                                                    :value.sync="search_model_total.sbst.ha_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="ha_options"
                                                    :value.sync="search_model_total.nxt.ha_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="ha_options"
                                                    :value.sync="search_model_total.rtg.ha_option"
                                                />
                                            </td>

                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="ha_options"
                                                    :value.sync="search_model_ten.on.ha_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="ha_options"
                                                    :value.sync="search_model_ten.off.ha_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="ha_options"
                                                    :value.sync="search_model_ten.blk.ha_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="ha_options"
                                                    :value.sync="search_model_ten.in.ha_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="ha_options"
                                                    :value.sync="search_model_ten.out.ha_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="ha_options"
                                                    :value.sync="search_model_ten.cnr.ha_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="ha_options"
                                                    :value.sync="search_model_ten.da.ha_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="ha_options"
                                                    :value.sync="search_model_ten.poss.ha_option"
                                                />
                                            </td>                                           
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="ha_options"
                                                    :value.sync="search_model_ten.sbst.ha_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="ha_options"
                                                    :value.sync="search_model_ten.goal.ha_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="ha_options"
                                                    :value.sync="search_model_ten.rtg.ha_option"
                                                />
                                            </td>
                                        </tr> 
                                        <tr>
                                            <td class="table_pre_row">{{ $t("operational") }}</td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="operation_options"
                                                    :value.sync="search_model_total.rank.operation_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="operation_options"
                                                    :value.sync="search_model_total.score.operation_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="operation_options"
                                                    :value.sync="search_model_total.on.operation_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="operation_options"
                                                    :value.sync="search_model_total.off.operation_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="operation_options"
                                                    :value.sync="search_model_total.blk.operation_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="operation_options"
                                                    :value.sync="search_model_total.in.operation_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="operation_options"
                                                    :value.sync="search_model_total.out.operation_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="operation_options"
                                                    :value.sync="search_model_total.cnr.operation_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="operation_options"
                                                    :value.sync="search_model_total.da.operation_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="operation_options"
                                                    :value.sync="search_model_total.poss.operation_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="operation_options"
                                                    :value.sync="search_model_total.red.operation_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="operation_options"
                                                    :value.sync="search_model_total.yel.operation_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="operation_options"
                                                    :value.sync="search_model_total.sbst.operation_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="operation_options"
                                                    :value.sync="search_model_total.nxt.operation_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="operation_options"
                                                    :value.sync="search_model_total.rtg.operation_option"
                                                />
                                            </td>

                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="operation_options"
                                                    :value.sync="search_model_ten.on.operation_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="operation_options"
                                                    :value.sync="search_model_ten.off.operation_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="operation_options"
                                                    :value.sync="search_model_ten.blk.operation_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="operation_options"
                                                    :value.sync="search_model_ten.in.operation_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="operation_options"
                                                    :value.sync="search_model_ten.out.operation_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="operation_options"
                                                    :value.sync="search_model_ten.cnr.operation_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="operation_options"
                                                    :value.sync="search_model_ten.da.operation_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="operation_options"
                                                    :value.sync="search_model_ten.poss.operation_option"
                                                />
                                            </td>                                           
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="operation_options"
                                                    :value.sync="search_model_ten.sbst.operation_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="operation_options"
                                                    :value.sync="search_model_ten.goal.operation_option"
                                                />
                                            </td>
                                            <td style="padding: 0px;" class="search-table-cell">
                                                <CSelect
                                                    style="margin-bottom:  0px;"
                                                    :options="operation_options"
                                                    :value.sync="search_model_ten.rtg.operation_option"
                                                />
                                            </td>
                                        </tr> 
                                        <tr>
                                            <td class="table_pre_row">min</td>

                                            
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 35px;" :value.sync="search_model_total.rank.min"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 35px;" :value.sync="search_model_total.score.min"></CInput>
                                            </td> 
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_total.on.min"></CInput>
                                            </td> 
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_total.off.min"></CInput>
                                            </td> 
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_total.blk.min"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_total.in.min"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_total.out.min"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_total.cnr.min"></CInput>
                                            </td>
                                             <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_total.da.min"></CInput>
                                            </td>
                                             <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_total.poss.min"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_total.red.min"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_total.yel.min"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_total.sbst.min"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_total.nxt.min"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_total.rtg.min"></CInput>
                                            </td>
                                           
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_ten.on.min"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_ten.off.min"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_ten.blk.min"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_ten.in.min"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_ten.out.min"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_ten.cnr.min"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_ten.da.min"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_ten.poss.min"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_ten.sbst.min"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_ten.goal.min"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_ten.rtg.min"></CInput>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="table_pre_row">max</td>

                                            
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 35px;" :value.sync="search_model_total.rank.max"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 35px;" :value.sync="search_model_total.score.max"></CInput>
                                            </td> 
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_total.on.max"></CInput>
                                            </td> 
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_total.off.max"></CInput>
                                            </td> 
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_total.blk.max"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_total.in.max"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_total.out.max"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_total.cnr.max"></CInput>
                                            </td>
                                             <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_total.da.max"></CInput>
                                            </td>
                                             <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_total.poss.max"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_total.red.max"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_total.yel.max"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_total.sbst.max"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_total.nxt.max"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_total.rtg.max"></CInput>
                                            </td>
                                           
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_ten.on.max"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_ten.off.max"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_ten.blk.max"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_ten.in.max"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_ten.out.max"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_ten.cnr.max"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_ten.da.max"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_ten.poss.max"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_ten.sbst.max"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_ten.goal.max"></CInput>
                                            </td>
                                            <td style="padding: 0px">
                                                <CInput style="margin-bottom:  0px; height: 100%;" :value.sync="search_model_ten.rtg.max"></CInput>
                                            </td>
                                        </tr>                                       
                                    </table>
                                </CCol>
                            </CRow>
                            <div style="height: 20px">
                            </div>

                            
                            <CButton
                                v-if="showSaveFilter"
                                style="background-color: red; color: white;"
                                class="m-2"
                                @click="handleCreatePreset"
                                :disabled="search_filters.league.length === 0 || liveStat_model_id"
                            >
                                {{ $t("Hide create preset") }}
                                
                            </CButton>
                            <CButton
                                v-else
                                color="info"
                                class="m-2"
                                @click="handleCreatePreset"
                                :disabled="search_filters.league.length === 0 || liveStat_model_id"
                            >
                                {{ $t("Create preset") }}
                                
                            </CButton>
                            
                            <CButton
                                v-if="showLoadFilter"
                                style="background-color: red; color: white;"
                                class="m-2"
                                @click="handleLoadPreset"
                            >
                                {{ $t("Hide load preset") }}
                                <CSpinner v-if="load_preset" color="danger" size="sm" />
                                
                            </CButton>
                            <CButton
                                v-else
                                color="info"
                                class="m-2"
                                @click="handleLoadPreset"
                            >
                                {{ $t("Load preset") }}
                                <CSpinner v-if="load_preset" color="danger" size="sm" />
                                
                            </CButton>
                            <div v-if="showSaveFilter">
                                <span>{{ $t("Filter name") }}</span>
                                <CRow>
                                    
                                    <CCol sm="4">
                                        
                                        <CInput style="margin-bottom:  5px !important;"  :value.sync="filter_name"></CInput>
                                        
                                    </CCol>
                                    <CCol sm="4">
                                        <CButton class="btn-search" color="success" @click="handleSaveFilter" :disabled="filter_name === '' || save_filter" style="margin-bottom:  10px !important;" >{{ $t("Save Filter") }}
                                            <CSpinner v-if="save_filter" color="danger" size="sm" />
                                        </CButton>

                                    </CCol>

                                </CRow>
                            </div>
                            <div v-if="showEditFilter && showLoadFilter">
                                <span>{{ $t("Edit filter name") }}</span>
                                <CRow>
                                    
                                    <CCol sm="4">
                                        
                                        <CInput style="margin-bottom:  5px !important;" :value.sync="edit_filter_name"></CInput>
                                        
                                    </CCol>
                                    <CCol sm="4"> 
                                        <CButton class="btn-search" color="success" @click="handleUpdateFilter" :disabled="edit_filter_name === '' || update_filter" style="margin-bottom:  10px !important;" >{{ $t("Update Filter") }}
                                            <CSpinner v-if="update_filter" color="danger" size="sm" />
                                        </CButton>
                                    </CCol>
                                </CRow>
                            </div>
                            <div v-if="showLoadFilter">
                                <span>{{ $t("Saved filters list") }}</span>
                                <CRow>
                                    
                                    <CCol sm="4">
                                        
                                        <CSelect
                                            style="margin-bottom:  10px !important;"
                                            :options="saved_filters"
                                            :value.sync="selected_filter"
                                            :disabled="liveStat_model_id"
                                        />
                                        
                                    </CCol>
                                    <CCol sm="4">
                                        <CButton class="btn-search" color="success" @click="handleLoadFilter" :disabled="liveStat_model_id">{{ $t("Load Filter") }}
                                            <CSpinner v-if="load_filter" color="danger" size="sm" />
                                        </CButton>
                                        <CButton class="btn-search" color="success" @click="handleDeleteFilter" style="margin-left: 5px;" :disabled="liveStat_model_id">{{ $t("Delete Filter") }}
                                            <CSpinner v-if="delete_filter" color="danger" size="sm" />
                                        </CButton>
                                        <CButton class="btn-search" color="success" @click="handleEditFilter" style="margin-left: 5px;" :disabled="liveStat_model_id">{{ $t("Edit Filter") }}
                                            <CSpinner v-if="edit_filter" color="danger" size="sm" />
                                        </CButton>
                                    </CCol>

                                </CRow>
                            </div>

                            <CButton
                                id="save-action"
                                color="info"
                                class="m-2"
                                :disabled="search_filters.league.length === 0"
                                @click="handleSearch"
                            >
                                {{ $t("Apply filters") }}
                                <!-- <CSpinner v-if="loading" color="danger" size="sm" /> -->
                            </CButton>
                            <CButton
                                id="cancel-action"
                                color="info"
                                class="m-2"
                                :disabled="!apply_filter"
                                @click="handleCancelSearch"
                            >
                                {{ $t("Clear filters") }}
                                
                            </CButton>
                        </div>
                    </div>
                    <div class="tab-pane-wrapper">
                        <div class="tab-pane-table-content">
                            <div v-if="apply_filter" class="sub_event_list" style="text-align: center; font-size: 19px !important; font-weight: 500;">{{ $t("Filtered list") }} ({{counted_events}})</div>
                            
                            <div v-for="(item, index) in filtered_eventArray">

                                <div v-if="item.events.length > 0 && item.league"  class="header" style="width: 100%; height: 50px; position: relative;">
                                    <div class="column-header-checkbox">
                                        <input
                                            class="check-box0"
                                            type="checkbox"
                                            @change='checkliveParent($event, index)'
                                        >
                                    </div>
                                    
                                    <div class="header-content column-league-header">
                                        {{item.league}}
                                    </div>
                                    <div class="header-content column-result-header">
                                        {{ $t('Result') }}
                                    </div>
                                    <div class="header-content detail_total column-total-game-header-wrapper" style="">
                                         {{ $t('Total Game') }}
                                        <div class="column-total-game-header">
                                            <div :id="item.league_id + '-LIVE-TOTAL-On'" class="detail">
                                                On
                                            </div>
                                            <div :id="item.league_id + '-LIVE-TOTAL-Off'" class="detail">
                                                Off
                                            </div>
                                            <div :id="item.league_id + '-LIVE-TOTAL-Blk'" class="detail">
                                                Blk
                                            </div>
                                            <div :id="item.league_id + '-LIVE-TOTAL-In'" class="detail">
                                                In
                                            </div>
                                            <div :id="item.league_id + '-LIVE-TOTAL-Out'" class="detail">
                                                Out
                                            </div>
                                            <div :id="item.league_id + '-LIVE-TOTAL-Cnr'" class="detail">
                                                Cnr
                                            </div>
                                            <div :id="item.league_id + '-LIVE-TOTAL-DA'" class="detail">
                                                DA
                                            </div>
                                            <div :id="item.league_id + '-LIVE-TOTAL-Poss'" class="detail" style="min-width: 30px;">
                                                Poss
                                            </div>
                                            <div :id="item.league_id + '-LIVE-TOTAL-Red'" class="detail">
                                                Red
                                            </div>
                                            <div :id="item.league_id + '-LIVE-TOTAL-Yel'" class="detail">
                                                Yel
                                            </div>
                                            <div :id="item.league_id + '-LIVE-TOTAL-Sbst'" class="detail">
                                                Sbst
                                            </div>
                                            <div :id="item.league_id + '-LIVE-TOTAL-Ini'" class="detail" style="min-width: 30px;">
                                                Ini
                                            </div>
                                            <div :id="item.league_id + '-LIVE-TOTAL-PFM'" class="detail" style="width: 4%;">
                                                PFM
                                            </div>
                                        </div>
                                        <b-tooltip :target="item.league_id + '-LIVE-TOTAL-On'" triggers="hover">
                                            <span>{{ $t(' On ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-LIVE-TOTAL-Off'" triggers="hover">
                                            <span>{{ $t(' Off ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-LIVE-TOTAL-Blk'" triggers="hover">
                                            <span>{{ $t(' Blk ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-LIVE-TOTAL-In'" triggers="hover">
                                            <span>{{ $t(' In ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-LIVE-TOTAL-Out'" triggers="hover">
                                            <span>{{ $t(' Out ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-LIVE-TOTAL-Cnr'" triggers="hover">
                                            <span>{{ $t(' Cnr ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-LIVE-TOTAL-DA'" triggers="hover">
                                            <span>{{ $t(' DA ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-LIVE-TOTAL-Poss'" triggers="hover">
                                            <span>{{ $t(' Poss ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-LIVE-TOTAL-Red'" triggers="hover">
                                            <span>{{ $t(' Red ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-LIVE-TOTAL-Yel'" triggers="hover">
                                            <span>{{ $t(' Yel ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-LIVE-TOTAL-Sbst'" triggers="hover">
                                            <span>{{ $t(' Sbst ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-LIVE-TOTAL-Ini'" triggers="hover">
                                            <span>{{ $t(' Ini ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-LIVE-TOTAL-PFM'" triggers="hover">
                                            <span>{{ $t(' PFM ') }}</span>
                                        </b-tooltip>
                                    </div>
                                    <div class="header-content detail_total column-last-10-header-wrapper">
                                        {{ $t('Last 10 minutes') }}
                                        <div class="column-last-10-header" style="width: 100%">
                                            <div :id="item.league_id + '-LIVE-10-On'" class="detail">
                                                On
                                            </div>
                                            <div :id="item.league_id + '-LIVE-10-Off'" class="detail">
                                                Off
                                            </div>
                                            <div :id="item.league_id + '-LIVE-10-Blk'" class="detail">
                                                Blk
                                            </div>
                                            <div :id="item.league_id + '-LIVE-10-In'" class="detail">
                                                In
                                            </div>
                                            <div :id="item.league_id + '-LIVE-10-Out'" class="detail">
                                                Out
                                            </div>
                                            <div :id="item.league_id + '-LIVE-10-Cnr'" class="detail">
                                                Cnr
                                            </div>
                                            <div :id="item.league_id + '-LIVE-10-DA'" class="detail">
                                                DA
                                            </div>
                                            <div :id="item.league_id + '-LIVE-10-Poss'" class="detail1" style="min-width: 32px;">
                                                Poss
                                            </div>
                                            <div :id="item.league_id + '-LIVE-10-Sbst'" class="detail1">
                                                Sbst
                                            </div>
                                            <div :id="item.league_id + '-LIVE-10-Goal'" class="detail1" style="min-width: 35px;">
                                                Goal
                                            </div>
                                            <div :id="item.league_id + '-LIVE-10-Rtg'" class="detail1">
                                                Rtg
                                            </div>
                                        </div>
                                        <b-tooltip :target="item.league_id + '-LIVE-10-On'" triggers="hover">
                                            <span>{{ $t(' On ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-LIVE-10-Off'" triggers="hover">
                                            <span>{{ $t(' Off ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-LIVE-10-Blk'" triggers="hover">
                                            <span>{{ $t(' Blk ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-LIVE-10-In'" triggers="hover">
                                            <span>{{ $t(' In ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-LIVE-10-Out'" triggers="hover">
                                            <span>{{ $t(' Out ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-LIVE-10-Cnr'" triggers="hover">
                                            <span>{{ $t(' Cnr ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-LIVE-10-DA'" triggers="hover">
                                            <span>{{ $t(' DA ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-LIVE-10-Poss'" triggers="hover">
                                            <span>{{ $t(' Poss ') }}</span>
                                        </b-tooltip>
                                       
                                        <b-tooltip :target="item.league_id + '-LIVE-10-Sbst'" triggers="hover">
                                            <span>{{ $t(' Sbst ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-LIVE-10-Goal'" triggers="hover">
                                            <span>{{ $t(' Goal ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-LIVE-10-Rtg'" triggers="hover">
                                            <span>{{ $t(' Rtg ') }}</span>
                                        </b-tooltip>
                                    </div>
                                    <div class="header-content" style="width: 19%; float: left; border-left: 1px solid whitesmoke; font-weight: bold;">
                                        {{ $t('Odds') }}
                                        <div class="column-odds-header" style="width: 100%">
                                            <div :id="item.league_id + '-LIVE-1_2'"  style="width: 45%; float: left; text-align: center;">
                                                1 X 2
                                            </div>
                                            <div :id="item.league_id + '-LIVE-O_U'" style="width: 55%; float: left; text-align: center;">
                                                O / U
                                            </div>
                                        </div>
                                    </div>

                                    <div :id="item.league_id + '-LIVE-NextGoal'" class="header-content column-next-goal-header" style="font-weight: bold;">
                                        {{ $t('Next Goal') }}                     
                                    </div>

                                    <div :id="item.league_id + '-LIVE-GB'" class="header-content detail_total column-gb-percent-header" style="font-weight: bold;">
                                        GB (%)                                
                                    </div>

                                    <b-tooltip :target="item.league_id + '-LIVE-1_2'" triggers="hover">
                                        <span>{{ $t(' 1 X 2 ') }}</span>
                                    </b-tooltip>
                                    <b-tooltip :target="item.league_id + '-LIVE-O_U'" triggers="hover">
                                        <span>{{ $t(' O / U ') }}</span>
                                    </b-tooltip>
                                    <b-tooltip :target="item.league_id + '-LIVE-NextGoal'" triggers="hover">
                                        <span>{{ $t(' Next Goal ') }}</span>
                                    </b-tooltip>
                                    <b-tooltip :target="item.league_id + '-LIVE-GB'" triggers="hover">
                                        <span>{{ $t(' GB (%) ') }}</span>
                                    </b-tooltip>
                                    
                                </div>
                                <div v-for="(item1, index) in item.events" class="content" :style="{'width': '100%', 'position': 'relative', 'height': '80px', 'font-weight': '600', 'background': background_row[index % 2]}">

                                    <div style="height: 0px; position: relative; top: 31px; left: 5px;z-index: 1000;">
                                        
                                        <input
                                            class="check-box0"
                                            type="checkbox"
                                            style="margin-top: -2px"
                                            v-model="user_live_ids"
                                            :value = "item1.main_data._id"
                                        >
                                        
                                    </div>

                                    
                                    <!--  home team data part Total (League column first line) -->
                                    <div style="width: 15%; height: 80px; float: left; position: relative; top: 0px;">
                                        <div class="time_manner" style="width: 50px; float: left;position: relative; top:  28px; left: 24px; font-size: 17px; font-weight: normal"><p>{{item1.home.time}}'</p><p>{{item1.home.added_time}}</p></div>
                                        
                                        <div class="column-league-content">
                                            <div class="column-league-name">
                                                <div v-if="item1.home.flash == 1" class="goal_manner">{{item1.main_data.home_name}} <span v-if="item1.stage_has_standings">({{item1.main_data.home_rank}})</span></div>
                                                <div v-else >{{item1.main_data.home_name}} <span v-if="item1.stage_has_standings">({{item1.main_data.home_rank}})</span>
                                                </div>
                                            </div>
                                            <div class="column-league-content-links-wrapper">
                                                <div class="column-league-content-links">
                                                    <div
                                                        @click="SetCollapse1(item1.index0)"
                                                        duration="100" class="column-league-content-link"
                                                    >
                                                        <img v-b-modal.modal-center src="/img/info_icon.png" @click="callHistoricalData(item1.home.id, item1.away.id, item1.season_id, item1.main_data.home_name + ' v ' + item1.main_data.away_name, item1.home.rtg, item1.home.a_rtg, item1.away.rtg, item1.away.a_rtg, item1.fixtureId)" width="13px;" style="margin-top: -1px;" />
                                                    </div>
                                                    <a v-if="item1.com_url != ''"  :href="item1.com_url" target="_blank" class="column-league-content-link">
                                                        <img src="/img/bf.com_icon.png" style="margin-top: -2px;" />
                                                    </a>
                                                    <a v-if="item1.it_url != ''"  :href="item1.it_url" target="_blank"  class="column-league-content-link">
                                                        <img src="/img/bf.it_icon_new.png" style="margin-top: -2px;" />
                                                    </a>
                                                    <div style="display: inline-block;">
                                                        <div class="postTipBtn" @click="callPostTip(item1, item.league)">post</div>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                            <div class="column-league-name">
                                                <div v-if="item1.away.flash == 1" class="goal_manner">{{item1.main_data.away_name}} <span v-if="item1.stage_has_standings">({{item1.main_data.away_rank}})</span></div>
                                                <div v-else>{{item1.main_data.away_name}} <span v-if="item1.stage_has_standings">({{item1.main_data.away_rank}})</span></div>
                                            </div>
                                        </div>

                                    </div>
                                    <!-- League column - second line -->
                                    <!-- <a :href="item1.com_url" target="_blank" style="float: left; height: 0px; position: relative; top: 23px; left: -53px; z-index: 1000;">
                                        <img src="/img/bf.com_icon.png" style="width: 20px; cursor: pointer; outline: none;"/>
                                    </a>
                                    <a :href="item1.it_url" target="_blank" style="float: left; height: 0px; position: relative; top: 23px; left: -25px; z-index: 1000;">
                                        <img v-if="item1.it_url != ''" src="/img/bf.it_icon_new.png" style="width: 20px; cursor: pointer; outline: none;"/>
                                    </a>
                                    <div
                                            @click="SetCollapse1(item1.index0)"
                                            duration="100"
                                            style="height: 0px; position: relative; top: 23px; left: -80px; float: left; z-index: 1000;"
                                    >
                                        <img v-b-modal.modal-center src="/img/info_icon.png" @click="callHistoricalData(item1.home.id, item1.away.id, item1.season_id, item1.main_data.home_name + ' v ' + item1.main_data.away_name, item1.home.rtg, item1.home.a_rtg, item1.away.rtg, item1.away.a_rtg, item1.fixtureId)" width="13px;" style="width: 20px; cursor: pointer; outline: none;"/>
                                    </div> -->
                                    <div class="column-result">
                                        <div style="padding: 0; color: black; width: 100%;">
                                            <div :key="item1.goalKey" class="detail" style="color: red; position: relative; width: 100%">
                                                <p :id="item1.goalKey">{{item1.home.score}} - {{item1.away.score}}</p>
                                                <!-- <p>{{item1.aggregate_result}}</p> -->
                                                <p v-if="item1.scores.ht_score" style="color: lightgrey;">{{"( " + item1.scores.ht_score + " )"}}</p>
                                            </div>
                                            <b-tooltip :key="item1.goalKey + '1'" :target="item1.goalKey" v-if="item1.goal_tooltip != ''" triggers="hover">
                                                {{item1.goal_tooltip}}
                                            </b-tooltip>
                                        </div>
                                    </div>
                                    <div class="detail_total column-total-game-wrapper">
                                        <div class="column-total-game" style="color: #212529;">
                                            <div v-if="item1.homeT.on == 0" class="detail" style="color: #212529;">
                                                0
                                            </div>
                                            <div :key="item1.home_tooltip.onKey" :id="item1.home_tooltip.onKey"  v-if="item1.homeT.on > 0" class="detail" style="color: #212529;">
                                                {{item1.homeT.on}}
                                            </div>
                                            <b-tooltip v-if="item1.homeT.on > 0" :key="item1.home_tooltip.onKey + '1'" :target="item1.home_tooltip.onKey" triggers="hover">
                                                {{item1.home_tooltip.on}}
                                            </b-tooltip>

                                            <!-- <b-tooltip ref="tooltip" :target="item1.home_tooltip.onKey" placement="top">
                                                Hello <strong>World!</strong>
                                            </b-tooltip> -->

                                            <div v-if="item1.homeT.off == 0" class="detail" style="color: #212529">
                                                {{item1.homeT.off}}
                                            </div>
                                            <div :key="item1.home_tooltip.offKey" :id="item1.home_tooltip.offKey"  v-if="item1.homeT.off > 0" class="detail" style="color: #212529;">
                                                {{item1.homeT.off}}
                                            </div>
                                            <b-tooltip v-if="item1.homeT.off > 0" :key="item1.home_tooltip.offKey + '1'" :target="item1.home_tooltip.offKey" triggers="hover">
                                                {{item1.home_tooltip.off}}
                                            </b-tooltip>
                                            <div :key="item1.home_tooltip.blkKey" :id="item1.home_tooltip.blkKey"  v-if="item1.homeT.blk > 0" class="detail" style="color: #212529;">
                                                {{item1.homeT.blk}}
                                            </div>
                                            <b-tooltip v-if="item1.homeT.blk > 0" :key="item1.home_tooltip.blkKey + '1'" :target="item1.home_tooltip.blkKey" triggers="hover">
                                                {{item1.home_tooltip.blk}}
                                            </b-tooltip>

                                            <div v-if="item1.homeT.blk == 0 && item1.awayT.blk != 0" class="detail" style="color: #212529">
                                                {{item1.homeT.blk}}
                                            </div>
                                            <div v-if="item1.homeT.blk == null || (item1.homeT.blk == 0 && item1.awayT.blk == 0)" class="detail" style="color: #212529">
                                                -
                                            </div>
                                            <div v-if="item1.homeT.in == 0" class="detail" style="color: #212529">
                                                {{item1.homeT.in}}
                                            </div>
                                            <div :key="item1.home_tooltip.inKey" :id="item1.home_tooltip.inKey"  v-if="item1.homeT.in > 0" class="detail" style="color: #212529;">
                                                {{item1.homeT.in}}
                                            </div>
                                            <b-tooltip v-if="item1.homeT.in > 0" :key="item1.home_tooltip.inKey + '1'" :target="item1.home_tooltip.inKey" triggers="hover">
                                                {{item1.home_tooltip.in}}
                                            </b-tooltip>
                                            <div v-if="item1.homeT.in == null" class="detail" style="color: #212529">
                                                -
                                            </div>
                                            <div v-if="item1.homeT.out == 0" class="detail" style="color: #212529">
                                                {{item1.homeT.out}}
                                            </div>
                                            <div :key="item1.home_tooltip.outKey" :id="item1.home_tooltip.outKey"  v-if="item1.homeT.out > 0" class="detail" style="color: #212529;">
                                                {{item1.homeT.out}}
                                            </div>
                                            <b-tooltip v-if="item1.homeT.out > 0" :key="item1.home_tooltip.outKey + '1'" :target="item1.home_tooltip.outKey" triggers="hover">
                                                {{item1.home_tooltip.out}}
                                            </b-tooltip>
                                            <div v-if="item1.homeT.out == null" class="detail" style="color: #212529">
                                                -
                                            </div>
                                            <div v-if="item1.homeT.cnr == 0" class="detail" style="color: #212529">
                                                {{item1.homeT.cnr}}
                                            </div>
                                            <div :key="item1.home_tooltip.cnrKey" :id="item1.home_tooltip.cnrKey"  v-if="item1.homeT.cnr > 0" class="detail" style="color: #212529;">
                                                {{item1.homeT.cnr}}
                                            </div>
                                            <b-tooltip v-if="item1.homeT.cnr > 0" :key="item1.home_tooltip.cnrKey + '1'" :target="item1.home_tooltip.cnrKey" triggers="hover">
                                                {{item1.home_tooltip.cnr}}
                                            </b-tooltip>

                                            <div v-if="item1.homeT.cnr == null" class="detail" style="color: #212529">
                                                -
                                            </div>
                                            <div v-if="item1.homeT.da == 0" class="detail" style="color: #212529">
                                                {{item1.homeT.da}}
                                            </div>
                                            <div v-if="item1.homeT.da > 0" class="detail" style="color: #212529">
                                                {{item1.homeT.da}}
                                            </div>
                                            <div v-if="item1.homeT.poss == null" class="detail" style="color: #212529">
                                                -
                                            </div>
                                            <div v-if="item1.homeT.poss == 0" class="detail" style="color: #212529">
                                                {{item1.homeT.poss}}
                                            </div>
                                            <div v-if="item1.homeT.poss != 0 && item1.homeT.poss != null" class="detail" style="color: #212529">
                                                {{item1.homeT.poss}}
                                            </div>
                                            <div v-if="item1.homeT.red == null" class="detail" style="color: #212529">
                                                -
                                            </div>
                                            <div v-if="item1.homeT.red == 0" class="detail" style="color: #212529">
                                                0
                                            </div>
                                            <div v-if="item1.homeT.red != 0 && item1.homeT.red != null" class="detail" :id="item1.home_tooltip.redKey" style="color: #212529; background-color: red;">
                                                {{item1.homeT.red}}
                                            </div>
                                            <b-tooltip v-if="item1.homeT.red != 0 && item1.homeT.red != null" :target="item1.home_tooltip.redKey" triggers="hover">
                                                {{item1.home_tooltip.red}}
                                            </b-tooltip>
                                            <div v-if="item1.homeT.yel == null" class="detail" style="color: #212529">
                                                -
                                            </div>
                                            <div v-if="item1.homeT.yel == 0" class="detail" style="color: #212529">
                                                0
                                            </div>
                                            <div v-if="item1.homeT.yel != 0 && item1.homeT.yel != null" class="detail" :id="item1.home_tooltip.yelKey" style="color: #212529">
                                                {{item1.homeT.yel}}
                                            </div>
                                            <b-tooltip v-if="item1.homeT.yel != 0 && item1.homeT.yel != null" :target="item1.home_tooltip.yelKey" triggers="hover">
                                                {{item1.home_tooltip.yel}}
                                            </b-tooltip>
                                            <div v-if="item1.homeT.sbst == null" class="detail" style="color: #212529">
                                                -
                                            </div>
                                            <div v-if="item1.homeT.sbst == 0" class="detail" style="color: #212529">
                                                0
                                            </div>
                                            <div v-if="item1.homeT.sbst != 0 && item1.homeT.sbst != null" class="detail" :id="item1.home_tooltip.sbstKey" style="color: #212529">
                                                {{item1.homeT.sbst}}
                                            </div>
                                            <b-tooltip v-if="item1.homeT.yel != 0 && item1.homeT.yel != null" :target="item1.home_tooltip.sbstKey" triggers="hover">
                                                {{item1.home_tooltip.sbst}}
                                            </b-tooltip>
                                            <div class="detail" style="color: #212529; min-width: 37px; font-weight: bold">
                                                {{item1.homeT.nxt}}
                                            </div>
                                            <div class="detail" style="color: #212529; font-weight: bold">
                                                {{item1.homeT.rtg}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="detail_total column-last-10-wrapper" style="float: left;">
                                        <div class="column-last-10" style="color: black;">
                                            <div v-if="item1.home.on > 0 || item1.home.on < 0" class="detail1" :style="{'color': item1.home1.on}">
                                                {{item1.home.on}}
                                            </div>
                                            <div v-if="item1.home.on == 0" class="detail1" :style="{'color': item1.home1.on}">
                                                0
                                            </div>
                                            <div v-if="item1.home.on != 0 && item1.home.on == null" class="detail1" :style="{'color': item1.home1.on}">
                                                -
                                            </div>

                                            <div v-if="item1.home.off > 0 || item1.home.off < 0" class="detail1" :style="{'color': item1.home1.off}">
                                                {{item1.home.off}}
                                            </div>
                                            <div v-if="item1.home.off == 0" class="detail1" :style="{'color': item1.home1.off}">
                                                {{item1.home.off}}
                                            </div>
                                            <div v-if="item1.home.off != 0 && item1.home.off == null" class="detail1" :style="{'color': item1.home1.off}">
                                                -
                                            </div>

                                            <div v-if="item1.home.blk > 0" class="detail1" :style="{'color': item1.home1.blk}">
                                                {{item1.home.blk}}
                                            </div>
                                            <div v-if="(item1.home.blk == 0 && item1.away.blk != 0)" class="detail1" :style="{'color': item1.home1.blk}">
                                                {{item1.home.blk}}
                                            </div>
                                            <div v-if="(item1.home.blk == 0 && item1.away.blk == 0)" class="detail1" :style="{'color': item1.home1.blk}">
                                                -
                                            </div>
                                            <div v-if="item1.home.blk != 0 && item1.home.blk == null" class="detail1" :style="{'color': item1.home1.blk}">
                                                -
                                            </div>

                                            <div v-if="item1.home.in > 0 || item1.home.in < 0" class="detail1" :style="{'color': item1.home1.in}">
                                                {{item1.home.in}}
                                            </div>
                                            <div v-if="item1.home.in == 0" class="detail1" :style="{'color': item1.home1.in}">
                                                {{item1.home.in}}
                                            </div>
                                            <div v-if="item1.home.in != 0 && item1.home.in == null" class="detail1" :style="{'color': item1.home1.in}">
                                                -
                                            </div>

                                            <div v-if="item1.home.out > 0 || item1.home.out < 0" class="detail1" :style="{'color': item1.home1.out}">
                                                {{item1.home.out}}
                                            </div>
                                            <div v-if="item1.home.out == 0" class="detail1" :style="{'color': item1.home1.out}">
                                                {{item1.home.out}}
                                            </div>
                                            <div v-if="item1.home.out != 0 && item1.home.out == null" class="detail1" :style="{'color': item1.home1.out}">
                                                -
                                            </div>

                                            <div v-if="item1.home.cnr > 0 || item1.home.cnr < 0" class="detail1" :style="{'color': item1.home1.cnr}">
                                                {{item1.home.cnr}}
                                            </div>
                                            <div v-if="item1.home.cnr == 0" class="detail1" :style="{'color': item1.home1.cnr}">
                                                {{item1.home.cnr}}
                                            </div>
                                            <div v-if="item1.home.cnr != 0 && item1.home.cnr == null" class="detail1" :style="{'color': item1.home1.cnr}">
                                                -
                                            </div>

                                            <div v-if="item1.home.da > 0 || item1.home.da < 0" class="detail1" :style="{'color': item1.home1.da}">
                                                {{item1.home.da}}
                                            </div>
                                            <div v-if="item1.home.da == 0" class="detail1" :style="{'color': item1.home1.da}">
                                                {{item1.home.da}}
                                            </div>
                                            <div v-if="item1.home.da != 0 && item1.home.da == null" class="detail1" :style="{'color': item1.home1.da}">
                                                -
                                            </div>

                                            <div v-if="item1.home.poss > 0 || item1.home.poss < 0" class="detail1" :style="{'color': item1.home1.poss}">
                                                {{item1.home.poss}}
                                            </div>
                                            <div v-if="item1.home.poss == 0" class="detail1" :style="{'color': item1.home1.poss}">
                                                0
                                            </div>
                                            <div v-if="item1.home.poss != 0 && item1.home.poss == null" class="detail1" :style="{'color': item1.home1.poss}">
                                                -
                                            </div>

                                            <div v-if="item1.home.sbst > 0 || item1.home.sbst < 0" class="detail1" style="color: black">
                                                {{item1.home.sbst}}
                                            </div>
                                            <div v-if="item1.home.sbst == 0" class="detail1" style="color: black">
                                                {{item1.home.sbst}}
                                            </div>
                                            <div v-if="item1.home.sbst != 0 && item1.home.sbst == null" class="detail1" style="color: black">
                                                -
                                            </div>

                                            <div v-if="item1.home.goal > 0 || item1.home.goal < 0" class="detail1" style="color: black; min-width: 36px;">
                                                {{item1.home.goal}}
                                            </div>
                                            <div v-if="item1.home.goal == 0" class="detail1" style="color: black; min-width: 36px;">
                                                {{item1.home.goal}}
                                            </div>
                                            <div v-if="item1.home.goal != 0 && item1.home.goal == null" class="detail1" style="color: black;  min-width: 36px;">
                                                -
                                            </div>

                                            <div v-if="item1.home.rtg > item1.home.a_rtg" class="detail1" style="color: #263043; font-weight: bold; background: #d4edda;">
                                                {{item1.home.rtg}}
                                            </div>
                                            <div v-else class="detail1" style="color: #263043; font-weight: bold;">
                                                {{item1.home.rtg}}
                                            </div>
                                        </div>
                                    </div>
                                    <div style="width: 19%; float: left; height: 80px;border-left: 1px solid #e2e2e2;">
                                        <div class="column-odds" style="width: 100%; padding: 3px 7px; ">
                                            <div class="column-odds-left" style="width: 45%; float: left;">
                                                <div>
                                                    <div v-if="item1.homeT.homewin_stat_green" style="height: 16px; margin-bottom: 2px; margin-top: 2px;">
                                                        1: <label class="Odds-label" style="margin-left: 1.5px;">{{item1.homeT.homeodds}}</label><label class='green-label' :id="item1.home.id + '-' +  item1.away.id + 'hw'">{{item1.homeT.homewin_stat}}</label>
                                                    </div>
                                                    <div v-else style="height: 16px; margin-bottom: 2px; margin-top: 2px;">
                                                        1: <label class="Odds-label" style="margin-left: 1.5px;">{{item1.homeT.homeodds}}</label><label style='padding-left: 5px'  :id="item1.home.id + '-' +  item1.away.id + 'hw'">{{item1.homeT.homewin_stat}}</label>
                                                    </div>
                                                    
                                                    
                                                    <b-tooltip v-if="item1.homeT.homewin_stat_tooltip_1" :target="item1.home.id + '-' +  item1.away.id + 'hw'" triggers="hover">
                                                        <span>True Odds: {{item1.homeT.homewin_stat_tooltip_1}}</span><br>
                                                        <span>Value: {{item1.homeT.homewin_stat_tooltip_2}}%</span>
                                                        
                                                    </b-tooltip>
                                                    <div v-if="item1.homeT.drawwin_stat_green" style="height: 16px; margin-bottom: 2px;">
                                                        X: <label class="Odds-label">{{item1.homeT.drawodds}}</label><label class='green-label' :id="item1.home.id + '-' +  item1.away.id + 'dw'">{{item1.homeT.drawwin_stat}}</label>
                                                    </div>
                                                    <div v-else style="height: 16px; margin-bottom: 2px;">
                                                        X: <label class="Odds-label">{{item1.homeT.drawodds}}</label><label :id="item1.home.id + '-' +  item1.away.id + 'dw'" style='padding-left: 5px'>{{item1.homeT.drawwin_stat}}</label>
                                                    </div>
                                                    <b-tooltip v-if="item1.homeT.drawwin_stat_tooltip_1" :target="item1.home.id + '-' +  item1.away.id + 'dw'" triggers="hover">
                                                        <span>True Odds: {{item1.homeT.drawwin_stat_tooltip_1}}</span><br>
                                                        <span>Value: {{item1.homeT.drawwin_stat_tooltip_2}}%</span>
                                                        
                                                    </b-tooltip>
                                                    <div v-if="item1.homeT.awaywin_stat_green"  style="height: 16px;">
                                                        2: <label class="Odds-label" style="margin-left: 1px;">{{item1.homeT.awayodds}}</label><label class='green-label' :id="item1.home.id + '-awin' +  item1.away.id">{{item1.homeT.awaywin_stat}}</label>
                                                    </div>
                                                    <div v-else style="height: 16px;">
                                                        2: <label class="Odds-label" style="margin-left: 1px;">{{item1.homeT.awayodds}}</label><label :id="item1.home.id + '-awin' +  item1.away.id" style="padding-left: 5px">{{item1.homeT.awaywin_stat}}</label>
                                                    </div>
                                                    <b-tooltip v-if="item1.homeT.awaywin_stat_tooltip_1" :target="item1.home.id + '-awin' +  item1.away.id" triggers="hover">
                                                        <span>True Odds: {{item1.homeT.awaywin_stat_tooltip_1}}</span><br>
                                                        <span>Value: {{item1.homeT.awaywin_stat_tooltip_2}}%</span>
                                                    </b-tooltip>
                                                    <div style="height: 16px;">
                                                        {{ $t('Matches') }}: {{item1.homeT.number_of_matches}}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="column-odds-right">
                                                <div>
                                                    <div v-if="item1.homeT.over_odds[0]['mark']" style="height: 16px; margin-bottom: 2px; margin-top: 2px;">
                                                        O {{item1.homeT.over_odds[0]['mark']}}: <label class="Odds-label">{{item1.homeT.over_odds[0]['value']}}</label>
                                                        
                                                            <label v-bind:class="[item1.homeT.goal_1_plus_green ? 'green-label' : 'stats-label']" :id="item1.home.id + 'o05' + item1.away.id">
                                                                {{item1.homeT.goal_1_plus}}
                                                                
                                                            </label>
                                                            <b-tooltip v-if="item1.homeT.goal_1_plus_tooltip_1" :target="item1.home.id + 'o05' +  item1.away.id " triggers="hover">
                                                                <span>True Odds: {{item1.homeT.goal_1_plus_tooltip_1}}</span><br>
                                                                <span>Value: {{item1.homeT.goal_1_plus_tooltip_2}}%</span>
                                                            </b-tooltip>
                                                    
                                                    </div>
                                                    <!-- <div v-else style="height: 16px; margin-bottom: 2px; margin-top: 2px;">
                                                        O x.x: <label class="Odds-label"></label>
                                                    </div> -->
                                                    <div v-if="item1.homeT.under_odds[0]['mark']" style="height: 16px;">
                                                        U {{item1.homeT.under_odds[0]['mark']}}: <label class="Odds-label">{{item1.homeT.under_odds[0]['value']}}</label>

                                                        <label v-bind:class="[item1.homeT.goal_1_minus_green ? 'green-label' : 'stats-label']" :id="item1.home.id + 'u05' + item1.away.id">{{item1.homeT.goal_1_minus}}</label>
                                                        <b-tooltip v-if="item1.homeT.goal_1_minus_tooltip_1" :target="item1.home.id + 'u05' +  item1.away.id " triggers="hover">
                                                            <span>True Odds: {{item1.homeT.goal_1_minus_tooltip_1}}</span><br>
                                                            <span>Value: {{item1.homeT.goal_1_minus_tooltip_2}}%</span>
                                                        </b-tooltip>
                                                    </div>
                                                    <!-- <div v-else style="height: 16px; margin-bottom: 2px; margin-top: 2px;">
                                                        U x.x: <label class="Odds-label"></label>
                                                    </div> -->
                                                    <div v-if="item1.homeT.over_odds[1]['mark']" style="height: 16px; margin-bottom: 2px; margin-top: 2px;">
                                                        O {{item1.homeT.over_odds[1]['mark']}}: <label class="Odds-label">{{item1.homeT.over_odds[1]['value']}}</label>
                                                        <label v-bind:class="[item1.homeT.goal_2_plus_green ? 'green-label' : 'stats-label']" :id="item1.home.id + 'o15' + item1.away.id">{{item1.homeT.goal_2_plus}}</label>
                                                        <b-tooltip v-if="item1.homeT.goal_2_plus_tooltip_1" :target="item1.home.id + 'o15' +  item1.away.id " triggers="hover">
                                                            <span>True Odds: {{item1.homeT.goal_2_plus_tooltip_1}}</span><br>
                                                            <span>Value: {{item1.homeT.goal_2_plus_tooltip_2}}%</span>
                                                        </b-tooltip>
                                                    </div>
                                                    <!-- <div v-else style="height: 16px; margin-bottom: 2px; margin-top: 2px;">
                                                        O x.x: <label class="Odds-label"></label>
                                                    </div> -->
                                                    <div v-if="item1.homeT.under_odds[1]['mark']" style="height: 16px;">
                                                        U {{item1.homeT.under_odds[1]['mark']}}: <label class="Odds-label">{{item1.homeT.under_odds[1]['value']}}</label>
                                                        <label v-bind:class="[item1.homeT.goal_2_minus_green ? 'green-label' : 'stats-label']" :id="item1.home.id + 'u15' + item1.away.id">{{item1.homeT.goal_2_minus}}</label>
                                                        <b-tooltip v-if="item1.homeT.goal_2_minus_tooltip_1" :target="item1.home.id + 'u15' +  item1.away.id " triggers="hover">
                                                            <span>True Odds: {{item1.homeT.goal_2_minus_tooltip_1}}</span><br>
                                                            <span>Value: {{item1.homeT.goal_2_minus_tooltip_2}}%</span>
                                                        </b-tooltip>
                                                    </div>
                                                    <!-- <div v-else style="height: 16px; margin-bottom: 2px; margin-top: 2px;">
                                                        U x.x: <label class="Odds-label"></label>
                                                    </div> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="column-next-goal">

                                        <div class="column-next-goal-content">
                                            <div style="height: 16px; margin-bottom: 2px; margin-top: 2px;">
                                                H:<label>{{item1.homeT.goalnexthome}}</label>
                                            </div>
                                            <div style="height: 16px;">
                                                A:<label class="" style="margin-left: 1px;">{{item1.homeT.goalnextaway}}</label>
                                            </div>
                                            <div style="height: 16px; margin-bottom: 2px;">
                                                N:<label class="">{{item1.homeT.goalnextdraw}}</label>
                                            </div>
                                            
                                        </div>
                                    </div>

                                    <div class="column-gb-percent">
                                        <div>
                                            <div v-if="item1.homeT.goalyes.length > 0"  style="text-align: center;">
                                                <label>{{item1.homeT.goalyes[0]['mark']}}</label>
                                            </div>
                                            <div v-if="item1.homeT.goalyes.length > 0"  style="text-align: center;">
                                            <label v-bind:class="[item1.homeT.goalyes[0].green ? 'green-label' : '']" :id="item1.home.id + '-goal_1-' + item1.away.id">{{item1.homeT.goalyes[0]['value']}}</label>

                                            <b-tooltip v-if="item1.homeT.goalyes[0].tooltip_1" :target="item1.home.id + '-goal_1-' +  item1.away.id " triggers="hover">
                                                    <span>True Odds: {{item1.homeT.goalyes[0].tooltip_1}}</span><br>
                                                    <span>Value: {{item1.homeT.goalyes[0].tooltip_2}}%</span>
                                                </b-tooltip>
                                            </div>
                                            <div v-if="item1.homeT.goalyes.length > 1"  style="text-align: center;">
                                                <label>{{item1.homeT.goalyes[1]['mark']}}</label>
                                            </div>
                                            <div v-if="item1.homeT.goalyes.length > 1"  style="text-align: center;">
                                            <label v-bind:class="[item1.homeT.goalyes[1].green ? 'green-label' : '']" :id="item1.home.id + '-goal_2-' + item1.away.id">{{item1.homeT.goalyes[1]['value']}}</label>
                                            <b-tooltip v-if="item1.homeT.goalyes[1].tooltip_1" :target="item1.home.id + '-goal_2-' +  item1.away.id " triggers="hover">
                                                    <span>True Odds: {{item1.homeT.goalyes[1].tooltip_1}}</span><br>
                                                    <span>Value: {{item1.homeT.goalyes[1].tooltip_2}}%</span>
                                                </b-tooltip>
                                            </div> 
                                        </div>
                                    </div>


                                    
                                    <!--  away team data part  Total (League Column third-line) -->
                                    <!-- <div style="width: 15%; height: 30px; position: absolute; top: 45px;">
                                        <div style="width: 50px; float: left; color: white;">.</div>
                                        <div v-if="item1.away.flash == 1" class="goal_manner" style="width: calc(100% - 65px); float: left;">{{item1.main_data.away_name}} <span v-if="item1.stage_has_standings">({{item1.main_data.away_rank}})</span></div>
                                        <div v-else style="width: calc(100% - 65px); float: left;">{{item1.main_data.away_name}} <span v-if="item1.stage_has_standings">({{item1.main_data.away_rank}})</span></div>
                                    </div> -->
                                    <!-- <div style="width: 4%; height: 30px; float: left; border-left: 1px solid #e2e2e2;">
                                        <div style="width: 100%; padding: 3px 7px; color: black;">
                                            <transition name="slide-fade" mode="out-in" class="livenow">
                                            </transition>
                                        </div>
                                    </div> -->
                                    <div class="detail_total column-total-game-wrapper" style="top: 40px; left: 19%; position: absolute;">
                                        <div class="column-total-game" style="color: black;">
                                            <div v-if="item1.awayT.on == 0"  class="detail" style="color: #212529;">
                                                {{item1.awayT.on}}
                                            </div>
                                            <div :key="item1.away_tooltip.onKey" :id="item1.away_tooltip.onKey"  v-if="item1.awayT.on > 0" class="detail" style="color: #212529;">
                                                {{item1.awayT.on}}
                                            </div>
                                            <b-tooltip v-if="item1.awayT.on > 0" :key="item1.away_tooltip.onKey + '1'" :target="item1.away_tooltip.onKey" triggers="hover">
                                                {{item1.away_tooltip.on}}
                                            </b-tooltip>

                                            <div v-if="item1.awayT.off == 0" class="detail" style="color: #212529">
                                                {{item1.awayT.off}}
                                            </div>
                                            <div :key="item1.away_tooltip.offKey" :id="item1.away_tooltip.offKey"  v-if="item1.awayT.off > 0" class="detail" style="color: #212529;">
                                                {{item1.awayT.off}}
                                            </div>
                                            <b-tooltip v-if="item1.awayT.off > 0" :key="item1.away_tooltip.offKey + '1'" :target="item1.away_tooltip.offKey" triggers="hover">
                                                {{item1.away_tooltip.off}}
                                            </b-tooltip>

                                            <div :key="item1.away_tooltip.blkKey" :id="item1.away_tooltip.blkKey"  v-if="item1.awayT.blk > 0" class="detail" style="color: #212529;">
                                                {{item1.awayT.blk}}
                                            </div>
                                            <b-tooltip v-if="item1.awayT.blk > 0" :key="item1.away_tooltip.blkKey + '1'" :target="item1.away_tooltip.blkKey" triggers="hover">
                                                {{item1.away_tooltip.blk}}
                                            </b-tooltip>

                                            <div v-if="item1.awayT.blk == 0 && item1.homeT.blk != 0" class="detail" style="color: #212529">
                                                {{item1.awayT.blk}}
                                            </div>

                                            <div v-if="item1.awayT.blk == null || (item1.awayT.blk == 0 && item1.homeT.blk == 0)" class="detail" style="color: #212529">
                                                -
                                            </div>

                                            <div v-if="item1.awayT.in == 0" class="detail" style="color: #212529">
                                                {{item1.awayT.in}}
                                            </div>
                                            <div :key="item1.away_tooltip.inKey" :id="item1.away_tooltip.inKey"  v-if="item1.awayT.in > 0" class="detail" style="color: #212529;">
                                                {{item1.awayT.in}}
                                            </div>
                                            <b-tooltip v-if="item1.awayT.in > 0" :key="item1.away_tooltip.inKey + '1'" :target="item1.away_tooltip.inKey" triggers="hover">
                                                {{item1.away_tooltip.in}}
                                            </b-tooltip>

                                            <div v-if="item1.awayT.in == null" class="detail" style="color: #212529">
                                                -
                                            </div>

                                            <div v-if="item1.awayT.out == 0" class="detail" style="color: #212529">
                                                {{item1.awayT.out}}
                                            </div>
                                            <div :key="item1.away_tooltip.outKey" :id="item1.away_tooltip.outKey"  v-if="item1.awayT.out > 0" class="detail" style="color: #212529;">
                                                {{item1.awayT.out}}
                                            </div>
                                            <b-tooltip v-if="item1.awayT.out > 0" :key="item1.away_tooltip.outKey + '1'" :target="item1.away_tooltip.outKey" triggers="hover">
                                                {{item1.away_tooltip.out}}
                                            </b-tooltip>

                                            <div v-if="item1.awayT.out == null" class="detail" style="color: #212529">
                                                -
                                            </div>

                                            <div v-if="item1.awayT.cnr == 0" class="detail" style="color: #212529">
                                                {{item1.awayT.cnr}}
                                            </div>
                                            <div :key="item1.away_tooltip.cnrKey" :id="item1.away_tooltip.cnrKey"  v-if="item1.awayT.cnr > 0" class="detail" style="color: #212529;">
                                                {{item1.awayT.cnr}}
                                            </div>
                                            <b-tooltip v-if="item1.awayT.cnr > 0" :key="item1.away_tooltip.cnrKey + '1'" :target="item1.away_tooltip.cnrKey" triggers="hover">
                                                {{item1.away_tooltip.cnr}}
                                            </b-tooltip>

                                            <div v-if="item1.awayT.cnr == null" class="detail" style="color: #212529">
                                                -
                                            </div>

                                            <div v-if="item1.awayT.da == 0" class="detail" style="color: #212529">
                                                {{item1.awayT.da}}
                                            </div>

                                            <div v-if="item1.awayT.da > 0" class="detail" style="color: #212529">
                                                {{item1.awayT.da}}
                                            </div>

                                            <div v-if="item1.awayT.poss == null" class="detail" style="color: #212529">
                                                -
                                            </div>

                                            <div v-if="item1.awayT.poss == 0" class="detail" style="color: #212529">
                                                0
                                            </div>

                                            <div v-if="item1.awayT.poss != 0 && item1.awayT.poss != null" class="detail" style="color: #212529">
                                                {{item1.awayT.poss}}
                                            </div>

                                            <div v-if="item1.awayT.red == null" class="detail" style="color: #212529">
                                                -
                                            </div>

                                            <div v-if="item1.awayT.red == 0" class="detail" style="color: #212529">
                                                0
                                            </div>

                                            <div v-if="item1.awayT.red > 0" class="detail" :id="item1.away_tooltip.redKey" style="color: #212529; background-color: red;">
                                                {{item1.awayT.red}}
                                            </div>

                                            <b-tooltip v-if="item1.awayT.red > 0" :target="item1.away_tooltip.redKey" triggers="hover">
                                                {{item1.away_tooltip.red}}
                                            </b-tooltip>

                                            <div v-if="item1.awayT.yel == null" class="detail" style="color: #212529">
                                                -
                                            </div>

                                            <div v-if="item1.awayT.yel == 0" class="detail" style="color: #212529">
                                                0
                                            </div>

                                            <div v-if="item1.awayT.yel > 0" class="detail" :id="item1.away_tooltip.yelKey" style="color: #212529">
                                                {{item1.awayT.yel}}
                                            </div>

                                            <b-tooltip v-if="item1.awayT.yel > 0" :target="item1.away_tooltip.yelKey" triggers="hover">
                                                {{item1.away_tooltip.yel}}
                                            </b-tooltip>

                                            <div v-if="item1.awayT.sbst == null" class="detail" style="color: #212529">
                                                -
                                            </div>

                                            <div v-if="item1.awayT.sbst == 0" class="detail" style="color: #212529">
                                                0
                                            </div>

                                            <div v-if="item1.awayT.sbst > 0" class="detail" :id="item1.away_tooltip.sbstKey" style="color: #212529">
                                                {{item1.awayT.sbst}}
                                            </div>

                                            <b-tooltip v-if="item1.awayT.sbst > 0" :target="item1.away_tooltip.sbstKey" triggers="hover">
                                                {{item1.away_tooltip.sbst}}
                                            </b-tooltip>
                                            <div class="detail" style="color: #212529; min-width: 37px; font-weight: bold">
                                                {{item1.awayT.nxt}}
                                            </div>
                                            <div class="detail" style="color: #212529; font-weight: bold">
                                                {{item1.awayT.rtg}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="detail_total column-last-10-wrapper" style="position: absolute; left: 48%; top: 40px;">
                                        <div class="column-last-10" style="color: black;">
                                            <div v-if="item1.away.on > 0" class="detail1" :style="{'color': item1.away1.on}">
                                                {{item1.away.on}}
                                            </div>
                                            <div v-if="item1.away.on == 0" class="detail1" :style="{'color': item1.away1.on}">
                                                0
                                            </div>
                                            <div v-if="item1.away.on != 0 && item1.away.on == null" class="detail1" :style="{'color': item1.away1.on}">
                                                -
                                            </div>

                                            <div v-if="item1.away.off > 0" class="detail1" :style="{'color': item1.away1.off}">
                                                {{item1.away.off}}
                                            </div>
                                            <div v-if="item1.away.off == 0" class="detail1" :style="{'color': item1.away1.off}">
                                                {{item1.away.off}}
                                            </div>
                                            <div v-if="item1.away.off != 0 && item1.away.off == null" class="detail1" :style="{'color': item1.away1.off}">
                                                -
                                            </div>

                                            <div v-if="item1.away.blk > 0" class="detail1" :style="{'color': item1.away1.blk}">
                                                {{item1.away.blk}}
                                            </div>
                                            <div v-if="(item1.away.blk == 0 && item1.home.blk != 0)" class="detail1" :style="{'color': item1.away1.blk}">
                                                {{item1.away.blk}}
                                            </div>
                                            <div v-if="(item1.away.blk == 0 && item1.home.blk == 0)" class="detail1" :style="{'color': item1.away1.blk}">
                                                -
                                            </div>
                                            <div v-if="item1.away.blk != 0 && item1.away.blk == null" class="detail1" :style="{'color': item1.away1.blk}">
                                                -
                                            </div>

                                            <div v-if="item1.away.in > 0" class="detail1" :style="{'color': item1.away1.in}">
                                                {{item1.away.in}}
                                            </div>
                                            <div v-if="item1.away.in == 0" class="detail1" :style="{'color': item1.away1.in}">
                                                {{item1.away.in}}
                                            </div>
                                            <div v-if="item1.away.in != 0 && item1.away.in == null" class="detail1" :style="{'color': item1.away1.in}">
                                                -
                                            </div>

                                            <div v-if="item1.away.out > 0" class="detail1" :style="{'color': item1.away1.out}">
                                                {{item1.away.out}}
                                            </div>
                                            <div v-if="item1.away.out == 0" class="detail1" :style="{'color': item1.away1.out}">
                                                {{item1.away.out}}
                                            </div>
                                            <div v-if="item1.away.out != 0 && item1.away.out == null" class="detail1" :style="{'color': item1.away1.out}">
                                                -
                                            </div>

                                            <div v-if="item1.away.cnr > 0 || item1.away.cnr < 0" class="detail1" :style="{'color': item1.away1.cnr}">
                                                {{item1.away.cnr}}
                                            </div>
                                            <div v-if="item1.away.cnr == 0" class="detail1" :style="{'color': item1.away1.cnr}">
                                                {{item1.away.cnr}}
                                            </div>
                                            <div v-if="item1.away.cnr != 0 && item1.away.cnr == null" class="detail1" :style="{'color': item1.away1.cnr}">
                                                -
                                            </div>

                                            <div v-if="item1.away.da > 0 || item1.away.da < 0" class="detail1" :style="{'color': item1.away1.da}">
                                                {{item1.away.da}}
                                            </div>
                                            <div v-if="item1.away.da == 0" class="detail1" :style="{'color': item1.away1.da}">
                                                {{item1.away.da}}
                                            </div>
                                            <div v-if="item1.away.da != 0 && item1.away.da == null" class="detail1" :style="{'color': item1.away1.da}">
                                                -
                                            </div>

                                            <div v-if="item1.away.poss > 0 || item1.away.poss < 0" class="detail1" :style="{'color': item1.away1.poss}">
                                                {{item1.away.poss}}
                                            </div>
                                            <div v-if="item1.away.poss == 0" class="detail1" :style="{'color': item1.away1.poss}">
                                                0
                                            </div>
                                            <div v-if="item1.away.poss != 0 && item1.away.poss == null" class="detail1" :style="{'color': item1.away1.poss}">
                                                -
                                            </div>

                                            <div v-if="item1.away.sbst > 0 || item1.away.sbst < 0" class="detail1" style="color: black">
                                                {{item1.away.sbst}}
                                            </div>
                                            <div v-if="item1.away.sbst == 0" class="detail1" style="color: black">
                                                {{item1.away.sbst}}
                                            </div>
                                            <div v-if="item1.away.sbst != 0 && item1.away.sbst == null" class="detail1" style="color: black">
                                                -
                                            </div>

                                            <div v-if="item1.away.goal > 0 || item1.away.goal < 0" class="detail1" style="color: black; min-width: 36px;">
                                                {{item1.away.goal}}
                                            </div>
                                            <div v-if="item1.away.goal == 0" class="detail1" style="color: black; min-width: 36px;">
                                                {{item1.away.goal}}
                                            </div>
                                            <div v-if="item1.away.goal != 0 && item1.away.goal == null" class="detail1" style="color: black;  min-width: 36px;">
                                                -
                                            </div>

                                            <div v-if="item1.away.rtg > item1.away.a_rtg" class="detail1" style="color: #263043; font-weight: bold; background: #d4edda;">
                                                {{item1.away.rtg}}
                                            </div>
                                            <div v-else class="detail1" style="color: #263043; font-weight: bold;">
                                                {{item1.away.rtg}}
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div style="width: 20%; height: 30px; float: left; border-left: 1px solid #e2e2e2;">
                                        <div style="width: 100%; padding: 3px 7px; color: white;">
                                            ...
                                        </div>
                                    </div> -->
                                    
                                    <!--  home team data part  last 10 minutes-->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="last-update-bottom-bar">
                        <div>
                            <label style="float:left; font-weight: bold; margin-right: 10px;">{{ $t('Last Updated') }}: </label> <div style="float: left; background: #17a2b8; color: white; width: 60px; text-align: center; font-weight: bold;">{{last_updated_time}}</div>
                        </div>
                    </div>

                    <CCol sm="4" style = "position:fixed; bottom: 0;">
                        <CButton
                            color="info"
                            class="m-2 save_match_data"
                            @click="save_live"
                        >
                            {{ $t("Save to My Game") }}
                        </CButton>

                        <CButton v-if="advanced_search" class="m-2 save_match_data" @click="showSearch" style="background-color: red; color: white;">{{ $t("Hide search") }}</CButton>
                        <CButton v-else-if="apply_filter" class="m-2 save_match_data" color="info" @click="showSearch">{{ $t("Edit Filter") }}</CButton>
                        <CButton v-else class="m-2 save_match_data" color="info" @click="showSearch">{{ $t("Advanced search") }}</CButton>

                    </CCol>

                </CTab>
                
                <CTab @click.native="finished_tab()" :title="$t('Finished Games') + '('+finishedLength+')'">
                    <div class="tab-pane-wrapper">
                        <div style="min-width: 756px;">
                            <div v-for="item in finishedArray" class="finished-tab">
                                <div v-if="item.events.length > 0 && item.league"  class="header" style="width: auto; height: 50px;">
                                    <div class="header-content" style="width: 30%; height: 50px; float: left; text-align: left;">
                                        {{item.league}}
                                    </div>
                                    <div class="header-content" style="width: 55%; height: 50px; float: left; border-left: 1px solid whitesmoke">
                                        Total Game
                                        <div style="width: 100%">
                                            <div :id="item.league_id + '-FINISHED-TOTAL-On'" class="detail">
                                                On
                                            </div>
                                            <div :id="item.league_id + '-FINISHED-TOTAL-Off'" class="detail">
                                                Off
                                            </div>
                                            <div :id="item.league_id + '-FINISHED-TOTAL-Blk'" class="detail">
                                                Blk
                                            </div>
                                            <div :id="item.league_id + '-FINISHED-TOTAL-In'" class="detail">
                                                In
                                            </div>
                                            <div :id="item.league_id + '-FINISHED-TOTAL-Out'" class="detail">
                                                Out
                                            </div>
                                            <div :id="item.league_id + '-FINISHED-TOTAL-Cnr'" class="detail">
                                                Cnr
                                            </div>
                                            <div :id="item.league_id + '-FINISHED-TOTAL-DA'" class="detail">
                                                DA
                                            </div>
                                            <div :id="item.league_id + '-FINISHED-TOTAL-Poss'" class="detail">
                                                Poss
                                            </div>
                                            <div :id="item.league_id + '-FINISHED-TOTAL-Red'" class="detail">
                                                Red
                                            </div>
                                            <div :id="item.league_id + '-FINISHED-TOTAL-Yel'" class="detail">
                                                Yel
                                            </div>
                                            <div :id="item.league_id + '-FINISHED-TOTAL-Sbst'" class="detail">
                                                Sbst
                                            </div>
                                            <div :id="item.league_id + '-FINISHED-TOTAL-NXT'" class="detail" style="min-width: 37px;">
                                                NXT%
                                            </div>
                                            <div :id="item.league_id + '-FINISHED-TOTAL-PFM'" class="detail" style="width: 4%;">
                                                PFM
                                            </div>
                                        </div>
                                        <b-tooltip :target="item.league_id + '-FINISHED-TOTAL-On'" triggers="hover">
                                            <span>{{ $t(' On ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-FINISHED-TOTAL-Off'" triggers="hover">
                                            <span>{{ $t(' Off ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-FINISHED-TOTAL-Blk'" triggers="hover">
                                            <span>{{ $t(' Blk ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-FINISHED-TOTAL-In'" triggers="hover">
                                            <span>{{ $t(' In ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-FINISHED-TOTAL-Out'" triggers="hover">
                                            <span>{{ $t(' Out ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-FINISHED-TOTAL-Cnr'" triggers="hover">
                                            <span>{{ $t(' Cnr ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-FINISHED-TOTAL-DA'" triggers="hover">
                                            <span>{{ $t(' DA ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-FINISHED-TOTAL-Poss'" triggers="hover">
                                            <span>{{ $t(' Poss ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-FINISHED-TOTAL-Red'" triggers="hover">
                                            <span>{{ $t(' Red ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-FINISHED-TOTAL-Yel'" triggers="hover">
                                            <span>{{ $t(' Yel ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-FINISHED-TOTAL-Sbst'" triggers="hover">
                                            <span>{{ $t(' Sbst ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-FINISHED-TOTAL-NXT'" triggers="hover">
                                            <span>{{ $t(' Ini ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip :target="item.league_id + '-FINISHED-TOTAL-PFM'" triggers="hover">
                                            <span>{{ $t(' PFM ') }}</span>
                                        </b-tooltip>
                                    </div>
                                    <div class="header-content" style="width: 15%; height: 50px; float: left; border-left: 1px solid whitesmoke">
                                        <p style="text-align: center;">Cards</p>
                                        <img src="/img/box-yellow.png" width="20px;" style="position: relative; top: -15px; left: -20%;"/>
                                        <img src="/img/box-red.png" width="20px;" style="position: relative; top: -15px; left: 20%"/>
                                    </div>
                                </div>
                                <div v-for="item1 in item.events" class="content" style="width: auto; height: 80px; font-weight: 600;">
                                    <!--                             home team data part  -->

                                    <div style="width: 30%; height: 31px; float: left;">
                                        <div style="width: 40px; float: left;position: relative; top:  16px; left: 15px; font-size: 17px; font-weight: normal">{{item1.status}}</div>
                                        <div style="width: calc(100% - 90px); float: left;">{{item1.home_name}}</div>
                                        <img v-b-modal.modal-center src="/img/info_icon.png" @click="callHistoricalData(item1.home.id, item1.away.id, item1.season_id, item1.main_data.home_name + ' v ' + item1.main_data.away_name, item1.home.rtg, item1.home.a_rtg, item1.away.rtg, item1.away.a_rtg, item1.main_data._id)" width="13px;" style="width: 20px; cursor: pointer; outline: none; position: relative; top: 20px; left: -36px"/>
                                    </div>
                                    <div style="width: 55%; height: 31px; float: left; border-left: 1px solid #e2e2e2;">
                                        <div style="width: 100%; padding: 3px 7px; color: #212529;">
                                            <div v-if="item1.homeT.on == 0" class="detail" style="color: #212529;">
                                                0
                                            </div>
                                            <div :key="item1.home_tooltip.onKey" :id="item1.home_tooltip.onKey"  v-if="item1.homeT.on > 0" class="detail" style="color: #212529;">
                                                {{item1.homeT.on}}
                                            </div>
                                            <b-tooltip v-if="item1.home_tooltip.on != ''" :key="item1.home_tooltip.onKey + '1'" :target="item1.home_tooltip.onKey" triggers="hover">
                                                {{item1.home_tooltip.on}}
                                            </b-tooltip>

                                            <div v-if="item1.homeT.off == 0" class="detail" style="color: #212529">
                                                {{item1.homeT.off}}
                                            </div>
                                            <div :key="item1.home_tooltip.offKey" :id="item1.home_tooltip.offKey"  v-if="item1.homeT.off > 0" class="detail" style="color: #212529;">
                                                {{item1.homeT.off}}
                                            </div>
                                            <b-tooltip v-if="item1.home_tooltip.off != ''" :key="item1.home_tooltip.offKey + '1'" :target="item1.home_tooltip.offKey" triggers="hover">
                                                {{item1.home_tooltip.off}}
                                            </b-tooltip>
                                            <div :key="item1.home_tooltip.blkKey" :id="item1.home_tooltip.blkKey"  v-if="item1.homeT.blk > 0" class="detail" style="color: #212529;">
                                                {{item1.homeT.blk}}
                                            </div>
                                            <b-tooltip v-if="item1.home_tooltip.blk != ''" :key="item1.home_tooltip.blkKey + '1'" :target="item1.home_tooltip.blkKey" triggers="hover">
                                                {{item1.home_tooltip.blk}}
                                            </b-tooltip>

                                            <div v-if="item1.homeT.blk == 0 && item1.awayT.blk != 0" class="detail" style="color: #212529">
                                                {{item1.homeT.blk}}
                                            </div>
                                            <div v-if="item1.homeT.blk == null || (item1.homeT.blk == 0 && item1.awayT.blk == 0)" class="detail" style="color: #212529">
                                                -
                                            </div>
                                            <div v-if="item1.homeT.in == 0" class="detail" style="color: #212529">
                                                {{item1.homeT.in}}
                                            </div>
                                            <div :key="item1.home_tooltip.inKey" :id="item1.home_tooltip.inKey"  v-if="item1.homeT.in > 0" class="detail" style="color: #212529;">
                                                {{item1.homeT.in}}
                                            </div>
                                            <b-tooltip v-if="item1.home_tooltip.in != ''" :key="item1.home_tooltip.inKey + '1'" :target="item1.home_tooltip.inKey" triggers="hover">
                                                {{item1.home_tooltip.in}}
                                            </b-tooltip>
                                            <div v-if="item1.homeT.in == null" class="detail" style="color: #212529">
                                                -
                                            </div>
                                            <div v-if="item1.homeT.out == 0" class="detail" style="color: #212529">
                                                {{item1.homeT.out}}
                                            </div>
                                            <div :key="item1.home_tooltip.outKey" :id="item1.home_tooltip.outKey"  v-if="item1.homeT.out > 0" class="detail" style="color: #212529;">
                                                {{item1.homeT.out}}
                                            </div>
                                            <b-tooltip v-if="item1.home_tooltip.out != ''" :key="item1.home_tooltip.outKey + '1'" :target="item1.home_tooltip.outKey" triggers="hover">
                                                {{item1.home_tooltip.out}}
                                            </b-tooltip>
                                            <div v-if="item1.homeT.out == null" class="detail" style="color: #212529">
                                                -
                                            </div>
                                            <div v-if="item1.homeT.cnr == 0" class="detail" style="color: #212529">
                                                {{item1.homeT.cnr}}
                                            </div>
                                            <div :key="item1.home_tooltip.cnrKey" :id="item1.home_tooltip.cnrKey"  v-if="item1.homeT.cnr > 0" class="detail" style="color: #212529;">
                                                {{item1.homeT.cnr}}
                                            </div>
                                            <b-tooltip v-if="item1.home_tooltip.cnr != ''" :key="item1.home_tooltip.cnrKey + '1'" :target="item1.home_tooltip.cnrKey" triggers="hover">
                                                {{item1.home_tooltip.cnr}}
                                            </b-tooltip>

                                            <div v-if="item1.homeT.cnr == null" class="detail" style="color: #212529">
                                                -
                                            </div>
                                            <div v-if="item1.homeT.da == 0" class="detail" style="color: #212529">
                                                {{item1.homeT.da}}
                                            </div>
                                            <div v-if="item1.homeT.da > 0" class="detail" style="color: #212529">
                                                {{item1.homeT.da}}
                                            </div>
                                            <div v-if="item1.homeT.poss == null" class="detail" style="color: #212529">
                                                -
                                            </div>
                                            <div v-if="item1.homeT.poss == 0" class="detail" style="color: #212529">
                                                {{item1.homeT.poss}}
                                            </div>
                                            <div v-if="item1.homeT.poss != 0 && item1.homeT.poss != null" class="detail" style="color: #212529">
                                                {{item1.homeT.poss}}
                                            </div>
                                            <div v-if="item1.homeT.red == null" class="detail" style="color: #212529">
                                                -
                                            </div>
                                            <div v-if="item1.homeT.red == 0" class="detail" style="color: #212529">
                                                0
                                            </div>
                                            <div v-if="item1.homeT.red != 0 && item1.homeT.red != null" class="detail" style="color: #212529">
                                                {{item1.homeT.red}}
                                            </div>
                                            <div v-if="item1.homeT.yel == null" class="detail" style="color: #212529">
                                                -
                                            </div>
                                            <div v-if="item1.homeT.yel == 0" class="detail" style="color: #212529">
                                                0
                                            </div>
                                            <div v-if="item1.homeT.yel != 0 && item1.homeT.yel != null" class="detail" style="color: #212529">
                                                {{item1.homeT.yel}}
                                            </div>
                                            <div v-if="item1.homeT.sbst == null" class="detail" style="color: #212529">
                                                -
                                            </div>
                                            <div v-if="item1.homeT.sbst == 0" class="detail" style="color: #212529">
                                                0
                                            </div>
                                            <div v-if="item1.homeT.sbst != 0 && item1.homeT.sbst != null" class="detail" style="color: #212529">
                                                {{item1.homeT.sbst}}
                                            </div>
                                            <div class="detail" style="color: #212529; min-width: 37px; font-weight: bold">
                                                {{item1.homeT.nxt}}
                                            </div>
                                            <div class="detail" style="color: #212529; font-weight: bold">
                                                {{item1.homeT.rtg}}
                                            </div>
                                        </div>
                                    </div>
                                    <div style="width: 15%; height: 31px; float: left; border-left: 1px solid #e2e2e2; border-right: 1px solid #e2e2e2; padding: 0px 10px; text-align: center;">
                                        <div class="detail" style="width: 50%; position: relative; left: -4px;">{{item1.homeT.yel}}</div>
                                        <div class="detail" style="width: 50%; position: relative; left: 3px;">{{item1.homeT.red}}</div>
                                    </div>
                                    <!--                             away team data part  -->
                                    <div style="width: 30%; height: 49px; float: left; padding-top: 10px; border-bottom: 1px solid lightgray">
                                        <div style="width: 40px; float: left; color: white;">.</div>
                                        <div style="width: calc(100% - 90px); float: left;">{{item1.away_name}}</div>
                                        <!--                                <div style="width: 30px; float: left; font-size: 17px; font-weight: 600; position: relative; top: -12px; left: -10px;">{{item1.home_score}} - {{item1.away_score}}</div>-->
                                        <div :key="item1.goalKey" v-c-tooltip="item1.goal_tooltip" class="detail" style="color: red; position: relative; top: -20px; left: -10px; font-size: 18px; width: 7%">
                                            {{item1.home_score}} - {{item1.away_score}}
                                        </div>
                                    </div>
                                    <div style="width: 55%; height: 49px; float: left; border-left: 1px solid #e2e2e2; padding-top: 10px; border-bottom: 1px solid lightgray">
                                        <div style="width: 100%; padding: 3px 7px; color: black;">
                                            <div v-if="item1.awayT.on == 0"  class="detail" style="color: #212529;">
                                                {{item1.awayT.on}}
                                            </div>
                                            <div :key="item1.away_tooltip.onKey" :id="item1.away_tooltip.onKey"  v-if="item1.awayT.on > 0" class="detail" style="color: #212529;">
                                                {{item1.awayT.on}}
                                            </div>
                                            <b-tooltip v-if="item1.away_tooltip.on != ''" :key="item1.away_tooltip.onKey + '1'" :target="item1.away_tooltip.onKey" triggers="hover">
                                                {{item1.away_tooltip.on}}
                                            </b-tooltip>

                                            <div v-if="item1.awayT.off == 0" class="detail" style="color: #212529">
                                                {{item1.awayT.off}}
                                            </div>
                                            <div :key="item1.away_tooltip.offKey" :id="item1.away_tooltip.offKey"  v-if="item1.awayT.off > 0" class="detail" style="color: #212529;">
                                                {{item1.awayT.off}}
                                            </div>
                                            <b-tooltip v-if="item1.away_tooltip.off != ''" :key="item1.away_tooltip.offKey + '1'" :target="item1.away_tooltip.offKey" triggers="hover">
                                                {{item1.away_tooltip.off}}
                                            </b-tooltip>

                                            <div :key="item1.away_tooltip.blkKey" :id="item1.away_tooltip.blkKey"  v-if="item1.awayT.blk > 0" class="detail" style="color: #212529;">
                                                {{item1.awayT.blk}}
                                            </div>
                                            <b-tooltip v-if="item1.away_tooltip.blk != ''" :key="item1.away_tooltip.blkKey + '1'" :target="item1.away_tooltip.blkKey" triggers="hover">
                                                {{item1.away_tooltip.blk}}
                                            </b-tooltip>

                                            <div v-if="item1.awayT.blk == 0 && item1.homeT.blk != 0" class="detail" style="color: #212529">
                                                {{item1.awayT.blk}}
                                            </div>

                                            <div v-if="item1.awayT.blk == null || (item1.awayT.blk == 0 && item1.homeT.blk == 0)" class="detail" style="color: #212529">
                                                -
                                            </div>

                                            <div v-if="item1.awayT.in == 0" class="detail" style="color: #212529">
                                                {{item1.awayT.in}}
                                            </div>
                                            <div :key="item1.away_tooltip.inKey" :id="item1.away_tooltip.inKey"  v-if="item1.awayT.in > 0" class="detail" style="color: #212529;">
                                                {{item1.awayT.in}}
                                            </div>
                                            <b-tooltip v-if="item1.away_tooltip.in != ''" :key="item1.away_tooltip.inKey + '1'" :target="item1.away_tooltip.inKey" triggers="hover">
                                                {{item1.away_tooltip.in}}
                                            </b-tooltip>

                                            <div v-if="item1.awayT.in == null" class="detail" style="color: #212529">
                                                -
                                            </div>

                                            <div v-if="item1.awayT.out == 0" class="detail" style="color: #212529">
                                                {{item1.awayT.out}}
                                            </div>
                                            <div :key="item1.away_tooltip.outKey" :id="item1.away_tooltip.outKey"  v-if="item1.awayT.out > 0" class="detail" style="color: #212529;">
                                                {{item1.awayT.out}}
                                            </div>
                                            <b-tooltip v-if="item1.away_tooltip.out != ''" :key="item1.away_tooltip.outKey + '1'" :target="item1.away_tooltip.outKey" triggers="hover">
                                                {{item1.away_tooltip.out}}
                                            </b-tooltip>

                                            <div v-if="item1.awayT.out == null" class="detail" style="color: #212529">
                                                -
                                            </div>

                                            <div v-if="item1.awayT.cnr == 0" class="detail" style="color: #212529">
                                                {{item1.awayT.cnr}}
                                            </div>
                                            <div :key="item1.away_tooltip.cnrKey" :id="item1.away_tooltip.cnrKey"  v-if="item1.awayT.cnr > 0" class="detail" style="color: #212529;">
                                                {{item1.awayT.cnr}}
                                            </div>
                                            <b-tooltip v-if="item1.away_tooltip.cnr != ''" :key="item1.away_tooltip.cnrKey + '1'" :target="item1.away_tooltip.cnrKey" triggers="hover">
                                                {{item1.away_tooltip.cnr}}
                                            </b-tooltip>

                                            <div v-if="item1.awayT.cnr == null" class="detail" style="color: #212529">
                                                -
                                            </div>

                                            <div v-if="item1.awayT.da == 0" class="detail" style="color: #212529">
                                                {{item1.awayT.da}}
                                            </div>

                                            <div v-if="item1.awayT.da > 0" class="detail" style="color: #212529">
                                                {{item1.awayT.da}}
                                            </div>

                                            <div v-if="item1.awayT.poss == null" class="detail" style="color: #212529">
                                                -
                                            </div>

                                            <div v-if="item1.awayT.poss == 0" class="detail" style="color: #212529">
                                                0
                                            </div>

                                            <div v-if="item1.awayT.poss != 0 && item1.awayT.poss != null" class="detail" style="color: #212529">
                                                {{item1.awayT.poss}}
                                            </div>

                                            <div v-if="item1.awayT.red == null" class="detail" style="color: #212529">
                                                -
                                            </div>

                                            <div v-if="item1.awayT.red == 0" class="detail" style="color: #212529">
                                                0
                                            </div>

                                            <div v-if="item1.awayT.red > 0" class="detail" style="color: #212529">
                                                {{item1.awayT.red}}
                                            </div>

                                            <div v-if="item1.awayT.yel == null" class="detail" style="color: #212529">
                                                -
                                            </div>

                                            <div v-if="item1.awayT.yel == 0" class="detail" style="color: #212529">
                                                0
                                            </div>

                                            <div v-if="item1.awayT.yel > 0" class="detail" style="color: #212529">
                                                {{item1.awayT.yel}}
                                            </div>

                                            <div v-if="item1.awayT.sbst == null" class="detail" style="color: #212529">
                                                -
                                            </div>

                                            <div v-if="item1.awayT.sbst == 0" class="detail" style="color: #212529">
                                                0
                                            </div>

                                            <div v-if="item1.awayT.sbst > 0" class="detail" style="color: #212529">
                                                {{item1.awayT.sbst}}
                                            </div>
                                            <div class="detail" style="color: #212529; min-width: 37px; font-weight: bold">
                                                {{item1.awayT.nxt}}
                                            </div>
                                            <div class="detail" style="color: #212529; font-weight: bold">
                                                {{item1.awayT.rtg}}
                                            </div>
                                        </div>
                                    </div>
                                    <div style="width: 15%; height: 49px; float: left; border-left: 1px solid #e2e2e2; padding-top: 10px; border-right: 1px solid #e2e2e2; padding: 0px 10px; text-align: center; border-bottom: 1px solid lightgray">
                                        <div class="detail" style="width: 50%; position: relative; left: -4px;">{{item1.awayT.yel}}</div>
                                        <div class="detail" style="width: 50%; position: relative; left: 3px;">{{item1.awayT.red}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </CTab>
                <CTab  @click.native="mygames_tab()" :title="$t('My Games') + '(' + mygamesnumber + ')'">
                    <mygames ref="mygames_ref" v-on:update_mygames="update_mygamesnumber"></mygames>
                </CTab>
            </CTabs>
            <PostTipModal v-if="postTipItem" :showModal="showPostTipModal" :item="postTipItem" @hidePostModal="hidePostModal"></PostTipModal>

            <b-modal id="modal-center" class="live-stats-modal" centered :title="historicModalData.eventName">
                <div v-if="!isload" style="height: 10px;">
                    <b-progress :value="current_counter" :max="counter" animated></b-progress>
                </div>
                <div v-else>
                    <CTabs variant="tabs" :active-tab="0">
                        <CTab :title="$t('Historical Stats')">
                            <div class="header modal-tab-content">
                                <div style="min-width: 714px;">
                                    <div class="header-content" style="text-align: center; padding-top: 20px; width: 5%; height: 50px; float: left; background: #8db4e2; border-left: 1px solid #ffffff;"  v-b-tooltip.hover :title = "$t(' P-Number ')">
                                        <span v-b-tooltip.hover :title = "$t(' P-Number ')">P</span>
                                    </div>
                                    <div class="header-content detail_total" style="width: 95%; height: 50px; float: left; border-left: 1px solid #ffffff; background: #8db4e2; font-weight: bold; font-size: 13px!important;">
                                        <span v-b-tooltip.hover :title = "$t(' Avg Stats Per Game ')">{{ $t('Avg Stats Per Game') }}</span>
                                        <div class="season-part" style="width: 100%">
                                            <div class="detail season-detail" style="min-width: 30px!important; width: 6.5%!important" v-b-tooltip.hover :title = "$t(' Goals ')">
                                                {{ $t('Goals') }}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 4.5%!important" v-b-tooltip.hover :title = "$t(' On ')">
                                                On
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important;" v-b-tooltip.hover :title = "$t(' Off ')">
                                                Off
                                            </div>
                                            <div class="detail season-detail" v-b-tooltip.hover :title = "$t(' Blk ')">
                                                Blk
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 5%!important" v-b-tooltip.hover :title = "$t(' In ')">
                                                In
                                            </div>
                                            <div  class="detail season-detail" v-b-tooltip.hover :title = "$t(' Out ')">
                                                Out
                                            </div>
                                            <div  class="detail season-detail" v-b-tooltip.hover :title = "$t(' Cnr ')">
                                                Cnr
                                            </div>
                                            <div class="detail season-detail" v-b-tooltip.hover :title = "$t(' DA ')">
                                                DA
                                            </div>
                                            <div class="detail season-detail" style="min-width: 30px;" v-b-tooltip.hover :title = "$t(' Pos ')">
                                                Pos
                                            </div>
                                            <div class="detail season-detail" v-b-tooltip.hover :title = "$t(' Pas ')">
                                                Pas
                                            </div>
                                            <div class="detail season-detail" v-b-tooltip.hover :title = "$t(' Acc ')">
                                                Acc
                                            </div>
                                            <div class="detail season-detail" v-b-tooltip.hover :title = "$t(' Atk ')">
                                                Atk
                                            </div>
                                            <div class="detail season-detail" v-b-tooltip.hover :title = "$t(' Ofs ')">
                                                Ofs
                                            </div>
                                            <div class="detail season-detail" v-b-tooltip.hover :title = "$t(' Sav ')">
                                                Sav
                                            </div>
                                            <div class="detail season-detail" v-b-tooltip.hover :title = "$t(' Sbst ')">
                                                Sbst
                                            </div>
                                            <div class="detail season-detail" v-b-tooltip.hover :title = "$t(' Fou ')">
                                                Fou
                                            </div>
                                            <div  class="detail season-detail" style="min-width: 30px!important; width: 6%!important" v-b-tooltip.hover :title = "$t(' G_att ')">
                                                G_att
                                            </div>
                                            <div  class="detail season-detail" v-b-tooltip.hover :title = "$t(' Safe ')">
                                                Safe
                                            </div>
                                            <div  class="detail season-detail" v-b-tooltip.hover :title = "$t(' Rtg ')">
                                                Rtg
                                            </div>
                                        </div>
                                        <b-tooltip target="Modal-P" triggers="hover">
                                            <span>{{ $t(' P-Number ') }}</span>
                                        </b-tooltip>
                                         <b-tooltip target="Modal-avg" triggers="hover">
                                            <span>{{ $t(' Avg Stats Per Game ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip target="Modal-Goals" triggers="hover">
                                            <span>{{ $t(' Goals ') }}</span>
                                        </b-tooltip>
                                    </div>
                                    <div style="width: 5%; height: 30px; float: left; border-left: 1px solid #e2e2e2; border-bottom: 1px solid #e2e2e2;">
                                        <div style="text-align: center;">{{historicModalData.home_p}}</div>
                                    </div>
                                    <div class="detail_total season-stats-part" style="width: 95%; height: 30px; float: left; border: 1px solid #e2e2e2; border-top: none;">
                                        <div style="width: 100%; padding: 3px 7px; color: black;">
                                            <div v-if="historicModalData.home_season.goals == 0" class="detail season-detail"  style="color: red; min-width: 45px!important;">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.goals == null" class="detail season-detail" style="min-width: 45px!important;">
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.goals != 0 && historicModalData.home_season.goals != null" class="detail season-detail" style="color: green; min-width: 45px!important;">
                                                {{(historicModalData.home_season.goals/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.on == 0" class="detail season-detail" style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.on == null" class="detail season-detail" style="color: red">
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.on != null && historicModalData.home_season.on != 0" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.on/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.off == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.off == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.off != 0 && historicModalData.home_season.off != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.off/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.blk == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.blk == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.blk != 0 && historicModalData.home_season.blk != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.blk/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.in == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.in == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.in != 0 && historicModalData.home_season.in != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.in/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.out == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.out == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.out != 0 && historicModalData.home_season.out != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.out/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.cnr == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.cnr == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.cnr != 0 && historicModalData.home_season.cnr != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.cnr/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.da == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.da == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.da != 0 && historicModalData.home_season.da != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.da/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.pos == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.pos == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.pos != 0 && historicModalData.home_season.pos != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.pos/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.pas == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.pas == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.pas != 0 && historicModalData.home_season.pas != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.pas/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.acc == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.acc == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.acc != 0 && historicModalData.home_season.acc != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.acc/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.atk == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.atk == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.atk != 0 && historicModalData.home_season.atk != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.atk/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.ofs == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.ofs == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.ofs != 0 && historicModalData.home_season.ofs != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.ofs/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.sav == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.sav == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.sav != 0 && historicModalData.home_season.sav != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.sav/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.sbst == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.sbst == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.sbst != 0 && historicModalData.home_season.sav != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.sbst/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.fou == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.fou == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.fou != 0 && historicModalData.home_season.sav != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.fou/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.g_att == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.g_att == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.g_att != 0 && historicModalData.home_season.g_att != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.g_att/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.safe == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.safe == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.safe != 0 && historicModalData.home_season.safe != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.safe/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div class="detail season-detail" style="color: #263043; font-weight: bold;">
                                                {{(historicModalData.home_a_rtg).toFixed(0)}}
                                            </div>
                                        </div>
                                    </div>
                                    <div style="width: 5%; height: 30px; float: left; border-left: 1px solid #e2e2e2; border-bottom: 1px solid #e2e2e2;">
                                        <div style="text-align: center;">{{historicModalData.away_p}}</div>
                                    </div>
                                    <div class="detail_total season-stats-part" style="width: 95%; height: 30px; float: left; border: 1px solid #e2e2e2; border-top: none;">
                                        <div style="width: 100%; padding: 3px 7px; color: black;">
                                            <div v-if="historicModalData.away_season.goals == 0" class="detail season-detail"  style="color: red; min-width: 45px!important;">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.goals == null" class="detail season-detail" style="min-width: 45px!important;">
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.goals != 0 && historicModalData.away_season.goals != null" class="detail season-detail" style="color: green; min-width: 45px!important;">
                                                {{(historicModalData.away_season.goals/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.on == 0" class="detail season-detail" style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.on == null" class="detail season-detail" style="color: red">
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.on != null && historicModalData.away_season.on != 0" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.on/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.off == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.off == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.off != 0 && historicModalData.away_season.off != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.off/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.blk == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.blk == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.blk != 0 && historicModalData.away_season.blk != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.blk/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.in == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.in == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.in != 0 && historicModalData.away_season.in != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.in/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.out == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.out == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.out != 0 && historicModalData.away_season.out != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.out/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.cnr == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.cnr == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.cnr != 0 && historicModalData.away_season.cnr != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.cnr/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.da == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.da == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.da != 0 && historicModalData.away_season.da != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.da/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.pos == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.pos == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.pos != 0 && historicModalData.away_season.pos != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.pos/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.pas == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.pas == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.pas != 0 && historicModalData.away_season.pas != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.pas/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.acc == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.acc == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.acc != 0 && historicModalData.away_season.acc != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.acc/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.atk == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.atk == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.atk != 0 && historicModalData.away_season.atk != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.atk/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.ofs == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.ofs == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.ofs != 0 && historicModalData.away_season.ofs != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.ofs/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.sav == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.sav == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.sav != 0 && historicModalData.away_season.sav != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.sav/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.sbst == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.sbst == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.sbst != 0 && historicModalData.away_season.sav != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.sbst/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.fou == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.fou == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.fou != 0 && historicModalData.away_season.sav != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.fou/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.g_att == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.g_att == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.g_att != 0 && historicModalData.away_season.g_att != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.g_att/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.safe == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.safe == null" class="detail season-detail" >
                                                -
                                            </div>
                                            <div  v-if="historicModalData.away_season.safe != 0 && historicModalData.away_season.safe != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.safe/historicModalData.away_p).toFixed(1)}}
                                            </div>
                                            <div class="detail season-detail" style="color: #263043; font-weight: bold;">
                                                {{(historicModalData.away_a_rtg).toFixed(0)}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CTab>
                        <CTab :title="$t('Chart')">
                            <div class="modal-tab-content" style="height: auto">
                                <div style="min-width: 714px;">
                                    <Plotly :data="data" :layout="layout" :display-mode-bar="true"></Plotly>
                                </div>
                            </div>
                        </CTab>
                        <CTab :title="$t('Odds')">
                            <div class="header modal-tab-content">
                                <div style="min-width: 714px;">
                                    <div class="header-content detail_total" style="width: 100%; height: 50px; float: left; border-left: 1px solid #ffffff; background: #8db4e2; font-weight: bold; font-size: 13px!important;">
                                        Odds
                                        <div class="season-part" style="width: 100%">
                                            <div class="detail season-detail" style="min-width: 20px!important;">
                                                H
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important;">
                                                D
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important;">
                                                A
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                O-0.5
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                U-0.5
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                O-1.5
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                U-1.5
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                O-2.5
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                U-2.5
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                O-3.5
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                U-3.5
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 8%!important">
                                                O-0.5(ht)
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 8%!important">
                                                U-0.5(ht)
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 8.5%!important">
                                                BTS(yes)
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 8.5%!important">
                                                BTS(no)
                                            </div>
                                            
                                        </div>
                                    </div>
                                    
                                    <div class="detail_total season-stats-part" style="width: 100%; height: 30px; float: left; border: 1px solid #e2e2e2; border-top: none;">
                                        <div style="width: 100%; padding: 3px 7px; color: black;">
                                            <div class="detail season-detail" style="min-width: 20px!important;">
                                                {{this.flatodds.h_win}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important;">
                                            {{this.flatodds.d_win}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important;">
                                            {{this.flatodds.a_win}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                {{this.flatodds.o_05}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                            {{this.flatodds.u_05}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                {{this.flatodds.o_15}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                {{this.flatodds.u_15}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                {{this.flatodds.o_25}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                {{this.flatodds.u_25}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                {{this.flatodds.o_35}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                {{this.flatodds.u_35}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 8%!important">
                                            {{this.flatodds.o_05_ht}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 8%!important">
                                                {{this.flatodds.u_05_ht}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 8.5%!important">
                                                {{this.flatodds.bts_yes}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 8.5%!important">
                                                {{this.flatodds.bts_no}}
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <div class="detail_total season-stats-part" style="width: 100%; height: 30px; float: left; border: 1px solid #e2e2e2; border-top: none;">
                                        <div style="width: 100%; padding: 3px 7px; color: black;">
                                            <div  v-if="flatodds.prob_home != '-'" class="detail season-detail" style="min-width: 20px!important;">
                                                <span id="prob_home" :class="{'green-label' : flatodds.prob_home_tt2 > 10 }">{{flatodds.prob_home + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important;">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_draw != '-'" class="detail season-detail" style="min-width: 20px!important;">
                                                <span id="prob_draw" :class="{'green-label' : flatodds.prob_draw_tt2 > 10 }">{{this.flatodds.prob_draw + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important;">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_away != '-'" class="detail season-detail" style="min-width: 20px!important;" >
                                                <span id="prob_away" :class="{'green-label' : flatodds.prob_away_tt2 > 10 }">{{this.flatodds.prob_away + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important;">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_over05 != '-'" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                <span id="prob_over05" :class="{'green-label' : flatodds.prob_over05_tt2 > 10 }">{{this.flatodds.prob_over05 + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_under05 != '-'" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                <span id="prob_under05"  :class="{'green-label' : flatodds.prob_under05_tt2 > 10 }">{{this.flatodds.prob_under05 + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_over15 != '-'" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                <span id="prob_over15" :class="{'green-label' : flatodds.prob_over15_tt2 > 10 }">{{this.flatodds.prob_over15 + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_under15 != '-'" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                <span id="prob_under15" :class="{'green-label' : flatodds.prob_under15_tt2 > 10 }">{{this.flatodds.prob_under15 + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_over25 != '-'" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                <span id="prob_over25" :class="{'green-label' : flatodds.prob_over25_tt2 > 10 }">{{this.flatodds.prob_over25 + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_under25 != '-'" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                <span id="prob_under25" :class="{'green-label' : flatodds.prob_under25_tt2 > 10 }">{{this.flatodds.prob_under25 + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_over35 != '-'" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                <span id="prob_over35" :class="{'green-label' : flatodds.prob_over35_tt2 > 10 }">{{this.flatodds.prob_over35 + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_under35 != '-'" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                <span id="prob_under35" :class="{'green-label' : flatodds.prob_under35_tt2 > 10 }">{{this.flatodds.prob_under35 + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_over05_ht != '-'" class="detail season-detail" style="min-width: 20px!important; width: 8%!important">
                                                <span id="prob_over05_ht" :class="{'green-label' : flatodds.prob_over05_ht_tt2 > 10 }">{{this.flatodds.prob_over05_ht + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 8%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_under05_ht != '-'" class="detail season-detail" style="min-width: 20px!important; width: 8%!important">
                                                <span id="prob_under05_ht" :class="{'green-label' : flatodds.prob_under05_ht_tt2 > 10 }">{{this.flatodds.prob_under05_ht + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 8%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_bts != '-'" class="detail season-detail" style="min-width: 20px!important; width: 8.5%!important">
                                                <span id="prob_bts" :class="{'green-label' : flatodds.prob_bts_tt2 > 10 }">{{this.flatodds.prob_bts + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 8.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_bts_no != '-'" class="detail season-detail" style="min-width: 20px!important; width: 8.5%!important">
                                                <span id="prob_bts_no" :class="{'green-label' : flatodds.prob_bts_no_tt2 > 10 }">{{this.flatodds.prob_bts_no + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 8.5%!important">
                                                -
                                            </div>
                                            
                                        </div>
                                        
                                        <b-tooltip v-if="flatodds.prob_home_tt2" target="prob_home" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_home_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_home_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_away_tt2" target="prob_away" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_away_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_away_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_draw_tt2" target="prob_draw" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_draw_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_draw_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_over05_tt2" target="prob_over05" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_over05_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_over05_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_over15_tt2" target="prob_over15" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_over15_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_over15_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_over25_tt2" target="prob_over25" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_over25_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_over25_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_over35_tt2" target="prob_over35" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_over35_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_over35_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_under05_tt2" target="prob_under05" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_under05_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_under05_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_under15_tt2" target="prob_under15" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_under15_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_under15_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_under25_tt2" target="prob_under25" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_under25_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_under25_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_under35_tt2" target="prob_under35" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_under35_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_under35_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_over05_ht_tt2" target="prob_over05_ht" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_over05_ht_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_over05_ht_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_under05_ht_tt2" target="prob_under05_ht" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_under05_ht_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_under05_ht_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_bts_tt2" target="prob_bts" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_bts_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_bts_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_bts_no_tt2" target="prob_bts_no" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_bts_no_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_bts_no_tt2}}%</span>
                                        </b-tooltip>
                                    </div>
                                    <div class="detail_total season-stats-part" style="width: 100%; height: 30px; float: left; border: 1px solid #e2e2e2; border-top: none; padding-left: 15px;">
                                        {{matches_sample}} matches sample
                                    </div>
                                </div>
                                
                            </div>
                        </CTab>
                    </CTabs>
                </div>
            </b-modal>
        </CCard>
    </div>
</template>

<script>
    
    import Multiselect from 'vue-multiselect';
    import { Plotly } from 'vue-plotly'
    import swal from "sweetalert2";
    import mygames from './mygames.vue'
    const io = require("socket.io-client")
    import {displaySuccess, displayError} from '../helpers/message';

    import PostTipModal from '@/components/PostTipModal';

    export default {
        name: 'LiveStatsNew',
        components: {
            Plotly,
            mygames,
            Multiselect,
            PostTipModal
        },
        data () {
            return {
                //show modal
                postTipItem: null,
                showPostTipModal: false,

                // search filter
                apply_filter: false,
                advanced_search: false,                
                
                showSaveFilter: false,
                showEditFilter: false,
                showLoadFilter: false,
                saved_filters: [{value: "", label: this.$t("choose filters")}],
                selected_filter: "",

                load_preset: false,
                save_filter: false,
                update_filter: false,
                load_filter: false,
                delete_filter: false,
                edit_filter: false,

                liveStat_model_id: null,

                filteredEventIds: [],
                filter_name: "",
                edit_filter_name: "",


                leagueOptions: [
                    {
                      all: this.$t('All leagues'),
                      leagues: []
                    }
                ],
                search_filters: {
                    league: []
                },

                search_model: {
                    time: '',
                    time_min: '',
                    time_max: ''
                },
                ha_options: [
                    { value: '1', label: this.$t("home(A), away(B)")},
                    { value: '2', label: this.$t("favourite(A), underdog(B)")},
                    { value: '3', label: this.$t("winning(A), losing(B)")},
                    { value: '', label: this.$t("None")}
                ],
                operation_options: [
                    { value: "team1, team2", label: "A, B"},
                    { value: "team1", label: "A"},
                    { value: "team2", label: "B"},
                    { value: "team1 OR team2", label: "A OR B"},
                    { value: "team1 AND team2", label: "A AND B"},
                    { value: "team1 > team2", label: "A > B"},
                    { value: "team1 < team2", label: "A < B"},
                    { value: "team1 = team2", label: "A = B"},
                    { value: "sum greater than", label: this.$t("sum greater than")},
                    { value: "sum minor than", label: this.$t("sum minor than")},
                    { value: "diff greater than", label: this.$t("diff greater than")},
                    { value: "diff minor than", label: this.$t("diff minor than")},
                    { value: "team1 OR team2 > team1 OR team2", label: this.$t("A OR B > A OR B")},
                    { value: "", label: "None"}
                ],
                search_model_total: {
                    rank: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',                        
                    },
                    score: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                        
                    },
                    on: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                        
                    },
                    off: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    blk: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                        
                    },
                    in: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    out: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    cnr: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                        
                    },
                    da: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    poss: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    red: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    yel: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    sbst: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    nxt: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                        
                    },
                    rtg: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                },
                search_model_ten: {                   
                    on: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    off: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    blk: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    in: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    out: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                      
                    },
                    cnr: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    da: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                      
                    },
                    poss: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },                    
                    sbst: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    goal: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    rtg: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                },
                

                finished_tab_clicked: false,
                scheduled_tab_clicked: false,
                user_scheduled_ids: [],
                user_live_ids: [],
                socket: undefined,
                isload: false,
                counter: 50,
                current_counter: 0,
                eventArray:[],
                scheduleArray:[],
                scheduleArray1:[],
                liveNumbers: 0,
                mygamesnumber: 0,
                liveDataArray:[],
                scheduleLength:0,
                finishedArray:[],
                finishedLength:0,
                collapsed1:[],
                flatodds: {
                    "h_win": "-",
                    "a_win": "-",
                    "d_win": "-",
                    "o_05": "-",
                    "o_15": "-",
                    "o_25": "-",
                    "o_35": "-",
                    "u_05": "-",
                    "u_15": "-",
                    "u_25": "-",
                    "u_35": "-",
                    "o_05_ht": "-",
                    "u_05_ht": "-",
                    "bts_yes": "-",
                    "bts_no": "-",
                    prob_home: "-",
                    prob_draw: "-",
                    prob_away : "-",
                    prob_over05: "-",
                    prob_over15: "-",
                    prob_over25 : "-",
                    prob_over35 : "-",
                    prob_bts: "-",
                    prob_over05_ht: "-",

                    prob_under05: "-",
                    prob_under15: "-",
                    prob_under25 : "-",
                    prob_under35: "-",

                    prob_bts_no: "-",
                    prob_under05_ht: "-",

                    prob_home_tt1: null,
                    prob_home_tt2: null,
                    prob_away_tt1: null,
                    prob_away_tt2: null,
                    prob_draw_tt1: null,
                    prob_draw_tt2: null,
                    prob_over05_tt1: null,
                    prob_over05_tt2: null,
                    prob_over15_tt1: null,
                    prob_over15_tt2: null,
                    prob_over25_tt1: null,
                    prob_over25_tt2: null,
                    prob_over35_tt1: null,
                    prob_over35_tt2: null,
                    prob_under05_tt1: null,
                    prob_under05_tt2: null,
                    prob_under15_tt1: null,
                    prob_under15_tt2: null,
                    prob_under25_tt1: null,
                    prob_under25_tt2: null,
                    prob_under35_tt1: null,
                    prob_under35_tt2: null,
                    prob_over05_ht_tt1: null,
                    prob_over05_ht_tt2: null,
                    prob_under05_ht_tt1: null,
                    prob_under05_ht_tt2: null,
                    prob_bts_tt1: null,
                    prob_bts_tt2: null,
                    prob_bts_no_tt1: null,
                    prob_bts_no_tt2: null,

                },
                matches_sample: 0,
                historicModalData:{
                    "eventName": "",
                    "home_season": {
                        'on': 0,
                        'off': 0,
                        'block': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'pos': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'fou': 0 ,
                        'g_att': 0 ,
                        'safe': 0,
                        'goals':0
                    },
                    "away_season": {
                        'on': 0,
                        'off': 0,
                        'block': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'pos': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'fou': 0 ,
                        'g_att': 0 ,
                        'safe': 0,
                        'goals': 0
                    },
                    "home_p": 1,
                    "away_p": 1,
                    "home_rtg": 0,
                    "home_a_rtg": 0,
                    "away_rtg": 0,
                    "away_a_rtg": 0
                },
                data:[
                    {
                        x: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],
                        y: [10,15,13,17,10,15,13,17,10,15,13,17],
                        type:"bar",
                        name: '-',
                        showarrow: false,
                        marker: {
                            color: 'rgba(244,66,66, 1)',
                            line: {
                                color: 'rgb(244,66,66)',
                                width: 1
                            }
                        }
                    },
                    {
                        x: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],
                        y: [-10,-15,-13,-17,10,15,13,17,10,15,13,17],
                        type:"bar",
                        name: '-',
                        yaxis: 'y2',
                        showarrow: false,
                        marker: {
                            color: 'rgba(65,149,244,1)',
                            line: {
                                color: 'rgb(65,149,244)',
                                width: 1
                            }
                        }
                    },
                ],
                layout:{
                    title: "",
                    xaxis:{
                        "title": {
                            "text": 'Time',
                            "font": {
                                "size": 18,
                                "color": '#263043',
                                "weight": "bold"
                            }
                        },
                    },
                    yaxis: {
                        'showgrid': false,
                        'zeroline': false,
                        'visible': false
                    },
                    yaxis2: {
                        "title": {
                            "text": 'RTG',
                            "font": {
                                "size": 18,
                                "color": '#263043',
                                "weight": "bold"
                            }
                        },
                        "overlaying": 'y',
                        "matches": 'y',
                        "tickfont" : {
                            "color" : 'white'
                        },
                        // 'showgrid': true,
                        // 'zeroline': false,
                        // 'visible': false
                        // "autorange": 'reversed',
                    },
                    showlegend: true,
                    barmode: 'relative',
                    showarrow: false
                },
                refreshIndex: 0,
                background_row:[
                    'white',
                    '#f2f2f2',
                    '#dff0d8',
                    '#f1f9ed',
                ],
                sort_by: [
                    {"value": 1, "label": "Sort By League"},
                    {"value": 2, "label": "Sort By Time"}
                ],
                last_updated_time: null,
                sort: 0,
                reload_flag: false,
                live_load_flag: false,
                league5yearsStats: [],
            }
        },
        methods: {
            hidePostModal() {
                this.postTipItem = null;
                this.showPostTipModal = false;
                // this.showPostTipModal[eventId.toString()] = false;
            },

            callPostTip(item, league) {
                this.postTipItem = {
                    fixtureId: item.fixtureId,
                    country: league.split(" - ")[0],
                    league: league.split(" - ")[1]
                };
                this.showPostTipModal = true;
                // console.log("this.$refs", this.$refs, item)
                // this.$refs['ref_' + String(item.fixtureId)].show();
            },
            
            init_liveStat_model() {
                this.search_filters.league = [];
                
                this.search_model.time_min = "";
                this.search_model.time_max = "";
                this.search_model_total = {
                    rank: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',                       
                    },
                    score: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                      
                    },
                    on: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                      
                    },
                    off: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    blk: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                     
                    },
                    in: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                      
                    },
                    out: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                     
                    },
                    cnr: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                     
                    },
                    da: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                     
                    },
                    poss: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                      
                    },
                    red: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                      
                    },
                    yel: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                      
                    },
                    sbst: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    nxt: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    rtg: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                };
                this.search_model_ten = {
                    on: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    off: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    blk: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                      
                    },
                    in: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    out: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                      
                    },
                    cnr: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    da: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    poss: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },                    
                    sbst: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                      
                    },
                    goal: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    rtg: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                      
                    },
                };
            },
            showSearch() {
                this.advanced_search = !this.advanced_search;
                if (this.advanced_search) {
                    setTimeout(() => {
                        this.$nextTick(() => {
                            var el = document.querySelector("#top-element");
                            el.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center'
                            });
                        });
                    }, 500);
                }
            },
            handleSearch() {
                this.apply_filter = true;
            },
            handleCancelSearch() {
                this.init_advancedSearch();
            },
            init_advancedSearch() {
                this.advanced_search = false;
                this.apply_filter = false;

                this.search_filters.league = [];
                
                this.search_model.time_min = "";
                this.search_model.time_max = "";
                this.search_model_total = {
                    rank: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',                       
                    },
                    score: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                      
                    },
                    on: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                      
                    },
                    off: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    blk: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                     
                    },
                    in: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                      
                    },
                    out: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                     
                    },
                    cnr: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                     
                    },
                    da: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                     
                    },
                    poss: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                      
                    },
                    red: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                      
                    },
                    yel: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                      
                    },
                    sbst: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    nxt: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    rtg: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                };
                this.search_model_ten = {
                    on: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    off: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    blk: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                      
                    },
                    in: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    out: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                      
                    },
                    cnr: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    da: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    poss: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },                    
                    sbst: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                      
                    },
                    goal: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                       
                    },
                    rtg: {
                        ha_option: '',
                        operation_option: '',
                        min: '',
                        max: '',
                      
                    },
                };

            },
            get_trueodds_value(odds, stat) {
                var true_odd = 100 / stat;
                var value = ( (odds - 1) * 100 / (true_odd - 1) ) - 100
                return [true_odd, value]
            },
            
            checkscheduleParent(e, index){
                const { checked } = e.target;
                const _childs = this.scheduleArray[index]['events'];
                if(!_childs.length) return;
                for(var i = 0; i < _childs.length; i++){
                    var _child = _childs[i];
                    if (!checked) {
                        if ( this.user_scheduled_ids.includes(_child._id) ) {
                            this.user_scheduled_ids = this.user_scheduled_ids.filter(function(ele){ 
                                return ele != _child._id; 
                            });
                        }
                    }
                    else {
                        if ( !this.user_scheduled_ids.includes(_child._id) ) {
                            this.user_scheduled_ids.push(_child._id);                            
                        }
                    }
                }
            },
            checkliveParent(e, index){
                const { checked } = e.target;
                const _childs = this.eventArray[index]['events'];
                if(!_childs.length) return;
                for(var i = 0; i < _childs.length; i++){
                    var _child = _childs[i];
                    if (!checked) {
                        if ( this.user_live_ids.includes(_child.main_data._id) ) {
                            this.user_live_ids = this.user_live_ids.filter(function(ele){ 
                                return ele != _child.main_data._id; 
                            });
                        }
                    }
                    else {
                        if ( !this.user_live_ids.includes(_child.main_data._id) ) {
                            this.user_live_ids.push(_child.main_data._id);                            
                        }
                    }
                }
            },
            showModal() {
                this.$root.$emit('bv::show::modal', 'modal-1', '#btnShow')
            },
            hideModal() {
                this.$root.$emit('bv::hide::modal', 'modal-1', '#btnShow')
            },

            update_mygamesnumber(val) {
                
                this.mygamesnumber = val;
            },
            
            mygames_tab() {

                this.$refs.mygames_ref.readData()
            },
            save_scheduled() {
                var user_id = localStorage.getItem("user_id");
                
                if (user_id == 'undefined') {
                    
                    swal.fire("Alert!", "User not specified", "error");
                    return;
                }
                else {
                    
                    
                }
                if (this.user_scheduled_ids.length == 0) {
                    swal.fire("Alert!", "No events selected", "error");
                    return;
                }
                var post_data = {
                    "user_id": user_id,
                    "event_ids": this.user_scheduled_ids
                }

                window.axios.post(`${process.env.VUE_APP_URL}save_scheduled`, post_data).then(({data}) => {
                    
                    swal.fire("Success!", "Data saved successfully", "success");
                    
                    this.mygames_tab();
                })
            },

            save_live() {
                var user_id = localStorage.getItem("user_id");
                
                if (user_id == 'undefined') {
                    
                    swal.fire("Alert!", "User not specified", "error");
                    return;
                }
                else {
                      
                    
                }
                if (this.user_live_ids.length == 0) {
                    swal.fire("Alert!", "No events selected", "error");
                    return;
                }
                var post_data = {
                    "user_id": user_id,
                    "event_ids": this.user_live_ids
                }

                window.axios.post(`${process.env.VUE_APP_URL}save_scheduled`, post_data).then(({data}) => {
                    
                    swal.fire("Success!", "Data saved successfully", "success");
                    
                    this.mygames_tab();
                })
            },
            
            create_UUID(){
                var dt = new Date().getTime();
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    var r = (dt + Math.random()*16)%16 | 0;
                    dt = Math.floor(dt/16);
                    return (c=='x' ? r :(r&0x3|0x8)).toString(16);
                });
                return uuid
            },
            isCollapsed1(id){
                return this.collapsed1.indexOf(id)>-1?true:false;
            },
            SetCollapse1(id){
                if (this.isCollapsed1(id)){
                    this.collapsed1.splice(this.collapsed1.indexOf(id), 1)
                }
                else{
                    this.collapsed1.push(id)
                }
            },
            isPlus(id){
                return this.collapsed1.indexOf(id)>-1?false:true;
            },
            isMinus(id){
                return this.collapsed1.indexOf(id)>-1?true:false;
            },
            frame() {
                if (this.current_counter >= 45) {
                    this.current_counter = 45
                    clearInterval(this.clock);
                } else {
                    this.current_counter++;
                }
            },
            frame1() {
                //this.readData()
                //this.mygames_tab()

            },
            scheduled_tab(){
                if (!this.scheduled_tab_clicked)
                    this.showModal();
                var user_id = localStorage.getItem("user_id");
                var post_data = {
                    "user_id": user_id
                }
                window.axios.post(`${process.env.VUE_APP_URL}getLiveStatsNew_scheduled_origin`, post_data).then(({data})=> {
                    if (!this.scheduled_tab_clicked)
                        this.hideModal();
                    this.scheduled_tab_clicked = true;
                    
                    let eventList = data.data[0]
                    let probList = data.data[1]
                    let probData = {};
                    for (let i = 0; i < probList.length; i++) {
                        probData[probList[i].league_id.toString()] = probList[i].oddslines;
                    }
                    let competitionArray1 = []
                    let competitionArrayCount = 0
                    for(let i = 0 ; i < eventList.length; i++){
                        if (eventList[i].competitions.length && eventList[i].competitions[0].league) {
                            let competitionName = eventList[i].competitions[0].league
                            competitionArray1[competitionArrayCount++] = competitionName
                        }
                    }
                    competitionArray1 = Array.from(new Set (competitionArray1))
                    this.scheduleArray = []
                    this.scheduleArray1 = []
                    this.scheduleLength = 0
                    for(let j = 0 ; j < competitionArray1.length ; j++){
                        this.scheduleArray.push({'id': this.create_UUID(), 'league': competitionArray1[j].split("(")[1].split(")")[0] + " - " + competitionArray1[j].split("(")[0], 'events': []})
                        this.scheduleArray1.push({'id': this.create_UUID(), 'league': competitionArray1[j].split("(")[1].split(")")[0] + " - " + competitionArray1[j].split("(")[0], 'events': []})
                        for(let k = 0 ;  k < eventList.length ; k++){
                            if(eventList[k].competitions.length && eventList[k].competitions[0].league == competitionArray1[j] && eventList[k].time.status == 'NS'){
                                this.scheduleLength++

                                let com_url = 'https://www.betfair.com/exchange/plus/en/football/'
                                let it_url = ''
                                
                                if(eventList[k].com_link){
                                   
                                    let com_name = eventList[k].com_link.competitionName
                                    let eventN = eventList[k].com_link.eventName
                                    com_name = com_name.toLowerCase()
                                    com_name = com_name.replaceAll(" ", "-")
                                    eventN = eventN.toLowerCase()
                                    eventN = eventN.replaceAll(" ", "-")
                                    com_url = com_name + "/" + eventN
                                    com_url = 'https://www.betfair.com/exchange/plus/en/football/' + com_url + '-betting-' + eventList[k].com_link.eventId                                        
                                }
                                if(eventList[k].it_link){
                                    let it_name = eventList[k].it_link.competitionName
                                    let itN = eventList[k].it_link.eventName
                                    it_name = it_name.toLowerCase()
                                    it_name = it_name.replaceAll(" ", "")
                                    itN = itN.toLowerCase()
                                    itN = itN.replaceAll(" ", "")
                                    it_url = it_name + "/" + itN
                                    it_url = 'https://www.betfair.it/exchange/plus/it/calcio/' + it_url + '-scommesse-' + eventList[k].it_link.eventId
                                }

                                let current_main_data = {
                                    "com_url": com_url,
                                    "it_url": it_url,

                                    "competitionId": eventList[k].competitionId,
                                    "competitions": eventList[k].competitions,
                                    "scores": eventList[k].scores,
                                    "stats": eventList[k].stats,
                                    "time": eventList[k].time,
                                    "localTeamName": eventList[k].localTeamName,
                                    "visitorTeamName": eventList[k].visitorTeamName,
                                    "_id": eventList[k]._id,
                                    "fixtureId": eventList[k]._id,
                                    "localTeamId": eventList[k].localTeamId,
                                    "visitorTeamId": eventList[k].visitorTeamId,
                                    "marketId_matched": null,
                                    "marketId_o_u": null,
                                    "match_1": null,
                                    "match_2": null,
                                    "match_3": null,
                                    "match_O": null,
                                    "match_U": null,

                                    "prob_home": null,
                                    "prob_draw": null,
                                    "prob_away": null,
                                    "prob_over05": null,
                                    "prob_over15": null,
                                    "prob_over25": null,
                                    "prob_over35": null,
                                    "prob_bts": null,
                                    "prob_over05_ht": null,

                                    "prob_under05": null,
                                    "prob_under15": null,
                                    "prob_under25": null,
                                    "prob_under35": null,
                                    "prob_bts_no": null,
                                    "prob_under05_ht": null,

                                    "prob_home_tt1": null,
                                    "prob_draw_tt1": null,
                                    "prob_away_tt1": null,
                                    "prob_over05_tt1": null,
                                    "prob_over15_tt1": null,
                                    "prob_over25_tt1": null,
                                    "prob_over35_tt1": null,
                                    "prob_bts_tt1": null,
                                    "prob_over05_ht_tt1": null,

                                    "prob_under05_tt1": null,
                                    "prob_under15_tt1": null,
                                    "prob_under25_tt1": null,
                                    "prob_under35_tt1": null,
                                    "prob_bts_no_tt1": null,
                                    "prob_under05_ht_tt1": null,

                                    "prob_home_tt2": null,
                                    "prob_draw_tt2": null,
                                    "prob_away_tt2": null,
                                    "prob_over05_tt2": null,
                                    "prob_over15_tt2": null,
                                    "prob_over25_tt2": null,
                                    "prob_over35_tt2": null,
                                    "prob_bts_tt2": null,
                                    "prob_over05_ht_tt2": null,

                                    "prob_under05_tt2": null,
                                    "prob_under15_tt2": null,
                                    "prob_under25_tt2": null,
                                    "prob_under35_tt2": null,
                                    "prob_bts_no_tt2": null,
                                    "prob_under05_ht_tt2": null,

                                    "odds_home": null,
                                    "odds_draw": null,
                                    "odds_away": null,
                                    "odds_over05": null,
                                    "odds_over15": null,
                                    "odds_over25": null,
                                    "odds_over35": null,
                                    "odds_bts_yes": null,
                                    "odds_over05_ht": null,

                                    "odds_under05": null,
                                    "odds_under15": null,
                                    "odds_under25": null,
                                    "odds_under35": null,
                                    "odds_bts_no": null,
                                    "odds_under05_ht": null,

                                    'sampleMatches': 0,

                                    "uuid": this.create_UUID()

                                }

                                var home_odds = 100;
                                var away_odds = 100;
                                var draw_odds = 100;

                                var event_odds_list = []

                                if (eventList[k].DailyFixtures.length != 0) {
                                    eventList[k].DailyFixtures[0].flatOdds.data.forEach((oItem) => {
                                        let mkt_id = oItem.market_id;
                                        if(oItem.bookmaker_id === 2) {
                                            let suffix;
                                            if(mkt_id === 1 || mkt_id === 12 || mkt_id === 976105  || mkt_id === 136703813 || mkt_id === 137918022 || mkt_id === 28077 || mkt_id === 1256989864) 
                                                suffix = 'FT';
                                            else if(mkt_id === 37 || mkt_id === 31379 || mkt_id === 975903 || mkt_id === 976226)
                                                suffix = 'HT';
                                            (oItem.odds || oItem.values).forEach((item) => {
                                                let label;
                                                if(item.label)
                                                    label = `${item.label}${item.total ? ' - ' + item.total : ''}`;
                                                else if(item.team)
                                                    label = item.team;
                                                else if(item.info) {
                                                    label = item.info;
                                                }
                                                if(label === 'Yes')
                                                    label = 'BTS';
                                                else if(label === 'No')
                                                    label = 'No BTS';
                                                if(label === '1')
                                                    label = "Home";
                                                else if(label === '2')
                                                    label = 'Away';
                                                else if(label === 'X')
                                                    label = 'Draw';
                                                if(!label.includes(",")) {              //except over 2.0,2.5 case
                                                    label = `${label} - ${suffix}`
                                                    if(label == 'Home - FT') {
                                                        current_main_data.match_1 = parseFloat(item.value)
                                                        home_odds = parseFloat(item.value)
                                                    }
                                                    else if(label == 'Away - FT') {
                                                        current_main_data.match_2 = parseFloat(item.value)
                                                        away_odds = parseFloat(item.value)
                                                    }
                                                    else if(label == 'Draw - FT') {
                                                        current_main_data.match_3 = parseFloat(item.value)
                                                        draw_odds = parseFloat(item.value)
                                                    }

                                                    else if(label == "Over - 0.5 - FT")
                                                        current_main_data.odds_over05 = parseFloat(item.value)
                                                    else if(label == "Over - 1.5 - FT")
                                                        current_main_data.odds_over15 = parseFloat(item.value)
                                                    else if(label == "Over - 2.5 - FT")
                                                        current_main_data.odds_over25 = parseFloat(item.value)
                                                    else if(label == "Over - 3.5 - FT")
                                                        current_main_data.odds_over35 = parseFloat(item.value)

                                                    else if(label == "Under - 0.5 - FT")
                                                        current_main_data.odds_under05 = parseFloat(item.value)
                                                    else if(label == "Under - 1.5 - FT")
                                                        current_main_data.odds_under15 = parseFloat(item.value)
                                                    else if(label == "Under - 2.5 - FT")
                                                        current_main_data.odds_under25 = parseFloat(item.value)
                                                    else if(label == "Under - 3.5 - FT")
                                                        current_main_data.odds_under35 = parseFloat(item.value)

                                                    else if(label == "BTS - FT")
                                                        current_main_data.odds_bts_yes = parseFloat(item.value)
                                                    else if(label == "No BTS - FT")
                                                        current_main_data.odds_bts_no = parseFloat(item.value)

                                                    else if(label == "Over - 0.5 - HT")
                                                        current_main_data.odds_over05_ht = parseFloat(item.value)
                                                    else if(label == "Under - 0.5 - HT")
                                                        current_main_data.odds_under05_ht = parseFloat(item.value)

                                                    // event_odds_list.push({
                                                    //     label: `${label} - ${suffix}`,
                                                    //     value: `${label} - ${suffix}`.trim(),
                                                    //     odd: parseFloat(item.value)
                                                    // });
                                                }
                                            });
                                        }
                                    });
                                    
                                
                                }

                                var oddslines = probData[eventList[k].leagueId.toString()];

                                var odds = null;
                                if (home_odds <= 3 && away_odds <= 3) {
                                    odds = oddslines[3]
                                }
                                else if (home_odds <= 1.5) {
                                    odds = oddslines[0]
                                }
                                else if (home_odds > 1.5 && home_odds <= 2) {
                                    odds = oddslines[1]
                                }
                                else if (home_odds > 2 && home_odds <= 3) {
                                    odds = oddslines[2]
                                }
                                
                                else if (away_odds <= 1.5) {
                                    odds = oddslines[4]
                                }
                                else if (away_odds > 1.5 && away_odds <= 2) {
                                    odds = oddslines[5]
                                }
                                else if (away_odds > 2 && away_odds <= 3) {
                                    odds = oddslines[6]
                                }

                                if (odds) {
                                    current_main_data.prob_home = parseInt(odds.home_win_percent)
                                    current_main_data.prob_draw = parseInt(odds.draw_win_percent)
                                    current_main_data.prob_away = parseInt(odds.away_win_percent)
                                    current_main_data.prob_over05 = parseInt(odds.full_05_percent)
                                    current_main_data.prob_over15 = parseInt(odds.full_15_percent)
                                    current_main_data.prob_over25 = parseInt(odds.full_25_percent)
                                    current_main_data.prob_over35 = parseInt(odds.full_35_percent)
                                    current_main_data.prob_bts = parseInt(odds.bts_percent)
                                    current_main_data.prob_over05_ht = parseInt(odds.first_05_percent)

                                    current_main_data.prob_under05 = 100 - parseInt(odds.full_05_percent)
                                    current_main_data.prob_under15 = 100 - parseInt(odds.full_15_percent)
                                    current_main_data.prob_under25 = 100 - parseInt(odds.full_25_percent)
                                    current_main_data.prob_under35 = 100 - parseInt(odds.full_35_percent)

                                    current_main_data.prob_bts_no = 100 - parseInt(odds.bts_percent)
                                    current_main_data.prob_under05_ht = 100 - parseInt(odds.first_05_percent)

                                    current_main_data.sampleMatches = odds.total_matches


                                }

                                if (current_main_data.prob_home !== null && current_main_data.match_1 !== null) {
                                    var val = this.get_trueodds_value(current_main_data.match_1, current_main_data.prob_home)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    current_main_data.prob_home_tt1 = true_odd.toFixed(2)
                                    current_main_data.prob_home_tt2 = value.toFixed(2)                                    
                                }

                                if (current_main_data.prob_draw !== null && current_main_data.match_3 !== null) {
                                    var val = this.get_trueodds_value(current_main_data.match_3, current_main_data.prob_draw)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    current_main_data.prob_draw_tt1 = true_odd.toFixed(2)
                                    current_main_data.prob_draw_tt2 = value.toFixed(2)
                                }

                                if (current_main_data.prob_away !== null && current_main_data.match_2 !== null) {
                                    var val = this.get_trueodds_value(current_main_data.match_2, current_main_data.prob_away)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    current_main_data.prob_away_tt1 = true_odd.toFixed(2)
                                    current_main_data.prob_away_tt2 = value.toFixed(2)
                                }

                                if (current_main_data.prob_over05 !== null && current_main_data.odds_over05 !== null) {
                                    var val = this.get_trueodds_value(current_main_data.odds_over05, current_main_data.prob_over05)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    current_main_data.prob_over05_tt1 = true_odd.toFixed(2)
                                    current_main_data.prob_over05_tt2 = value.toFixed(2)
                                }

                                if (current_main_data.prob_over15 !== null && current_main_data.odds_over15 !== null) {
                                    var val = this.get_trueodds_value(current_main_data.odds_over15, current_main_data.prob_over15)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    current_main_data.prob_over15_tt1 = true_odd.toFixed(2)
                                    current_main_data.prob_over15_tt2 = value.toFixed(2)
                                }

                                if (current_main_data.prob_over25 !== null && current_main_data.odds_over25 !== null) {
                                    var val = this.get_trueodds_value(current_main_data.odds_over25, current_main_data.prob_over25)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    current_main_data.prob_over25_tt1 = true_odd.toFixed(2)
                                    current_main_data.prob_over25_tt2 = value.toFixed(2)
                                }

                                if (current_main_data.prob_over35 !== null && current_main_data.odds_over35 !== null) {
                                    var val = this.get_trueodds_value(current_main_data.odds_over35, current_main_data.prob_over35)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    current_main_data.prob_over35_tt1 = true_odd.toFixed(2)
                                    current_main_data.prob_over35_tt2 = value.toFixed(2)
                                }

                                if (current_main_data.prob_under05 !== null && current_main_data.odds_under05 !== null) {
                                    var val = this.get_trueodds_value(current_main_data.odds_under05, current_main_data.prob_under05)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    current_main_data.prob_under05_tt1 = true_odd.toFixed(2)
                                    current_main_data.prob_under05_tt2 = value.toFixed(2)
                                }
                                if (current_main_data.prob_under15 !== null && current_main_data.odds_under15 !== null) {
                                    var val = this.get_trueodds_value(current_main_data.odds_under15, current_main_data.prob_under15)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    current_main_data.prob_under15_tt1 = true_odd.toFixed(2)
                                    current_main_data.prob_under15_tt2 = value.toFixed(2)
                                }
                                if (current_main_data.prob_under25 !== null && current_main_data.odds_under25 !== null) {
                                    var val = this.get_trueodds_value(current_main_data.odds_under25, current_main_data.prob_under25)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    current_main_data.prob_under25_tt1 = true_odd.toFixed(2)
                                    current_main_data.prob_under25_tt2 = value.toFixed(2)
                                }
                                if (current_main_data.prob_under35 !== null && current_main_data.odds_under35 !== null) {
                                    var val = this.get_trueodds_value(current_main_data.odds_under35, current_main_data.prob_under35)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    current_main_data.prob_under35_tt1 = true_odd.toFixed(2)
                                    current_main_data.prob_under35_tt2 = value.toFixed(2)
                                }

                                if (current_main_data.prob_over05_ht !== null && current_main_data.odds_over05_ht !== null) {
                                    var val = this.get_trueodds_value(current_main_data.odds_over05_ht, current_main_data.prob_over05_ht)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    current_main_data.prob_over05_ht_tt1 = true_odd.toFixed(2)
                                    current_main_data.prob_over05_ht_tt2 = value.toFixed(2)
                                }

                                if (current_main_data.prob_under05_ht !== null && current_main_data.odds_under05_ht !== null) {
                                    var val = this.get_trueodds_value(current_main_data.odds_under05_ht, current_main_data.prob_under05_ht)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    current_main_data.prob_under05_ht_tt1 = true_odd.toFixed(2)
                                    current_main_data.prob_under05_ht_tt2 = value.toFixed(2)
                                }

                                if (current_main_data.prob_bts !== null && current_main_data.odds_bts_yes !== null) {
                                    var val = this.get_trueodds_value(current_main_data.odds_bts_yes, current_main_data.prob_bts)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    current_main_data.prob_bts_tt1 = true_odd.toFixed(2)
                                    current_main_data.prob_bts_tt2 = value.toFixed(2)
                                }

                                if (current_main_data.prob_bts_no !== null && current_main_data.odds_bts_no !== null) {
                                    var val = this.get_trueodds_value(current_main_data.odds_bts_no, current_main_data.prob_bts_no)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    current_main_data.prob_bts_no_tt1 = true_odd.toFixed(2)
                                    current_main_data.prob_bts_no_tt2 = value.toFixed(2)
                                }

                                this.scheduleArray[j].events.push(current_main_data)
                                this.scheduleArray1[j].events.push(current_main_data)


                            }
                        }
                    }
                    let self = this
                    this.sortJSON(self.scheduleArray,'league', '123')
                    if(this.sort === 1){
                        this.sort_filter(2)
                    }
                })
            },
            finished_tab(){
                
                var user_id = localStorage.getItem("user_id");
                var post_data = {
                    "user_id": user_id
                }
                if (!this.finished_tab_clicked)
                    this.showModal();

                window.axios.post(`${process.env.VUE_APP_URL}getLiveStatsNew_finished_origin`, post_data).then(({data})=> {
                    if (!this.finished_tab_clicked)
                        this.hideModal();
                    this.finished_tab_clicked = true;
                    
                    let main_data = data.data[0]
                    let competitionArray = []
                    let competitionArrayCount = 0
                    for(let i = 0 ; i < main_data.length; i++){
                        if (main_data[i].competitions.length && main_data[i].competitions[0].league) {
                            let competitionName = main_data[i].competitions[0].league
                            competitionArray[competitionArrayCount++] = competitionName
                        }
                    }
                    competitionArray = Array.from(new Set (competitionArray))
                    this.finishedArray = []
                    // this.finishedLength = 0
                    // for(let j = 0 ; j < competitionArray1.length ; j++){
                    //     this.finishedArray.push({'league': competitionArray1[j].split("(")[1].split(")")[0] + " - " + competitionArray1[j].split("(")[0], 'events': []})
                    //     for(let k = 0 ;  k < eventList.length ; k++){
                    //         if(eventList[k].competitions.length && eventList[k].competitions[0].league == competitionArray1[j] && (eventList[k].time.status == 'FT' || eventList[k].time.status == 'FT_PEN' || eventList[k].time.status == 'AET')){
                    //             this.finishedLength++
                    //             this.finishedArray[j].events.push(eventList[k])
                    //         }
                    //     }
                    // }
                    for(let i = 0 ; i < competitionArray.length ; i++){
                        this.finishedArray.push({'league': competitionArray[i].split("(")[1].split(")")[0] + " - " + competitionArray[i].split("(")[0], 'events': []})
                        for(let j = 0 ; j < main_data.length ; j++) {
                            let current_main_data = main_data[j]
                            if(current_main_data.stats.length > 0 && current_main_data.competitions.length){
                                if(current_main_data.competitions[0].league == competitionArray[i]){
                                    let home = {
                                        'id': 0,
                                        'on': null,
                                        'off': null,
                                        'blk': null,
                                        'in': null,
                                        'out': null,
                                        'cnr': null,
                                        'da': null,
                                        'goal': null,
                                        'rtg': 0,
                                        'gdr':0,
                                        'time': '',
                                        'score': 0,
                                        'flash': 0,
                                        'poss': null,
                                        'pas': 0,
                                        'acc': 0,
                                        'atk': 0,
                                        'ofs': 0,
                                        'sav': 0,
                                        'sbst': null,
                                        'red': 0,
                                        'fou': 0,
                                        'g_att': 0,
                                        'safe': 0,
                                        'last_on': 0,
                                        'last_off': 0,
                                        'last_cnr': 0,
                                        'last_da': 0,
                                        'last_goal': 0,
                                        'a_rtg': 14
                                    }
                                    let homeT = {
                                        'on': 0,
                                        'off': 0,
                                        'blk': 0,
                                        'in': 0,
                                        'out': 0,
                                        'cnr': 0,
                                        'da': 0,
                                        'poss': 0,
                                        'flash': 0,
                                        'pas': 0,
                                        'acc': 0,
                                        'atk': 0,
                                        'ofs': 0,
                                        'sav': 0,
                                        'sbst': 0,
                                        'red': 0,
                                        'yel': 0,
                                        'fou': 0,
                                        'g_att': 0,
                                        'safe': 0,
                                        'nxt': 0,
                                        'rtg': 0,
                                    }
                                    let away = {
                                        'id': 0,
                                        'on': null,
                                        'off': null,
                                        'blk': null,
                                        'in': null,
                                        'out': null,
                                        'cnr': null,
                                        'da': null,
                                        'goal': null,
                                        'rtg': 0,
                                        'gdr': 0,
                                        'time': 0,
                                        'score': 0,
                                        'poss': null,
                                        'pas': 0,
                                        'acc': 0,
                                        'atk': 0,
                                        'ofs': 0,
                                        'sav': 0,
                                        'sbst': null,
                                        'red': 0,
                                        'fou': 0,
                                        'g_att': 0,
                                        'safe': 0,
                                        'last_on': 0,
                                        'last_off': 0,
                                        'last_cnr': 0,
                                        'last_da': 0,
                                        'last_goal': 0,
                                        'a_rtg': 14
                                    }
                                    let awayT = {
                                        'on': 0,
                                        'off': 0,
                                        'blk': 0,
                                        'in': 0,
                                        'out': 0,
                                        'cnr': 0,
                                        'da': 0,
                                        'poss': 0,
                                        'pas': 0,
                                        'acc': 0,
                                        'atk': 0,
                                        'ofs': 0,
                                        'sav': 0,
                                        'sbst': 0,
                                        'red': 0,
                                        'yel': 0,
                                        'fou': 0,
                                        'g_att': 0,
                                        'safe': 0,
                                        'nxt': 0,
                                        'rtg': 0
                                    }
                                    let home_season = {
                                        'on': 0,
                                        'off': 0,
                                        'block': 0,
                                        'in': 0,
                                        'out': 0,
                                        'cnr': 0,
                                        'da': 0,
                                        'pos': 0,
                                        'pas': 0,
                                        'acc': 0,
                                        'atk': 0,
                                        'ofs': 0,
                                        'sav': 0,
                                        'sbst': 0,
                                        'fou': 0 ,
                                        'g_att': 0 ,
                                        'safe': 0,
                                        'goals':0
                                    }
                                    let away_season = {
                                        'on': 0,
                                        'off': 0,
                                        'block': 0,
                                        'in': 0,
                                        'out': 0,
                                        'cnr': 0,
                                        'da': 0,
                                        'pos': 0,
                                        'pas': 0,
                                        'acc': 0,
                                        'atk': 0,
                                        'ofs': 0,
                                        'sav': 0,
                                        'sbst': 0,
                                        'fou': 0 ,
                                        'g_att': 0 ,
                                        'safe': 0,
                                        'goals': 0
                                    }
                                    let home_p = 0
                                    let away_p = 0
                                    let fixture_id = current_main_data._id

                                    let home_rtg_stats = current_main_data.home_rtg_stats
                                    let away_rtg_stats = current_main_data.away_rtg_stats
                                   
                                    let half_extra_time = 0

                                    if(home_rtg_stats){
                                        for(let c = 0; c < home_rtg_stats.length; c++){
                                            let minute = home_rtg_stats[c].time.minute
                                            let home_rtg = {
                                                'on': null,
                                                'off': null,
                                                'cnr': null,
                                                'da': null,
                                                'goal': null,
                                                'rtg': null
                                            }

                                            if(home_rtg_stats[c].time.extra_time != null){
                                                minute = home_rtg_stats[c].time.minute + home_rtg_stats[c].time.extra_time
                                                if(home_rtg_stats[c].time.minute < 46){
                                                    half_extra_time = home_rtg_stats[c].time.extra_time
                                                }
                                            }
                                            if(home_rtg_stats[c].time.minute > 45){
                                                minute = minute + half_extra_time
                                            }
                                            

                                            if(c <= 10){
                                                if(home_rtg_stats[c].shots != null){
                                                    home_rtg.on = home_rtg_stats[c].shots.ongoal
                                                    home_rtg.off = home_rtg_stats[c].shots.offgoal
                                                }
                                                if(home_rtg_stats[c].da != null){
                                                    home_rtg.da = home_rtg_stats[c].da.dangerous_attacks
                                                }
                                                home_rtg.cnr = home_rtg_stats[c].cnr
                                                home_rtg.goal = home_rtg_stats[c].goals
                                            }
                                            else{
                                                if(home_rtg_stats[c - 10].shots != null){
                                                    home_rtg.on = home_rtg_stats[c].shots.ongoal - home_rtg_stats[c - 10].shots.ongoal
                                                    home_rtg.off = home_rtg_stats[c].shots.offgoal - home_rtg_stats[c - 10].shots.offgoal
                                                }
                                                if(home_rtg_stats[c - 10].da != null){
                                                    home_rtg.da = home_rtg_stats[c].da.dangerous_attacks - home_rtg_stats[c - 10].da.dangerous_attacks
                                                }
                                                home_rtg.cnr = home_rtg_stats[c].cnr - home_rtg_stats[c - 10].cnr
                                                home_rtg.goal = home_rtg_stats[c].goals - home_rtg_stats[c - 10].goals
                                            }

                                            if((home_rtg.on >= 0) || (home_rtg.off >= 0) || (home_rtg.cnr >= 0) || (home_rtg.da > 0)){
                                                home_rtg.rtg = 0
                                                if(home_rtg.on >= 0){
                                                    home_rtg.rtg = home_rtg.rtg + home_rtg.on*3
                                                }
                                                if(home_rtg.off >= 0){
                                                    home_rtg.rtg = home_rtg.rtg + home_rtg.off*2
                                                }
                                                if(home_rtg.cnr >= 0){
                                                    home_rtg.rtg = home_rtg.rtg + home_rtg.cnr
                                                }
                                                if(home_rtg.da >= 0){
                                                    home_rtg.rtg = home_rtg.rtg + home_rtg.da
                                                }
                                            }
                                            else{
                                                home_rtg.rtg = '-'
                                            }
                                            
                                        }
                                    }
                                    if(away_rtg_stats){
                                        for(let c = 0; c < away_rtg_stats.length; c++){
                                            let home_rtg = {
                                                'on': null,
                                                'off': null,
                                                'cnr': null,
                                                'da': null,
                                                'goal': null,
                                                'rtg': null
                                            }
                                            if(c <= 10){
                                                if(away_rtg_stats[c].shots != null){
                                                    home_rtg.on = away_rtg_stats[c].shots.ongoal
                                                    home_rtg.off = away_rtg_stats[c].shots.offgoal
                                                }
                                                if(away_rtg_stats[c].da != null){
                                                    home_rtg.da = away_rtg_stats[c].da.dangerous_attacks
                                                }
                                                home_rtg.cnr = away_rtg_stats[c].cnr
                                                home_rtg.goal = away_rtg_stats[c].goals
                                            }
                                            else{
                                                if(away_rtg_stats[c - 10].shots != null){
                                                    home_rtg.on = away_rtg_stats[c].shots.ongoal - away_rtg_stats[c - 10].shots.ongoal
                                                    home_rtg.off = away_rtg_stats[c].shots.offgoal - away_rtg_stats[c - 10].shots.offgoal
                                                }
                                                if(away_rtg_stats[c - 10].da != null){
                                                    home_rtg.da = away_rtg_stats[c].da.dangerous_attacks - away_rtg_stats[c - 10].da.dangerous_attacks
                                                }
                                                home_rtg.cnr = away_rtg_stats[c].cnr - away_rtg_stats[c - 10].cnr
                                                home_rtg.goal = away_rtg_stats[c].goals - away_rtg_stats[c - 10].goals
                                            }

                                            if((home_rtg.on >= 0) || (home_rtg.off >= 0) || (home_rtg.cnr >= 0) || (home_rtg.da > 0)){
                                                home_rtg.rtg = 0
                                                if(home_rtg.on >= 0){
                                                    home_rtg.rtg = home_rtg.rtg + home_rtg.on*3
                                                }
                                                if(home_rtg.off >= 0){
                                                    home_rtg.rtg = home_rtg.rtg + home_rtg.off*2
                                                }
                                                if(home_rtg.cnr >= 0){
                                                    home_rtg.rtg = home_rtg.rtg + home_rtg.cnr
                                                }
                                                if(home_rtg.da >= 0){
                                                    home_rtg.rtg = home_rtg.rtg + home_rtg.da
                                                }
                                            }
                                            else{
                                                home_rtg.rtg = '-'
                                            }
                                            
                                        }
                                    }
                                    home.id = current_main_data.home_id
                                    away.id = current_main_data.away_id
                                    home.score = current_main_data.scores.localteam_score
                                    away.score = current_main_data.scores.visitorteam_score
                                    let home_goal = current_main_data.scores.localteam_score
                                    let away_goal = current_main_data.scores.visitorteam_score
                                    let goal_tooltip = ''
                                    if(current_main_data.goal_tooltip){
                                        goal_tooltip = current_main_data.goal_tooltip
                                    }
                                    let home_tip_array = {
                                        'on': '',
                                        'off': '',
                                        'in': '',
                                        'out': '',
                                        'blk': '',
                                        'cnr': '',
                                        'onKey': this.create_UUID(),
                                        'offKey': this.create_UUID(),
                                        'inKey': this.create_UUID(),
                                        'outKey': this.create_UUID(),
                                        'blkKey': this.create_UUID(),
                                        'cnrKey': this.create_UUID()
                                    }
                                    let away_tip_array = {
                                        'on': '',
                                        'off': '',
                                        'in': '',
                                        'out': '',
                                        'blk': '',
                                        'cnr': '',
                                        'onKey': this.create_UUID(),
                                        'offKey': this.create_UUID(),
                                        'inKey': this.create_UUID(),
                                        'outKey': this.create_UUID(),
                                        'blkKey': this.create_UUID(),
                                        'cnrKey': this.create_UUID()
                                    }
                                    if(current_main_data.home_tip_shots){
                                        for(let n = 0 ; n < current_main_data.home_tip_shots.length - 1 ; n++){
                                            if(current_main_data.home_tip_shots[n].shots != null){
                                                if(n === 0 && current_main_data.home_tip_shots[n].shots.ongoal != 0 && current_main_data.home_tip_shots[n].shots.ongoal != null){
                                                    let time = current_main_data.home_tip_shots[n].time.minute
                                                    if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    home_tip_array.on = home_tip_array.on + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.home_tip_shots[n + 1].time.minute
                                                    if(current_main_data.home_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.home_tip_shots[n + 1].shots.ongoal >= 0 && current_main_data.home_tip_shots[n].shots.ongoal === null){
                                                        current_main_data.home_tip_shots[n].shots.ongoal = 0
                                                    }
                                                    let check1 = current_main_data.home_tip_shots[n + 1].shots.ongoal - current_main_data.home_tip_shots[n].shots.ongoal
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.home_tip_shots[n].shots.ongoal >= 0 && current_main_data.home_tip_shots[n - 1].shots.ongoal === null){
                                                            current_main_data.home_tip_shots[n - 1].shots.ongoal = 0
                                                        }
                                                        check2 = current_main_data.home_tip_shots[n].shots.ongoal - current_main_data.home_tip_shots[n - 1].shots.ongoal
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.home_tip_shots[n + 1].shots.ongoal = current_main_data.home_tip_shots[n].shots.ongoal
                                                    }

                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        home_tip_array.on = home_tip_array.on + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        home_tip_array.on = home_tip_array.on + " " + time + "(" + check1 + ")"
                                                    }
                                                }

                                                if(n === 0 && current_main_data.home_tip_shots[n].shots.offgoal != 0 && current_main_data.home_tip_shots[n].shots.offgoal != null){
                                                    let time = current_main_data.home_tip_shots[n].time.minute
                                                    if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    home_tip_array.off = home_tip_array.off + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.home_tip_shots[n + 1].time.minute
                                                    if(current_main_data.home_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.home_tip_shots[n + 1].shots.offgoal >= 0 && current_main_data.home_tip_shots[n].shots.offgoal === null){
                                                        current_main_data.home_tip_shots[n].shots.offgoal = 0
                                                    }
                                                    let check1 = current_main_data.home_tip_shots[n + 1].shots.offgoal - current_main_data.home_tip_shots[n].shots.offgoal
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.home_tip_shots[n].shots.offgoal >= 0 && current_main_data.home_tip_shots[n - 1].shots.offgoal === null){
                                                            current_main_data.home_tip_shots[n - 1].shots.offgoal = 0
                                                        }
                                                        check2 = current_main_data.home_tip_shots[n].shots.offgoal - current_main_data.home_tip_shots[n - 1].shots.offgoal
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.home_tip_shots[n + 1].shots.offgoal = current_main_data.home_tip_shots[n].shots.offgoal
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        home_tip_array.off = home_tip_array.off + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        home_tip_array.off = home_tip_array.off + " " + time + "(" + check1 + ")"
                                                    }
                                                }

                                                if(n === 0 && current_main_data.home_tip_shots[n].shots.insidebox != 0 && current_main_data.home_tip_shots[n].shots.insidebox != null){
                                                    let time = current_main_data.home_tip_shots[n].time.minute
                                                    if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    home_tip_array.in = home_tip_array.in + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.home_tip_shots[n + 1].time.minute
                                                    if(current_main_data.home_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.home_tip_shots[n + 1].shots.insidebox >= 0 && current_main_data.home_tip_shots[n].shots.insidebox === null){
                                                        current_main_data.home_tip_shots[n].shots.insidebox = 0
                                                    }
                                                    let check1 = current_main_data.home_tip_shots[n + 1].shots.insidebox - current_main_data.home_tip_shots[n].shots.insidebox
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.home_tip_shots[n].shots.insidebox >= 0 && current_main_data.home_tip_shots[n - 1].shots.insidebox === null){
                                                            current_main_data.home_tip_shots[n - 1].shots.insidebox = 0
                                                        }
                                                        check2 = current_main_data.home_tip_shots[n].shots.insidebox - current_main_data.home_tip_shots[n - 1].shots.insidebox
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.home_tip_shots[n + 1].shots.insidebox = current_main_data.home_tip_shots[n].shots.insidebox
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        home_tip_array.in = home_tip_array.in + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        home_tip_array.in = home_tip_array.in + " " + time + "(" + check1 + ")"
                                                    }
                                                }

                                                if(n === 0 && current_main_data.home_tip_shots[n].shots.outsidebox != 0 && current_main_data.home_tip_shots[n].shots.outsidebox != null){
                                                    let time = current_main_data.home_tip_shots[n].time.minute
                                                    if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    home_tip_array.out = home_tip_array.out + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.home_tip_shots[n + 1].time.minute
                                                    if(current_main_data.home_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.home_tip_shots[n + 1].shots.outsidebox >= 0 && current_main_data.home_tip_shots[n].shots.outsidebox === null){
                                                        current_main_data.home_tip_shots[n].shots.outsidebox = 0
                                                    }
                                                    let check1 = current_main_data.home_tip_shots[n + 1].shots.outsidebox - current_main_data.home_tip_shots[n].shots.outsidebox
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.home_tip_shots[n].shots.outsidebox >= 0 && current_main_data.home_tip_shots[n - 1].shots.outsidebox === null){
                                                            current_main_data.home_tip_shots[n - 1].shots.outsidebox = 0
                                                        }
                                                        check2 = current_main_data.home_tip_shots[n].shots.outsidebox - current_main_data.home_tip_shots[n - 1].shots.outsidebox
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.home_tip_shots[n + 1].shots.outsidebox = current_main_data.home_tip_shots[n].shots.outsidebox
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        home_tip_array.out = home_tip_array.out + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        home_tip_array.out = home_tip_array.out + " " + time + "(" + check1 + ")"
                                                    }
                                                }

                                                if(n === 0 && current_main_data.home_tip_shots[n].shots.blocked != 0 && current_main_data.home_tip_shots[n].shots.blocked != null){
                                                    let time = current_main_data.home_tip_shots[n].time.minute
                                                    if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    home_tip_array.blk = home_tip_array.blk + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.home_tip_shots[n + 1].time.minute
                                                    if(current_main_data.home_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.home_tip_shots[n + 1].shots.blocked >= 0 && current_main_data.home_tip_shots[n].shots.blocked === null){
                                                        current_main_data.home_tip_shots[n].shots.blocked = 0
                                                    }
                                                    let check1 = current_main_data.home_tip_shots[n + 1].shots.blocked - current_main_data.home_tip_shots[n].shots.blocked

                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.home_tip_shots[n].shots.blocked >= 0 && current_main_data.home_tip_shots[n - 1].shots.blocked === null ){
                                                            current_main_data.home_tip_shots[n - 1].shots.blocked = 0
                                                        }
                                                        check2 = current_main_data.home_tip_shots[n].shots.blocked - current_main_data.home_tip_shots[n - 1].shots.blocked
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.home_tip_shots[n + 1].shots.blocked = current_main_data.home_tip_shots[n].shots.blocked
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        home_tip_array.blk = home_tip_array.blk + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        home_tip_array.blk = home_tip_array.blk + " " + time + "(" + check1 + ")"
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    if(current_main_data.home_tip_cnr){
                                        for(let n = 0 ; n < current_main_data.home_tip_cnr.length - 1 ; n++){
                                            let time = current_main_data.home_tip_cnr[n].time.minute
                                            if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                time = time + "+" + current_main_data.home_tip_cnr[n].time.extra_time + "'"
                                            }
                                            if(n === 0 && current_main_data.home_tip_cnr[n].shots != 0 && current_main_data.home_tip_cnr[n].shots != null){
                                                home_tip_array.cnr = home_tip_array.cnr + " " + time
                                            }
                                            else{
                                                if(current_main_data.home_tip_cnr[n + 1].shots >= 0 && current_main_data.home_tip_cnr[n].shots === null){
                                                    current_main_data.home_tip_cnr[n].shots = 0
                                                }
                                                let check1 = current_main_data.home_tip_cnr[n + 1].shots - current_main_data.home_tip_cnr[n].shots
                                                let check2 = 0
                                                if(n >= 1){
                                                    if(current_main_data.home_tip_cnr[n].shots >= 0 && current_main_data.home_tip_cnr[n - 1].shots === null){
                                                        current_main_data.home_tip_cnr[n - 1].shots = 0
                                                    }
                                                    check2 = current_main_data.home_tip_cnr[n].shots - current_main_data.home_tip_cnr[n - 1].shots
                                                }
                                                if(check1 < 0){
                                                    current_main_data.home_tip_cnr[n + 1].shots =  current_main_data.home_tip_cnr[n].shots
                                                }

                                                if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                    home_tip_array.cnr = home_tip_array.cnr + " " + time
                                                }
                                                else if(check1 > 1 && check2 >= 0){
                                                    home_tip_array.cnr = home_tip_array.cnr + " " + time + "(" + check1 + ")"
                                                }
                                            }
                                        }
                                    }
                                    if(current_main_data.away_tip_shots){
                                        for(let n = 0 ; n < current_main_data.away_tip_shots.length - 1 ; n++){
                                            if(current_main_data.away_tip_shots[n].shots != null){

                                                if(n === 0 && current_main_data.away_tip_shots[n].shots.ongoal != 0 && current_main_data.away_tip_shots[n].shots.ongoal != null){
                                                    let time = current_main_data.away_tip_shots[n].time.minute
                                                    if(current_main_data.away_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    away_tip_array.on = away_tip_array.on + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.away_tip_shots[n + 1].time.minute
                                                    if(current_main_data.away_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.away_tip_shots[n + 1].shots.ongoal >= 0 && current_main_data.away_tip_shots[n].shots.ongoal === null){
                                                        current_main_data.away_tip_shots[n].shots.ongoal = 0
                                                    }
                                                    let check1 = current_main_data.away_tip_shots[n + 1].shots.ongoal - current_main_data.away_tip_shots[n].shots.ongoal
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.away_tip_shots[n].shots.ongoal >= 0 && current_main_data.away_tip_shots[n - 1].shots.ongoal === null){
                                                            current_main_data.away_tip_shots[n - 1].shots.ongoal = 0
                                                        }
                                                        check2 = current_main_data.away_tip_shots[n].shots.ongoal - current_main_data.away_tip_shots[n - 1].shots.ongoal
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.away_tip_shots[n + 1].shots.ongoal = current_main_data.away_tip_shots[n].shots.ongoal
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        away_tip_array.on = away_tip_array.on + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        away_tip_array.on = away_tip_array.on + " " + time + "(" + check1 + ")"
                                                    }
                                                }

                                                if(n === 0 && current_main_data.away_tip_shots[n].shots.offgoal != 0 && current_main_data.away_tip_shots[n].shots.offgoal != null){
                                                    let time = current_main_data.away_tip_shots[n].time.minute
                                                    if(current_main_data.away_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    away_tip_array.off = away_tip_array.off + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.away_tip_shots[n + 1].time.minute
                                                    if(current_main_data.away_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.away_tip_shots[n + 1].shots.offgoal >= 0 && current_main_data.away_tip_shots[n].shots.offgoal === null){
                                                        current_main_data.away_tip_shots[n].shots.offgoal = 0
                                                    }
                                                    let check1 = current_main_data.away_tip_shots[n + 1].shots.offgoal - current_main_data.away_tip_shots[n].shots.offgoal
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.away_tip_shots[n].shots.offgoal >= 0 && current_main_data.away_tip_shots[n - 1].shots.offgoal === null){
                                                            current_main_data.away_tip_shots[n - 1].shots.offgoal = 0
                                                        }
                                                        check2 = current_main_data.away_tip_shots[n].shots.offgoal - current_main_data.away_tip_shots[n - 1].shots.offgoal
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.away_tip_shots[n + 1].shots.offgoal = current_main_data.away_tip_shots[n].shots.offgoal
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        away_tip_array.off = away_tip_array.off + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        away_tip_array.off = away_tip_array.off + " " + time + "(" + check1 + ")"
                                                    }
                                                }

                                                if(n === 0 && current_main_data.away_tip_shots[n].shots.insidebox != 0 && current_main_data.away_tip_shots[n].shots.insidebox != null){
                                                    let time = current_main_data.away_tip_shots[n].time.minute
                                                    if(current_main_data.away_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    away_tip_array.in = away_tip_array.in + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.away_tip_shots[n + 1].time.minute
                                                    if(current_main_data.away_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.away_tip_shots[n + 1].shots.insidebox >= 0 && current_main_data.away_tip_shots[n].shots.insidebox === null){
                                                        current_main_data.away_tip_shots[n].shots.insidebox = 0
                                                    }
                                                    let check1 = current_main_data.away_tip_shots[n + 1].shots.insidebox - current_main_data.away_tip_shots[n].shots.insidebox
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.away_tip_shots[n].shots.insidebox >= 0 && current_main_data.away_tip_shots[n - 1].shots.insidebox === null){
                                                            current_main_data.away_tip_shots[n - 1].shots.insidebox = 0
                                                        }
                                                        check2 = current_main_data.away_tip_shots[n].shots.insidebox - current_main_data.away_tip_shots[n - 1].shots.insidebox
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.away_tip_shots[n + 1].shots.insidebox = current_main_data.away_tip_shots[n].shots.insidebox
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        away_tip_array.in = away_tip_array.in + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        away_tip_array.in = away_tip_array.in + " " + time + "(" + check1 + ")"
                                                    }
                                                }

                                                if(n === 0 && current_main_data.away_tip_shots[n].shots.outsidebox != 0 && current_main_data.away_tip_shots[n].shots.outsidebox != null){
                                                    let time = current_main_data.away_tip_shots[n].time.minute
                                                    if(current_main_data.away_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    away_tip_array.out = away_tip_array.out + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.away_tip_shots[n + 1].time.minute
                                                    if(current_main_data.away_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.away_tip_shots[n + 1].shots.outsidebox >= 0 && current_main_data.away_tip_shots[n].shots.outsidebox === null){
                                                        current_main_data.away_tip_shots[n].shots.outsidebox = 0
                                                    }
                                                    let check1 = current_main_data.away_tip_shots[n + 1].shots.outsidebox - current_main_data.away_tip_shots[n].shots.outsidebox
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.away_tip_shots[n].shots.outsidebox >= 0 && current_main_data.away_tip_shots[n - 1].shots.outsidebox === null){
                                                            current_main_data.away_tip_shots[n - 1].shots.outsidebox = 0
                                                        }
                                                        check2 = current_main_data.away_tip_shots[n].shots.outsidebox - current_main_data.away_tip_shots[n - 1].shots.outsidebox
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.away_tip_shots[n + 1].shots.outsidebox = current_main_data.away_tip_shots[n].shots.outsidebox
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        away_tip_array.out = away_tip_array.out + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        away_tip_array.out = away_tip_array.out + " " + time + "(" + check1 + ")"
                                                    }
                                                }

                                                if(n === 0 && current_main_data.away_tip_shots[n].shots.blocked != 0 && current_main_data.away_tip_shots[n].shots.blocked != null){
                                                    let time = current_main_data.away_tip_shots[n].time.minute
                                                    if(current_main_data.away_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    away_tip_array.blk = away_tip_array.blk + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.away_tip_shots[n + 1].time.minute
                                                    if(current_main_data.away_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.away_tip_shots[n + 1].shots.blocked >= 0 && current_main_data.away_tip_shots[n].shots.blocked === null){
                                                        current_main_data.away_tip_shots[n].shots.blocked = 0
                                                    }
                                                    let check1 = current_main_data.away_tip_shots[n + 1].shots.blocked - current_main_data.away_tip_shots[n].shots.blocked
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.away_tip_shots[n].shots.blocked >= 0 && current_main_data.away_tip_shots[n - 1].shots.blocked === null){
                                                            current_main_data.away_tip_shots[n - 1].shots.blocked = 0
                                                        }
                                                        check2 = current_main_data.away_tip_shots[n].shots.blocked - current_main_data.away_tip_shots[n - 1].shots.blocked
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.away_tip_shots[n + 1].shots.blocked = current_main_data.away_tip_shots[n].shots.blocked
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        away_tip_array.blk = away_tip_array.blk + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        away_tip_array.blk = away_tip_array.blk + " " + time + "(" + check1 + ")"
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    if(current_main_data.away_tip_cnr){
                                        for(let n = 0 ; n < current_main_data.away_tip_cnr.length - 1 ; n++){
                                            let time = current_main_data.away_tip_cnr[n].time.minute
                                            if(current_main_data.away_tip_cnr[n].time.extra_time > 0){
                                                time = time + "+" + current_main_data.away_tip_cnr[n].time.extra_time + "'"
                                            }
                                            if(n === 0 && current_main_data.away_tip_cnr[n].shots > 0 && current_main_data.away_tip_cnr[n].shots != null){
                                                away_tip_array.cnr = away_tip_array.cnr + " " + time
                                                
                                            }
                                            else{
                                                if(current_main_data.away_tip_cnr[n + 1].shots >= 0 && current_main_data.away_tip_cnr[n].shots === null){
                                                    current_main_data.away_tip_cnr[n].shots = 0
                                                }
                                                let check1  = current_main_data.away_tip_cnr[n + 1].shots - current_main_data.away_tip_cnr[n].shots
                                                let check2 = 0
                                                if(n >= 1){
                                                    if(current_main_data.away_tip_cnr[n].shots >= 0 && current_main_data.away_tip_cnr[n - 1].shots === null){
                                                        current_main_data.away_tip_cnr[n - 1].shots = 0
                                                    }
                                                    check2  = current_main_data.away_tip_cnr[n].shots - current_main_data.away_tip_cnr[n - 1].shots
                                                }
                                                if(check1 < 0){
                                                    current_main_data.away_tip_cnr[n + 1].shots = current_main_data.away_tip_cnr[n].shots
                                                }
                                                if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                    away_tip_array.cnr = away_tip_array.cnr + " " + time
                                                }
                                                else if(check1 > 1 && check2 >= 0){
                                                    away_tip_array.cnr = away_tip_array.cnr + " " + time + "(" + check1 + ")"
                                                }
                                            }
                                        }
                                    }
                                    home.time = current_main_data.time.minute
                                    let tot_time = current_main_data.time.minute
                                    if (current_main_data.time.injury_time > 0) {
                                        home.time = current_main_data.time.minute + '+' + current_main_data.time.injury_time + "'"
                                        tot_time = current_main_data.time.minute + current_main_data.time.injury_time
                                    }
                                    if (current_main_data.time.status == 'HT') {
                                        home.time = 'HT'
                                        tot_time = 45
                                    }
                                    if(current_main_data.time.extra_minute > 0){
                                        home.time = current_main_data.time.minute + current_main_data.time.extra_minute + "'"
                                    }
                                    let stats = current_main_data.stats
                                    let stats_ten = current_main_data.stats_ten
                                    //-------------Total Part------------//
                                    if (current_main_data.home_id === stats[0].team_id) {
                                        if(stats[0].shots){
                                            homeT.on = stats[0].shots.ongoal
                                            awayT.on = stats[1].shots.ongoal
                                            homeT.off = stats[0].shots.offgoal
                                            awayT.off = stats[1].shots.offgoal
                                            homeT.blk = stats[0].shots.blocked
                                            awayT.blk = stats[1].shots.blocked
                                            homeT.in = stats[0].shots.insidebox
                                            awayT.in = stats[1].shots.insidebox
                                            homeT.out = stats[0].shots.outsidebox
                                            awayT.out = stats[1].shots.outsidebox
                                        }

                                        homeT.cnr = stats[0].corners
                                        awayT.cnr = stats[1].corners
                                        if(stats[0].attacks != null){
                                            homeT.da = stats[0].attacks.dangerous_attacks
                                            awayT.da = stats[1].attacks.dangerous_attacks
                                        }
                                        else{
                                            homeT.da = null
                                            awayT.da = null
                                        }
                                        homeT.sbst = stats[0].substitutions
                                        awayT.sbst = stats[1].substitutions
                                        homeT.poss = stats[0].possessiontime
                                        awayT.poss = stats[1].possessiontime
                                        homeT.red = stats[0].redcards
                                        awayT.red = stats[1].redcards
                                        homeT.yel = stats[0].yellowcards
                                        awayT.yel = stats[1].yellowcards
                                    }
                                    else {
                                        if(stats[1].shots){
                                            homeT.on = stats[1].shots.ongoal
                                            awayT.on = stats[0].shots.ongoal
                                            homeT.off = stats[1].shots.offgoal
                                            awayT.off = stats[0].shots.offgoal
                                            homeT.blk = stats[1].shots.blocked
                                            awayT.blk = stats[0].shots.blocked
                                            homeT.in = stats[1].shots.insidebox
                                            awayT.in = stats[0].shots.insidebox
                                            homeT.out = stats[1].shots.outsidebox
                                            awayT.out = stats[0].shots.outsidebox
                                        }

                                        homeT.cnr = stats[1].corners
                                        awayT.cnr = stats[0].corners
                                        if(stats[1].attacks != null){
                                            homeT.da = stats[1].attacks.dangerous_attacks
                                            awayT.da = stats[0].attacks.dangerous_attacks
                                        }
                                        else{
                                            homeT.da = null
                                            awayT.da = null
                                        }

                                        homeT.sbst = stats[1].substitutions
                                        awayT.sbst = stats[0].substitutions
                                        homeT.poss = stats[1].possessiontime
                                        awayT.poss = stats[0].possessiontime
                                        homeT.red = stats[1].redcards
                                        awayT.red = stats[0].redcards
                                        homeT.yel = stats[1].yellowcards
                                        awayT.yel = stats[0].yellowcards
                                    }

                                    if((home.on >= 0) || (home.off >= 0) || (home.cnr >= 0) || (home.da > 0)){
                                        if(home.on >= 0){
                                            home.rtg = home.rtg + home.on*3
                                        }
                                        if(home.off >= 0){
                                            home.rtg = home.rtg + home.off*2
                                        }
                                        if(home.cnr >= 0){
                                            home.rtg = home.rtg + home.cnr
                                        }
                                        if(home.da >= 0){
                                            home.rtg = home.rtg + home.da
                                        }
                                    }
                                    else{
                                        home.rtg = '-'
                                    }

                                    if((away.on >= 0) || (away.off >= 0) || (away.cnr >= 0) || (away.da > 0)){
                                        if(away.on >= 0){
                                            away.rtg = away.rtg + away.on*3
                                        }
                                        if(away.off >= 0){
                                            away.rtg = away.rtg + away.off*2
                                        }
                                        if(away.cnr >= 0){
                                            away.rtg = away.rtg + away.cnr
                                        }
                                        if(away.da >= 0){
                                            away.rtg = away.rtg + away.da
                                        }
                                    }
                                    else{
                                        away.rtg = '-'
                                    }
                                    home.gdr = '-'
                                    away.gdr = '-'
                                    homeT.nxt = '-'
                                    awayT.nxt = '-'
                                    homeT.rtg = '-'
                                    awayT.rtg = '-'
                                    if(current_main_data.historical_stats.length > 0){
                                        if(current_main_data.historical_stats[0].home_season){
                                            if(current_main_data.historical_stats[0].home_season.p > 0){
                                                home.gdr = 0
                                                homeT.rtg = 0
                                                if(current_main_data.historical_stats[0].home_season.on > 0){
                                                    home.last_on = current_main_data.historical_stats[0].home_season.on/current_main_data.historical_stats[0].home_season.p
                                                }
                                                if(current_main_data.historical_stats[0].home_season.off > 0){
                                                    home.last_off = current_main_data.historical_stats[0].home_season.off/current_main_data.historical_stats[0].home_season.p
                                                }
                                                if(current_main_data.historical_stats[0].home_season.cnr > 0){
                                                    home.last_cnr = current_main_data.historical_stats[0].home_season.cnr/current_main_data.historical_stats[0].home_season.p
                                                }
                                                if(current_main_data.historical_stats[0].home_season.da > 0){
                                                    home.last_da = current_main_data.historical_stats[0].home_season.da/current_main_data.historical_stats[0].home_season.p
                                                }
                                                if(current_main_data.historical_stats[0].home_season.goals > 0){
                                                    home.last_goal = current_main_data.historical_stats[0].home_season.goals/current_main_data.historical_stats[0].home_season.p
                                                }
                                                //----------average rtg-----------
                                                home.a_rtg = 0
                                                if(home.last_on > 0){
                                                    home.a_rtg = home.a_rtg + (home.last_on/9)*3
                                                }
                                                if(home.last_off > 0){
                                                    home.a_rtg = home.a_rtg + (home.last_off/9)*2
                                                }
                                                if(home.last_cnr > 0){
                                                    home.a_rtg = home.a_rtg + (home.last_cnr/9)
                                                }
                                                if(home.last_da > 0){
                                                    home.a_rtg = home.a_rtg + (home.last_da/9)
                                                }
                                                //--------------------------------

                                                if(home.last_goal > 0 && home.last_on > 0){
                                                    home.gdr = home.gdr + ((100*home.on/home.last_goal/home.last_on/9)*home.on)
                                                }
                                                if(home.last_goal > 0 && home.last_off > 0){
                                                    home.gdr = home.gdr + ( ( 100*home.off/home.last_goal/home.last_off/ 9 )*home.off )
                                                }
                                                if(home.last_goal > 0 && home.last_cnr > 0){
                                                    home.gdr = home.gdr + ((100*home.cnr/home.last_goal/home.last_cnr/9)*home.cnr )
                                                }
                                                if(home.last_goal > 0 && home.last_da > 0){
                                                    home.gdr = home.gdr + ((100*home.da/home.last_goal/home.last_da/9)*home.da )
                                                }
                                                home.gdr = home.gdr.toFixed(0)

                                                if(home_goal === 0){
                                                    homeT.nxt = 0
                                                    if(home.last_goal > 0 && home.last_on > 0){
                                                        homeT.nxt = homeT.nxt + ((homeT.on*90/tot_time/(home.last_on*home.last_goal/home.last_goal)))
                                                    }
                                                    if(home.last_goal > 0 && home.last_off > 0){
                                                        homeT.nxt = homeT.nxt + ((homeT.off*90/tot_time/(home.last_off*home.last_goal/home.last_goal)))
                                                    }
                                                    if(home.last_goal > 0 && home.last_cnr > 0){
                                                        homeT.nxt = homeT.nxt + ((homeT.cnr*90/tot_time/(home.last_cnr*home.last_goal/home.last_goal)))
                                                    }
                                                    if(home.last_goal > 0 && home.last_da > 0){
                                                        homeT.nxt = homeT.nxt + ((homeT.da*90/tot_time/(home.last_da*home.last_goal/home.last_goal)))
                                                    }
                                                    homeT.nxt = (homeT.nxt*100/4).toFixed(0)
                                                    homeT.nxt = -1 * homeT.nxt
                                                }
                                                else if(home_goal > 0){
                                                    homeT.nxt = 0
                                                    if(home.last_goal > 0 && home.last_on > 0){
                                                        homeT.nxt = homeT.nxt + ((homeT.on*90/tot_time/(home.last_on*home_goal/home.last_goal)))
                                                    }
                                                    if(home.last_goal > 0 && home.last_off > 0){
                                                        homeT.nxt = homeT.nxt + ((homeT.off*90/tot_time/(home.last_off*home_goal/home.last_goal)))
                                                    }
                                                    if(home.last_goal > 0 && home.last_cnr > 0){
                                                        homeT.nxt = homeT.nxt + ((homeT.cnr*90/tot_time/(home.last_cnr*home_goal/home.last_goal)))
                                                    }
                                                    if(home.last_goal > 0 && home.last_da > 0){
                                                        homeT.nxt = homeT.nxt + ((homeT.da*90/tot_time/(home.last_da*home_goal/home.last_goal)))
                                                    }
                                                    homeT.nxt = (homeT.nxt*100/4 - 100).toFixed(0)
                                                    homeT.nxt = -1 * homeT.nxt
                                                }

                                                if(home_goal > 0){
                                                    if(tot_time > 0 && home.last_on > 0 && homeT.on > 0){
                                                        homeT.rtg = homeT.rtg + homeT.on*90/tot_time/home.last_on
                                                    }
                                                    if(tot_time > 0 && home.last_off > 0 && homeT.off > 0){
                                                        homeT.rtg = homeT.rtg + homeT.off*90/tot_time/home.last_off
                                                    }
                                                    if(tot_time > 0 && home.last_cnr > 0 && homeT.cnr){
                                                        homeT.rtg = homeT.rtg + homeT.cnr*90/tot_time/home.last_cnr
                                                    }
                                                    if(tot_time > 0 && home.last_da > 0 && homeT.da > 0){
                                                        homeT.rtg = homeT.rtg + homeT.da*90/tot_time/home.last_da
                                                    }
                                                    if(tot_time > 0 && home.last_goal > 0){
                                                        homeT.rtg = homeT.rtg + home_goal*90/tot_time/home.last_goal
                                                    }
                                                    homeT.rtg = (homeT.rtg*20 - 100).toFixed(0)
                                                }
                                                else{
                                                    if(tot_time > 0 && home.last_on > 0 && homeT.on > 0){
                                                        homeT.rtg = homeT.rtg + homeT.on*90/tot_time/home.last_on
                                                    }
                                                    if(tot_time > 0 && home.last_off > 0 && homeT.off > 0){
                                                        homeT.rtg = homeT.rtg + homeT.off*90/tot_time/home.last_off
                                                    }
                                                    if(tot_time > 0 && home.last_cnr > 0 && homeT.cnr){
                                                        homeT.rtg = homeT.rtg + homeT.cnr*90/tot_time/home.last_cnr
                                                    }
                                                    if(tot_time > 0 && home.last_da > 0 && homeT.da > 0){
                                                        homeT.rtg = homeT.rtg + homeT.da*90/tot_time/home.last_da
                                                    }
                                                    homeT.rtg = (homeT.rtg*20 - 100).toFixed(0)
                                                }
                                            }
                                        }

                                        if(current_main_data.historical_stats[0].away_season){
                                            if(current_main_data.historical_stats[0].away_season.p > 0){
                                                away.gdr = 0
                                                awayT.rtg = 0
                                                if(current_main_data.historical_stats[0].away_season.on > 0){
                                                    away.last_on = current_main_data.historical_stats[0].away_season.on/current_main_data.historical_stats[0].away_season.p
                                                }
                                                if(current_main_data.historical_stats[0].away_season.off > 0){
                                                    away.last_off = current_main_data.historical_stats[0].away_season.off/current_main_data.historical_stats[0].away_season.p
                                                }
                                                if(current_main_data.historical_stats[0].away_season.cnr > 0){
                                                    away.last_cnr = current_main_data.historical_stats[0].away_season.cnr/current_main_data.historical_stats[0].away_season.p
                                                }
                                                if(current_main_data.historical_stats[0].away_season.da > 0){
                                                    away.last_da = current_main_data.historical_stats[0].away_season.da/current_main_data.historical_stats[0].away_season.p
                                                }
                                                if(current_main_data.historical_stats[0].away_season.goals > 0){
                                                    away.last_goal = current_main_data.historical_stats[0].away_season.goals/current_main_data.historical_stats[0].away_season.p
                                                }

                                                if(away.last_goal > 0 && away.last_on > 0){
                                                    away.gdr = away.gdr + ((100*away.on/away.last_goal/away.last_on/9)*away.on)
                                                }
                                                if(away.last_goal > 0 && away.last_off > 0){
                                                    away.gdr = away.gdr + ( ( 100*away.off/away.last_goal/away.last_off/ 9 )*away.off )
                                                }
                                                if(away.last_goal > 0 && away.last_cnr > 0){
                                                    away.gdr = away.gdr + ((100*away.cnr/away.last_goal/away.last_cnr/9)*away.cnr )
                                                }
                                                if(away.last_goal > 0 && away.last_da > 0){
                                                    away.gdr = away.gdr + ((100*away.da/away.last_goal/away.last_da/9)*away.da )
                                                }
                                                away.gdr = away.gdr.toFixed(0)

                                                //---------------away average rtg-------------------
                                                away.a_rtg = 0
                                                if(away.last_on > 0){
                                                    away.a_rtg = away.a_rtg + (away.last_on/9)*3
                                                }
                                                if(away.last_off > 0){
                                                    away.a_rtg = away.a_rtg + (away.last_off/9)*2
                                                }
                                                if(away.last_cnr > 0){
                                                    away.a_rtg = away.a_rtg + (away.last_cnr/9)
                                                }
                                                if(home.last_da > 0){
                                                    away.a_rtg = away.a_rtg + (away.last_da/9)
                                                }
                                                //----------------------------------------------

                                                if(away_goal === 0){
                                                    awayT.nxt = 0
                                                    if(away.last_goal > 0 && away.last_on > 0){
                                                        awayT.nxt = awayT.nxt + ((awayT.on*90/tot_time/(away.last_on*away.last_goal/away.last_goal)))
                                                    }
                                                    if(away.last_goal > 0 && away.last_off > 0){
                                                        awayT.nxt = awayT.nxt + ((awayT.off*90/tot_time/(away.last_off*away.last_goal/away.last_goal)))
                                                    }
                                                    if(away.last_goal > 0 && away.last_cnr > 0){
                                                        awayT.nxt = awayT.nxt + ((awayT.cnr*90/tot_time/(away.last_cnr*away.last_goal/away.last_goal)))
                                                    }
                                                    if(away.last_goal > 0 && away.last_da > 0){
                                                        awayT.nxt = awayT.nxt + ((awayT.da*90/tot_time/(away.last_da*away.last_goal/away.last_goal)))
                                                    }
                                                    awayT.nxt =(awayT.nxt*100/4).toFixed(0)
                                                    awayT.nxt = -1 * awayT.nxt
                                                }
                                                else if(away_goal > 0){
                                                    awayT.nxt = 0
                                                    if(away.last_goal > 0 && away.last_on > 0){
                                                        awayT.nxt = awayT.nxt + ((awayT.on*90/tot_time/(away.last_on*away_goal/away.last_goal)))
                                                    }
                                                    if(away.last_goal > 0 && away.last_off > 0){
                                                        awayT.nxt = awayT.nxt + ((awayT.off*90/tot_time/(away.last_off*away_goal/away.last_goal)))
                                                    }
                                                    if(away.last_goal > 0 && away.last_cnr > 0){
                                                        awayT.nxt = awayT.nxt + ((awayT.cnr*90/tot_time/(away.last_cnr*away_goal/away.last_goal)))
                                                    }
                                                    if(away.last_goal > 0 && away.last_da > 0){
                                                        awayT.nxt = awayT.nxt + ((awayT.da*90/tot_time/(away.last_da*away_goal/away.last_goal)))
                                                    }
                                                    awayT.nxt =(awayT.nxt*100/4 - 100).toFixed(0)
                                                    awayT.nxt = -1 * awayT.nxt
                                                }

                                                if(away_goal > 0){
                                                    if(tot_time > 0 && away.last_on > 0 && awayT.on > 0){
                                                        awayT.rtg = awayT.rtg + awayT.on*90/tot_time/away.last_on
                                                    }
                                                    if(tot_time > 0 && away.last_off > 0 && awayT.off > 0){
                                                        awayT.rtg = awayT.rtg + awayT.off*90/tot_time/away.last_off
                                                    }
                                                    if(tot_time > 0 && away.last_cnr > 0 && awayT.cnr > 0){
                                                        awayT.rtg = awayT.rtg + awayT.cnr*90/tot_time/away.last_cnr
                                                    }
                                                    if(tot_time > 0 && away.last_da > 0 && awayT.da > 0){
                                                        awayT.rtg = awayT.rtg + awayT.da*90/tot_time/away.last_da
                                                    }
                                                    if(tot_time > 0 && away.last_goal > 0){
                                                        awayT.rtg = awayT.rtg + away_goal*90/tot_time/away.last_goal
                                                    }
                                                    awayT.rtg = (awayT.rtg*20 - 100).toFixed(0)
                                                }
                                                else{
                                                    if(tot_time > 0 && away.last_on > 0 && awayT.on > 0){
                                                        awayT.rtg = awayT.rtg + awayT.on*90/tot_time/away.last_on
                                                    }
                                                    if(tot_time > 0 && away.last_off > 0 && awayT.off > 0){
                                                        awayT.rtg = awayT.rtg + awayT.off*90/tot_time/away.last_off
                                                    }
                                                    if(tot_time > 0 && away.last_cnr > 0 && awayT.cnr > 0){
                                                        awayT.rtg = awayT.rtg + awayT.cnr*90/tot_time/away.last_cnr
                                                    }
                                                    if(tot_time > 0 && away.last_da > 0 && awayT.da > 0){
                                                        awayT.rtg = awayT.rtg + awayT.da*90/tot_time/away.last_da
                                                    }
                                                    awayT.rtg = (awayT.rtg*20 - 100).toFixed(0)
                                                }
                                            }
                                        }
                                    }

                                    current_main_data.stats = stats
                                    current_main_data.stats_ten = stats_ten
                                    main_data[j] = current_main_data
                                    this.finishedArray[i].events.push({
                                        'home_name': current_main_data.home_name + '(' + current_main_data.home_rank + ')',
                                        "away_name": current_main_data.away_name + '(' + current_main_data.away_rank + ")",
                                        "status": current_main_data.time.status,
                                        "home_score": home.score,
                                        "away_score": away.score,
                                        "home_season": home_season,
                                        "away_season": away_season,
                                        "yellowcards": "",
                                        "redcards": "",
                                        
                                        'main_data': main_data[j],
                                        'goal_tooltip': goal_tooltip,
                                        'goalKey': this.create_UUID(),
                                        'homeT': homeT,
                                        'awayT': awayT,
                                        'home': home,
                                        'away': away,
                                        'home_tooltip': home_tip_array,
                                        'away_tooltip': away_tip_array,
                                        'season_id': main_data[j].season_id,
                                    })
                                }
                            }
                        }
                    }
                    
                    let self = this
                    this.sortJSON(self.finishedArray,'league', '123')
                })
            },
            percallfunction(){
                this.current_counter = 0
                clearInterval(this.clock)
                this.clock = setInterval(this.frame1, 9000)
            },
            callHistoricalData(home_id, away_id, season_id, eventName, home_rtg, home_a_rtg, away_rtg, away_a_rtg, fixtureId){
                
                this.historicModalData = {
                    "eventName": "",
                    "home_season": {
                        'on': 0,
                        'off': 0,
                        'block': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'pos': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'fou': 0 ,
                        'g_att': 0 ,
                        'safe': 0,
                        'goals':0
                    },
                    "away_season": {
                        'on': 0,
                        'off': 0,
                        'block': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'pos': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'fou': 0 ,
                        'g_att': 0 ,
                        'safe': 0,
                        'goals': 0
                    },
                    "home_p": 0,
                    "away_p": 0,
                    "home_rtg": home_rtg,
                    "home_a_rtg": home_a_rtg,
                    "away_rtg": away_rtg,
                    "away_a_rtg": away_a_rtg
                }
                this.historicModalData.eventName = eventName
                this.isload = false
                this.current_counter = 0
                clearInterval(this.clock)
                this.clock = setInterval(this.frame, 100)
                window.axios.post(`${process.env.VUE_APP_URL}getLiveEventHistory`, [fixtureId]).then(({data})=> {
                    
                    this.isload = true;
                    
                    let seasonData = data.data[0][0]
                    let home_poss_index = 0
                    let away_poss_index = 0
                    let home_p = 0
                    let away_p = 0
                    let home_season = {}
                    let away_season = {}
                    if(seasonData.home_season){
                        home_p = seasonData.home_season.p
                        away_p = seasonData.away_season.p
                        home_season = seasonData.home_season
                        away_season = seasonData.away_season
                    }

                    this.flatodds = {
                        "h_win": "-",
                        "a_win": "-",
                        "d_win": "-",
                        "o_05": "-",
                        "o_15": "-",
                        "o_25": "-",
                        "o_35": "-",
                        "u_05": "-",
                        "u_15": "-",
                        "u_25": "-",
                        "u_35": "-",
                        "o_05_ht": "-",
                        "u_05_ht": "-",
                        "bts_yes": "-",
                        "bts_no": "-",
                        prob_home: "-",
                        prob_draw: "-",
                        prob_away : "-",
                        prob_over05: "-",
                        prob_over15: "-",
                        prob_over25 : "-",
                        prob_over35 : "-",
                        prob_bts: "-",
                        prob_over05_ht: "-",

                        prob_under05: "-",
                        prob_under15: "-",
                        prob_under25 : "-",
                        prob_under35: "-",

                        prob_bts_no: "-",
                        prob_under05_ht: "-",

                        prob_home_tt1: null,
                        prob_home_tt2: null,
                        prob_away_tt1: null,
                        prob_away_tt2: null,
                        prob_draw_tt1: null,
                        prob_draw_tt2: null,
                        prob_over05_tt1: null,
                        prob_over05_tt2: null,
                        prob_over15_tt1: null,
                        prob_over15_tt2: null,
                        prob_over25_tt1: null,
                        prob_over25_tt2: null,
                        prob_over35_tt1: null,
                        prob_over35_tt2: null,
                        prob_under05_tt1: null,
                        prob_under05_tt2: null,
                        prob_under15_tt1: null,
                        prob_under15_tt2: null,
                        prob_under25_tt1: null,
                        prob_under25_tt2: null,
                        prob_under35_tt1: null,
                        prob_under35_tt2: null,
                        prob_over05_ht_tt1: null,
                        prob_over05_ht_tt2: null,
                        prob_under05_ht_tt1: null,
                        prob_under05_ht_tt2: null,
                        prob_bts_tt1: null,
                        prob_bts_tt2: null,
                        prob_bts_no_tt1: null,
                        prob_bts_no_tt2: null,

                    };
                    this.matches_sample = 0;
                    
                    if (seasonData.DailyFixtures.length != 0) {
                        seasonData.DailyFixtures[0].flatOdds.data.forEach((oItem) => {
                            let mkt_id = oItem.market_id;
                            if(oItem.bookmaker_id === 2) {
                                let suffix;
                                if(mkt_id === 1 || mkt_id === 12 || mkt_id === 976105  || mkt_id === 136703813 || mkt_id === 137918022 || mkt_id === 28077 || mkt_id === 1256989864) 
                                    suffix = 'FT';
                                else if(mkt_id === 37 || mkt_id === 31379 || mkt_id === 975903 || mkt_id === 976226)
                                    suffix = 'HT';
                                (oItem.odds || oItem.values).forEach((item) => {
                                    let label;
                                    if(item.label)
                                        label = `${item.label}${item.total ? ' - ' + item.total : ''}`;
                                    else if(item.team)
                                        label = item.team;
                                    else if(item.info) {
                                        label = item.info;
                                    }
                                    if(label === 'Yes')
                                        label = 'BTS';
                                    else if(label === 'No')
                                        label = 'No BTS';
                                    if(label === '1')
                                        label = "Home";
                                    else if(label === '2')
                                        label = 'Away';
                                    else if(label === 'X')
                                        label = 'Draw';
                                    if(!label.includes(",")) {              //except over 2.0,2.5 case
                                        label = `${label} - ${suffix}`
                                        if(label == 'Home - FT') {
                                            
                                            this.flatodds.h_win = parseFloat(item.value)
                                        }
                                        else if(label == 'Away - FT') {
                                            this.flatodds.a_win = parseFloat(item.value)
                                        }
                                        else if(label == 'Draw - FT') {
                                            
                                            this.flatodds.d_win = parseFloat(item.value)
                                        }

                                        else if(label == "Over - 0.5 - FT")
                                            this.flatodds.o_05 = parseFloat(item.value)
                                        else if(label == "Over - 1.5 - FT")
                                            this.flatodds.o_15 = parseFloat(item.value)
                                        else if(label == "Over - 2.5 - FT")
                                            this.flatodds.o_25 = parseFloat(item.value)
                                        else if(label == "Over - 3.5 - FT")
                                            this.flatodds.o_35 = parseFloat(item.value)

                                        else if(label == "Under - 0.5 - FT")
                                            this.flatodds.u_05 = parseFloat(item.value)
                                        else if(label == "Under - 1.5 - FT")
                                            this.flatodds.u_15  = parseFloat(item.value)
                                        else if(label == "Under - 2.5 - FT")
                                            this.flatodds.u_25  = parseFloat(item.value)
                                        else if(label == "Under - 3.5 - FT")
                                            this.flatodds.u_35  = parseFloat(item.value)

                                        else if(label == "BTS - FT")
                                            this.flatodds.bts_yes  = parseFloat(item.value)
                                        else if(label == "No BTS - FT")
                                            this.flatodds.bts_no = parseFloat(item.value)

                                        else if(label == "Over - 0.5 - HT")
                                            this.flatodds.o_05_ht = parseFloat(item.value)
                                        else if(label == "Under - 0.5 - HT")
                                            this.flatodds.u_05_ht = parseFloat(item.value)

                                        // event_odds_list.push({
                                        //     label: `${label} - ${suffix}`,
                                        //     value: `${label} - ${suffix}`.trim(),
                                        //     odd: parseFloat(item.value)
                                        // });
                                    }
                                });
                            }
                        });


                        var oddslines = null;
                        if ( seasonData.league5yearsStats.length > 0 ) {
                            oddslines = seasonData.league5yearsStats[0].oddslines;                            

                            var odds = null;
                            let home_odds = 100;
                            if (this.flatodds.h_win !== "-")
                                home_odds = this.flatodds.h_win;
                            let away_odds = 100;
                            if (this.flatodds.a_win !== "-")
                                away_odds = this.flatodds.a_win;
                            
                            if (home_odds <= 3 && away_odds <= 3) {
                                odds = oddslines[3]
                            }
                            else if (home_odds <= 1.5) {
                                odds = oddslines[0]
                            }
                            else if (home_odds > 1.5 && home_odds <= 2) {
                                odds = oddslines[1]
                            }
                            else if (home_odds > 2 && home_odds <= 3) {
                                odds = oddslines[2]
                            }
                            
                            else if (away_odds <= 1.5) {
                                odds = oddslines[4]
                            }
                            else if (away_odds > 1.5 && away_odds <= 2) {
                                odds = oddslines[5]
                            }
                            else if (away_odds > 2 && away_odds <= 3) {
                                odds = oddslines[6]
                            }
                            
                            if (odds) {
                                this.flatodds.prob_home = parseInt(odds.home_win_percent)
                                this.flatodds.prob_draw = parseInt(odds.draw_win_percent)
                                this.flatodds.prob_away = parseInt(odds.away_win_percent)
                                this.flatodds.prob_over05 = parseInt(odds.full_05_percent)
                                this.flatodds.prob_over15 = parseInt(odds.full_15_percent)
                                this.flatodds.prob_over25 = parseInt(odds.full_25_percent)
                                this.flatodds.prob_over35 = parseInt(odds.full_35_percent)
                                this.flatodds.prob_bts = parseInt(odds.bts_percent)
                                this.flatodds.prob_over05_ht = parseInt(odds.first_05_percent)

                                this.flatodds.prob_under05 = 100 - parseInt(odds.full_05_percent)
                                this.flatodds.prob_under15 = 100 - parseInt(odds.full_15_percent)
                                this.flatodds.prob_under25 = 100 - parseInt(odds.full_25_percent)
                                this.flatodds.prob_under35 = 100 - parseInt(odds.full_35_percent)

                                this.flatodds.prob_bts_no = 100 - parseInt(odds.bts_percent)
                                this.flatodds.prob_under05_ht = 100 - parseInt(odds.first_05_percent)

                                this.matches_sample = odds.total_matches;
                            }

                            if (this.flatodds.prob_home !== "-" && this.flatodds.h_win !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.h_win, this.flatodds.prob_home)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_home_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_home_tt2 = value.toFixed(2)                                    
                            }

                            if (this.flatodds.prob_draw !== "-" && this.flatodds.d_win !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.d_win, this.flatodds.prob_draw)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_draw_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_draw_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_away !== "-" && this.flatodds.a_win !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.a_win, this.flatodds.prob_away)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_away_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_away_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_over05 !== "-" && this.flatodds.o_05 !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.o_05, this.flatodds.prob_over05)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_over05_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_over05_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_over15 !== "-" && this.flatodds.o_15 !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.o_15, this.flatodds.prob_over15)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_over15_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_over15_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_over25 !== "-" && this.flatodds.o_25 !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.o_25, this.flatodds.prob_over25)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_over25_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_over25_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_over35 !== "-" && this.flatodds.o_35 !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.o_35, this.flatodds.prob_over35)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_over35_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_over35_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_under05 !== "-" && this.flatodds.u_05 !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.u_05, this.flatodds.prob_under05)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_under05_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_under05_tt2 = value.toFixed(2)
                            }
                            if (this.flatodds.prob_under15 !== "-" && this.flatodds.u_15 !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.u_15, this.flatodds.prob_under15)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_under15_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_under15_tt2 = value.toFixed(2)
                            }
                            if (this.flatodds.prob_under25 !== "-" && this.flatodds.oddsu_25_under25 !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.u_25, this.flatodds.prob_under25)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_under25_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_under25_tt2 = value.toFixed(2)
                            }
                            if (this.flatodds.prob_under35 !== "-" && this.flatodds.u_35 !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.u_35, this.flatodds.prob_under35)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_under35_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_under35_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_over05_ht !== "-" && this.flatodds.o_05_ht !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.o_05_ht, this.flatodds.prob_over05_ht)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_over05_ht_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_over05_ht_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_under05_ht !== "-" && this.flatodds.u_05_ht !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.u_05_ht, this.flatodds.prob_under05_ht)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_under05_ht_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_under05_ht_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_bts !== "-" && this.flatodds.bts_yes !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.bts_yes, this.flatodds.prob_bts)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_bts_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_bts_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_bts_no !== "-" && this.flatodds.bts_no !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.bts_no, this.flatodds.prob_bts_no)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_bts_no_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_bts_no_tt2 = value.toFixed(2)
                            }
                        }
                        if (this.matches_sample == 0) {
                            this.flatodds = {
                                "h_win": "-",
                                "a_win": "-",
                                "d_win": "-",
                                "o_05": "-",
                                "o_15": "-",
                                "o_25": "-",
                                "o_35": "-",
                                "u_05": "-",
                                "u_15": "-",
                                "u_25": "-",
                                "u_35": "-",
                                "o_05_ht": "-",
                                "u_05_ht": "-",
                                "bts_yes": "-",
                                "bts_no": "-",
                                prob_home: "-",
                                prob_draw: "-",
                                prob_away : "-",
                                prob_over05: "-",
                                prob_over15: "-",
                                prob_over25 : "-",
                                prob_over35 : "-",
                                prob_bts: "-",
                                prob_over05_ht: "-",

                                prob_under05: "-",
                                prob_under15: "-",
                                prob_under25 : "-",
                                prob_under35: "-",

                                prob_bts_no: "-",
                                prob_under05_ht: "-",

                                prob_home_tt1: null,
                                prob_home_tt2: null,
                                prob_away_tt1: null,
                                prob_away_tt2: null,
                                prob_draw_tt1: null,
                                prob_draw_tt2: null,
                                prob_over05_tt1: null,
                                prob_over05_tt2: null,
                                prob_over15_tt1: null,
                                prob_over15_tt2: null,
                                prob_over25_tt1: null,
                                prob_over25_tt2: null,
                                prob_over35_tt1: null,
                                prob_over35_tt2: null,
                                prob_under05_tt1: null,
                                prob_under05_tt2: null,
                                prob_under15_tt1: null,
                                prob_under15_tt2: null,
                                prob_under25_tt1: null,
                                prob_under25_tt2: null,
                                prob_under35_tt1: null,
                                prob_under35_tt2: null,
                                prob_over05_ht_tt1: null,
                                prob_over05_ht_tt2: null,
                                prob_under05_ht_tt1: null,
                                prob_under05_ht_tt2: null,
                                prob_bts_tt1: null,
                                prob_bts_tt2: null,
                                prob_bts_no_tt1: null,
                                prob_bts_no_tt2: null,

                            };
                        }
                    }

                    
                    let rtgTime = []
                    let homeRS = []
                    let awayRS = []

                    if (seasonData.liveStatsT.length > 0) {
                        let home_rtg_stats = seasonData.liveStatsT[0].home_rtg_stats
                        let away_rtg_stats = seasonData.liveStatsT[0].away_rtg_stats
                        if(home_rtg_stats){
                            for(let c = 0; c < home_rtg_stats.length; c++){
                                let minute = home_rtg_stats[c].time.minute
                                let half_extra_time = 0;
                                let home_rtg = {
                                    'on': null,
                                    'off': null,
                                    'cnr': null,
                                    'da': null,
                                    'goal': null,
                                    'rtg': null
                                }

                                if(home_rtg_stats[c].time.extra_time != null){
                                    minute = home_rtg_stats[c].time.minute + home_rtg_stats[c].time.extra_time
                                    if(home_rtg_stats[c].time.minute < 46){
                                        half_extra_time = home_rtg_stats[c].time.extra_time
                                    }
                                }
                                if(home_rtg_stats[c].time.minute > 45){
                                    minute = minute + half_extra_time
                                }
                                rtgTime.push(minute)

                                if(c <= 10){
                                    if(home_rtg_stats[c].shots != null){
                                        home_rtg.on = home_rtg_stats[c].shots.ongoal
                                        home_rtg.off = home_rtg_stats[c].shots.offgoal
                                    }
                                    if(home_rtg_stats[c].da != null){
                                        home_rtg.da = home_rtg_stats[c].da.dangerous_attacks
                                    }
                                    home_rtg.cnr = home_rtg_stats[c].cnr
                                    home_rtg.goal = home_rtg_stats[c].goals
                                }
                                else{
                                    if(home_rtg_stats[c - 10].shots != null){
                                        home_rtg.on = home_rtg_stats[c].shots.ongoal - home_rtg_stats[c - 10].shots.ongoal
                                        home_rtg.off = home_rtg_stats[c].shots.offgoal - home_rtg_stats[c - 10].shots.offgoal
                                    }
                                    if(home_rtg_stats[c - 10].da != null){
                                        home_rtg.da = home_rtg_stats[c].da.dangerous_attacks - home_rtg_stats[c - 10].da.dangerous_attacks
                                    }
                                    home_rtg.cnr = home_rtg_stats[c].cnr - home_rtg_stats[c - 10].cnr
                                    home_rtg.goal = home_rtg_stats[c].goals - home_rtg_stats[c - 10].goals
                                }

                                if((home_rtg.on >= 0) || (home_rtg.off >= 0) || (home_rtg.cnr >= 0) || (home_rtg.da > 0)){
                                    home_rtg.rtg = 0
                                    if(home_rtg.on >= 0){
                                        home_rtg.rtg = home_rtg.rtg + home_rtg.on*3
                                    }
                                    if(home_rtg.off >= 0){
                                        home_rtg.rtg = home_rtg.rtg + home_rtg.off*2
                                    }
                                    if(home_rtg.cnr >= 0){
                                        home_rtg.rtg = home_rtg.rtg + home_rtg.cnr
                                    }
                                    if(home_rtg.da >= 0){
                                        home_rtg.rtg = home_rtg.rtg + home_rtg.da
                                    }
                                }
                                else{
                                    home_rtg.rtg = '-'
                                }
                                homeRS.push(home_rtg.rtg)
                            }
                        }
                        if(away_rtg_stats){
                            for(let c = 0; c < away_rtg_stats.length; c++){
                                let home_rtg = {
                                    'on': null,
                                    'off': null,
                                    'cnr': null,
                                    'da': null,
                                    'goal': null,
                                    'rtg': null
                                }
                                if(c <= 10){
                                    if(away_rtg_stats[c].shots != null){
                                        home_rtg.on = away_rtg_stats[c].shots.ongoal
                                        home_rtg.off = away_rtg_stats[c].shots.offgoal
                                    }
                                    if(away_rtg_stats[c].da != null){
                                        home_rtg.da = away_rtg_stats[c].da.dangerous_attacks
                                    }
                                    home_rtg.cnr = away_rtg_stats[c].cnr
                                    home_rtg.goal = away_rtg_stats[c].goals
                                }
                                else{
                                    if(away_rtg_stats[c - 10].shots != null){
                                        home_rtg.on = away_rtg_stats[c].shots.ongoal - away_rtg_stats[c - 10].shots.ongoal
                                        home_rtg.off = away_rtg_stats[c].shots.offgoal - away_rtg_stats[c - 10].shots.offgoal
                                    }
                                    if(away_rtg_stats[c - 10].da != null){
                                        home_rtg.da = away_rtg_stats[c].da.dangerous_attacks - away_rtg_stats[c - 10].da.dangerous_attacks
                                    }
                                    home_rtg.cnr = away_rtg_stats[c].cnr - away_rtg_stats[c - 10].cnr
                                    home_rtg.goal = away_rtg_stats[c].goals - away_rtg_stats[c - 10].goals
                                }

                                if((home_rtg.on >= 0) || (home_rtg.off >= 0) || (home_rtg.cnr >= 0) || (home_rtg.da > 0)){
                                    home_rtg.rtg = 0
                                    if(home_rtg.on >= 0){
                                        home_rtg.rtg = home_rtg.rtg + home_rtg.on*3
                                    }
                                    if(home_rtg.off >= 0){
                                        home_rtg.rtg = home_rtg.rtg + home_rtg.off*2
                                    }
                                    if(home_rtg.cnr >= 0){
                                        home_rtg.rtg = home_rtg.rtg + home_rtg.cnr
                                    }
                                    if(home_rtg.da >= 0){
                                        home_rtg.rtg = home_rtg.rtg + home_rtg.da
                                    }
                                }
                                else{
                                    home_rtg.rtg = '-'
                                }
                                awayRS.push(-home_rtg.rtg)
                            }
                        }
                    }


                    for(let i = 0 ; i < this.eventArray.length ; i++){
                        for(let j = 0 ; j < this.eventArray[i].events.length ; j++){
                            
                            if(this.eventArray[i].events[j].home.id == home_id && this.eventArray[i].events[j].away.id == away_id){
                                this.historicModalData.home_season = Object.assign(home_season)
                                this.historicModalData.away_season = Object.assign(away_season)
                                this.historicModalData.home_p = home_p
                                this.historicModalData.away_p = away_p
                                // this.data[0].x = this.eventArray[i].events[j].chart.time
                                // this.data[1].x = this.eventArray[i].events[j].chart.time
                                // this.data[0].y = this.eventArray[i].events[j].chart.homeRTG
                                // this.data[1].y = this.eventArray[i].events[j].chart.awayRTG
                                this.data[0].x = rtgTime
                                this.data[1].x = rtgTime
                                this.data[0].y = homeRS
                                this.data[1].y = awayRS

                                this.data[0].name = this.eventArray[i].events[j].main_data.home_name
                                this.data[1].name = this.eventArray[i].events[j].main_data.away_name
                                this.historicModalData.eventName = this.eventArray[i].events[j].main_data.home_name + " v " + this.eventArray[i].events[j].main_data.away_name
                                // this.eventArray[i].events[j].show = true
                            }
                        }
                    }
                    for(let i = 0 ; i < this.finishedArray.length ; i++){
                        for(let j = 0 ; j < this.finishedArray[i].events.length ; j++){
                            
                            if(this.finishedArray[i].events[j].home.id == home_id && this.finishedArray[i].events[j].away.id == away_id){
                                this.historicModalData.home_season = Object.assign(home_season)
                                this.historicModalData.away_season = Object.assign(away_season)
                                this.historicModalData.home_p = home_p
                                this.historicModalData.away_p = away_p
                                // this.data[0].x = this.finishedArray[i].events[j].chart.time
                                // this.data[1].x = this.finishedArray[i].events[j].chart.time
                                // this.data[0].y = this.finishedArray[i].events[j].chart.homeRTG
                                // this.data[1].y = this.finishedArray[i].events[j].chart.awayRTG

                                this.data[0].x = rtgTime
                                this.data[1].x = rtgTime
                                this.data[0].y = homeRS
                                this.data[1].y = awayRS

                                this.data[0].name = this.finishedArray[i].events[j].main_data.home_name
                                this.data[1].name = this.finishedArray[i].events[j].main_data.away_name
                                this.historicModalData.eventName = this.finishedArray[i].events[j].main_data.home_name + " v " + this.finishedArray[i].events[j].main_data.away_name
                                // this.eventArray[i].events[j].show = true
                            }
                        }
                    }

                    this.percallfunction()
                })
            },
            callHistoricalData1(home_id, away_id, season_id, eventName, home_rtg, home_a_rtg, away_rtg, away_a_rtg, fixtureId){
                console.log('home_id, away_id====>', home_id, away_id, home_rtg, home_a_rtg, away_rtg, away_a_rtg)
                console.log('stage_id=======>', fixtureId)
                this.historicModalData = {
                    "eventName": "",
                    "home_season": {
                        'on': 0,
                        'off': 0,
                        'block': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'pos': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'fou': 0 ,
                        'g_att': 0 ,
                        'safe': 0,
                        'goals':0
                    },
                    "away_season": {
                        'on': 0,
                        'off': 0,
                        'block': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'pos': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'fou': 0 ,
                        'g_att': 0 ,
                        'safe': 0,
                        'goals': 0
                    },
                    "home_p": 0,
                    "away_p": 0,
                    "home_rtg": home_rtg,
                    "home_a_rtg": home_a_rtg,
                    "away_rtg": away_rtg,
                    "away_a_rtg": away_a_rtg
                }
                this.historicModalData.eventName = eventName
                this.isload = false
                this.current_counter = 0
                clearInterval(this.clock)
                this.clock = setInterval(this.frame, 100)
                window.axios.post(`${process.env.VUE_APP_URL}getLiveEventHistory`, [fixtureId]).then(({data})=> {
                    console.log('called historical data===>', data.data[0])
                    this.isload = true
                    let seasonData = data.data[0][0]
                    let home_poss_index = 0
                    let away_poss_index = 0
                    let home_p = 0
                    let away_p = 0
                    let home_season = {}
                    let away_season = {}
                    if(seasonData.home_season){
                        home_p = seasonData.home_season.p
                        away_p = seasonData.away_season.p
                        home_season = seasonData.home_season
                        away_season = seasonData.away_season
                    }

                    this.flatodds = {
                        "h_win": "-",
                        "a_win": "-",
                        "d_win": "-",
                        "o_05": "-",
                        "o_15": "-",
                        "o_25": "-",
                        "o_35": "-",
                        "u_05": "-",
                        "u_15": "-",
                        "u_25": "-",
                        "u_35": "-",
                        "o_05_ht": "-",
                        "u_05_ht": "-",
                        "bts_yes": "-",
                        "bts_no": "-",
                        prob_home: "-",
                        prob_draw: "-",
                        prob_away : "-",
                        prob_over05: "-",
                        prob_over15: "-",
                        prob_over25 : "-",
                        prob_over35 : "-",
                        prob_bts: "-",
                        prob_over05_ht: "-",

                        prob_under05: "-",
                        prob_under15: "-",
                        prob_under25 : "-",
                        prob_under35: "-",

                        prob_bts_no: "-",
                        prob_under05_ht: "-",

                        prob_home_tt1: null,
                        prob_home_tt2: null,
                        prob_away_tt1: null,
                        prob_away_tt2: null,
                        prob_draw_tt1: null,
                        prob_draw_tt2: null,
                        prob_over05_tt1: null,
                        prob_over05_tt2: null,
                        prob_over15_tt1: null,
                        prob_over15_tt2: null,
                        prob_over25_tt1: null,
                        prob_over25_tt2: null,
                        prob_over35_tt1: null,
                        prob_over35_tt2: null,
                        prob_under05_tt1: null,
                        prob_under05_tt2: null,
                        prob_under15_tt1: null,
                        prob_under15_tt2: null,
                        prob_under25_tt1: null,
                        prob_under25_tt2: null,
                        prob_under35_tt1: null,
                        prob_under35_tt2: null,
                        prob_over05_ht_tt1: null,
                        prob_over05_ht_tt2: null,
                        prob_under05_ht_tt1: null,
                        prob_under05_ht_tt2: null,
                        prob_bts_tt1: null,
                        prob_bts_tt2: null,
                        prob_bts_no_tt1: null,
                        prob_bts_no_tt2: null,

                    };
                    this.matches_sample = 0;
                    if (seasonData.DailyFixtures.length != 0) {
                        seasonData.DailyFixtures[0].flatOdds.data.forEach((oItem) => {
                            let mkt_id = oItem.market_id;
                            if(oItem.bookmaker_id === 2) {
                                let suffix;
                                if(mkt_id === 1 || mkt_id === 12 || mkt_id === 976105  || mkt_id === 136703813 || mkt_id === 137918022 || mkt_id === 28077 || mkt_id === 1256989864) 
                                    suffix = 'FT';
                                else if(mkt_id === 37 || mkt_id === 31379 || mkt_id === 975903 || mkt_id === 976226)
                                    suffix = 'HT';
                                (oItem.odds || oItem.values).forEach((item) => {
                                    let label;
                                    if(item.label)
                                        label = `${item.label}${item.total ? ' - ' + item.total : ''}`;
                                    else if(item.team)
                                        label = item.team;
                                    else if(item.info) {
                                        label = item.info;
                                    }
                                    if(label === 'Yes')
                                        label = 'BTS';
                                    else if(label === 'No')
                                        label = 'No BTS';
                                    if(label === '1')
                                        label = "Home";
                                    else if(label === '2')
                                        label = 'Away';
                                    else if(label === 'X')
                                        label = 'Draw';
                                    if(!label.includes(",")) {              //except over 2.0,2.5 case
                                        label = `${label} - ${suffix}`
                                        if(label == 'Home - FT') {
                                            
                                            this.flatodds.h_win = parseFloat(item.value)
                                        }
                                        else if(label == 'Away - FT') {
                                            this.flatodds.a_win = parseFloat(item.value)
                                        }
                                        else if(label == 'Draw - FT') {
                                            
                                            this.flatodds.d_win = parseFloat(item.value)
                                        }

                                        else if(label == "Over - 0.5 - FT")
                                            this.flatodds.o_05 = parseFloat(item.value)
                                        else if(label == "Over - 1.5 - FT")
                                            this.flatodds.o_15 = parseFloat(item.value)
                                        else if(label == "Over - 2.5 - FT")
                                            this.flatodds.o_25 = parseFloat(item.value)
                                        else if(label == "Over - 3.5 - FT")
                                            this.flatodds.o_35 = parseFloat(item.value)

                                        else if(label == "Under - 0.5 - FT")
                                            this.flatodds.u_05 = parseFloat(item.value)
                                        else if(label == "Under - 1.5 - FT")
                                            this.flatodds.u_15  = parseFloat(item.value)
                                        else if(label == "Under - 2.5 - FT")
                                            this.flatodds.u_25  = parseFloat(item.value)
                                        else if(label == "Under - 3.5 - FT")
                                            this.flatodds.u_35  = parseFloat(item.value)

                                        else if(label == "BTS - FT")
                                            this.flatodds.bts_yes  = parseFloat(item.value)
                                        else if(label == "No BTS - FT")
                                            this.flatodds.bts_no = parseFloat(item.value)

                                        else if(label == "Over - 0.5 - HT")
                                            this.flatodds.o_05_ht = parseFloat(item.value)
                                        else if(label == "Under - 0.5 - HT")
                                            this.flatodds.u_05_ht = parseFloat(item.value)

                                        // event_odds_list.push({
                                        //     label: `${label} - ${suffix}`,
                                        //     value: `${label} - ${suffix}`.trim(),
                                        //     odd: parseFloat(item.value)
                                        // });
                                    }
                                });
                            }

                            
                        });
                        var oddslines = null;
                        if ( seasonData.league5yearsStats.length > 0 ) {
                            oddslines = seasonData.league5yearsStats[0].oddslines;

                            var odds = null;
                            let home_odds = 100;
                            if (this.flatodds.h_win !== "-")
                                home_odds = this.flatodds.h_win;
                            let away_odds = 100;
                            if (this.flatodds.a_win !== "-")
                                away_odds = this.flatodds.a_win;
                            
                            if (home_odds <= 3 && away_odds <= 3) {
                                odds = oddslines[3]
                            }
                            else if (home_odds <= 1.5) {
                                odds = oddslines[0]
                            }
                            else if (home_odds > 1.5 && home_odds <= 2) {
                                odds = oddslines[1]
                            }
                            else if (home_odds > 2 && home_odds <= 3) {
                                odds = oddslines[2]
                            }
                            
                            else if (away_odds <= 1.5) {
                                odds = oddslines[4]
                            }
                            else if (away_odds > 1.5 && away_odds <= 2) {
                                odds = oddslines[5]
                            }
                            else if (away_odds > 2 && away_odds <= 3) {
                                odds = oddslines[6]
                            }

                            if (odds) {
                                this.flatodds.prob_home = parseInt(odds.home_win_percent)
                                this.flatodds.prob_draw = parseInt(odds.draw_win_percent)
                                this.flatodds.prob_away = parseInt(odds.away_win_percent)
                                this.flatodds.prob_over05 = parseInt(odds.full_05_percent)
                                this.flatodds.prob_over15 = parseInt(odds.full_15_percent)
                                this.flatodds.prob_over25 = parseInt(odds.full_25_percent)
                                this.flatodds.prob_over35 = parseInt(odds.full_35_percent)
                                this.flatodds.prob_bts = parseInt(odds.bts_percent)
                                this.flatodds.prob_over05_ht = parseInt(odds.first_05_percent)

                                this.flatodds.prob_under05 = 100 - parseInt(odds.full_05_percent)
                                this.flatodds.prob_under15 = 100 - parseInt(odds.full_15_percent)
                                this.flatodds.prob_under25 = 100 - parseInt(odds.full_25_percent)
                                this.flatodds.prob_under35 = 100 - parseInt(odds.full_35_percent)

                                this.flatodds.prob_bts_no = 100 - parseInt(odds.bts_percent)
                                this.flatodds.prob_under05_ht = 100 - parseInt(odds.first_05_percent)

                                this.matches_sample = odds.total_matches;
                            }

                            if (this.flatodds.prob_home !== "-" && this.flatodds.h_win !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.h_win, this.flatodds.prob_home)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_home_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_home_tt2 = value.toFixed(2)                                    
                            }

                            if (this.flatodds.prob_draw !== "-" && this.flatodds.d_win !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.d_win, this.flatodds.prob_draw)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_draw_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_draw_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_away !== "-" && this.flatodds.a_win !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.a_win, this.flatodds.prob_away)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_away_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_away_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_over05 !== "-" && this.flatodds.o_05 !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.o_05, this.flatodds.prob_over05)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_over05_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_over05_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_over15 !== "-" && this.flatodds.o_15 !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.o_15, this.flatodds.prob_over15)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_over15_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_over15_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_over25 !== "-" && this.flatodds.o_25 !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.o_25, this.flatodds.prob_over25)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_over25_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_over25_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_over35 !== "-" && this.flatodds.o_35 !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.o_35, this.flatodds.prob_over35)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_over35_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_over35_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_under05 !== "-" && this.flatodds.u_05 !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.u_05, this.flatodds.prob_under05)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_under05_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_under05_tt2 = value.toFixed(2)
                            }
                            if (this.flatodds.prob_under15 !== "-" && this.flatodds.u_15 !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.u_15, this.flatodds.prob_under15)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_under15_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_under15_tt2 = value.toFixed(2)
                            }
                            if (this.flatodds.prob_under25 !== "-" && this.flatodds.oddsu_25_under25 !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.u_25, this.flatodds.prob_under25)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_under25_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_under25_tt2 = value.toFixed(2)
                            }
                            if (this.flatodds.prob_under35 !== "-" && this.flatodds.u_35 !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.u_35, this.flatodds.prob_under35)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_under35_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_under35_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_over05_ht !== "-" && this.flatodds.o_05_ht !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.o_05_ht, this.flatodds.prob_over05_ht)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_over05_ht_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_over05_ht_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_under05_ht !== "-" && this.flatodds.u_05_ht !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.u_05_ht, this.flatodds.prob_under05_ht)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_under05_ht_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_under05_ht_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_bts !== "-" && this.flatodds.bts_yes !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.bts_yes, this.flatodds.prob_bts)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_bts_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_bts_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_bts_no !== "-" && this.flatodds.bts_no !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.bts_no, this.flatodds.prob_bts_no)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_bts_no_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_bts_no_tt2 = value.toFixed(2)
                            }
                        }
                        
                        if (this.matches_sample == 0) {
                            this.flatodds = {
                                "h_win": "-",
                                "a_win": "-",
                                "d_win": "-",
                                "o_05": "-",
                                "o_15": "-",
                                "o_25": "-",
                                "o_35": "-",
                                "u_05": "-",
                                "u_15": "-",
                                "u_25": "-",
                                "u_35": "-",
                                "o_05_ht": "-",
                                "u_05_ht": "-",
                                "bts_yes": "-",
                                "bts_no": "-",
                                prob_home: "-",
                                prob_draw: "-",
                                prob_away : "-",
                                prob_over05: "-",
                                prob_over15: "-",
                                prob_over25 : "-",
                                prob_over35 : "-",
                                prob_bts: "-",
                                prob_over05_ht: "-",

                                prob_under05: "-",
                                prob_under15: "-",
                                prob_under25 : "-",
                                prob_under35: "-",

                                prob_bts_no: "-",
                                prob_under05_ht: "-",

                                prob_home_tt1: null,
                                prob_home_tt2: null,
                                prob_away_tt1: null,
                                prob_away_tt2: null,
                                prob_draw_tt1: null,
                                prob_draw_tt2: null,
                                prob_over05_tt1: null,
                                prob_over05_tt2: null,
                                prob_over15_tt1: null,
                                prob_over15_tt2: null,
                                prob_over25_tt1: null,
                                prob_over25_tt2: null,
                                prob_over35_tt1: null,
                                prob_over35_tt2: null,
                                prob_under05_tt1: null,
                                prob_under05_tt2: null,
                                prob_under15_tt1: null,
                                prob_under15_tt2: null,
                                prob_under25_tt1: null,
                                prob_under25_tt2: null,
                                prob_under35_tt1: null,
                                prob_under35_tt2: null,
                                prob_over05_ht_tt1: null,
                                prob_over05_ht_tt2: null,
                                prob_under05_ht_tt1: null,
                                prob_under05_ht_tt2: null,
                                prob_bts_tt1: null,
                                prob_bts_tt2: null,
                                prob_bts_no_tt1: null,
                                prob_bts_no_tt2: null,

                            };
                        }
                        
                    
                    }

                    let rtgTime = []
                    let homeRS = []
                    let awayRS = []

                    if (seasonData.liveStatsT.length > 0) {
                        let home_rtg_stats = seasonData.liveStatsT[0].home_rtg_stats
                        let away_rtg_stats = seasonData.liveStatsT[0].away_rtg_stats
                        if(home_rtg_stats){
                            for(let c = 0; c < home_rtg_stats.length; c++){
                                let minute = home_rtg_stats[c].time.minute
                                let half_extra_time = 0;
                                let home_rtg = {
                                    'on': null,
                                    'off': null,
                                    'cnr': null,
                                    'da': null,
                                    'goal': null,
                                    'rtg': null
                                }

                                if(home_rtg_stats[c].time.extra_time != null){
                                    minute = home_rtg_stats[c].time.minute + home_rtg_stats[c].time.extra_time
                                    if(home_rtg_stats[c].time.minute < 46){
                                        half_extra_time = home_rtg_stats[c].time.extra_time
                                    }
                                }
                                if(home_rtg_stats[c].time.minute > 45){
                                    minute = minute + half_extra_time
                                }
                                rtgTime.push(minute)

                                if(c <= 10){
                                    if(home_rtg_stats[c].shots != null){
                                        home_rtg.on = home_rtg_stats[c].shots.ongoal
                                        home_rtg.off = home_rtg_stats[c].shots.offgoal
                                    }
                                    if(home_rtg_stats[c].da != null){
                                        home_rtg.da = home_rtg_stats[c].da.dangerous_attacks
                                    }
                                    home_rtg.cnr = home_rtg_stats[c].cnr
                                    home_rtg.goal = home_rtg_stats[c].goals
                                }
                                else{
                                    if(home_rtg_stats[c - 10].shots != null){
                                        home_rtg.on = home_rtg_stats[c].shots.ongoal - home_rtg_stats[c - 10].shots.ongoal
                                        home_rtg.off = home_rtg_stats[c].shots.offgoal - home_rtg_stats[c - 10].shots.offgoal
                                    }
                                    if(home_rtg_stats[c - 10].da != null){
                                        home_rtg.da = home_rtg_stats[c].da.dangerous_attacks - home_rtg_stats[c - 10].da.dangerous_attacks
                                    }
                                    home_rtg.cnr = home_rtg_stats[c].cnr - home_rtg_stats[c - 10].cnr
                                    home_rtg.goal = home_rtg_stats[c].goals - home_rtg_stats[c - 10].goals
                                }

                                if((home_rtg.on >= 0) || (home_rtg.off >= 0) || (home_rtg.cnr >= 0) || (home_rtg.da > 0)){
                                    home_rtg.rtg = 0
                                    if(home_rtg.on >= 0){
                                        home_rtg.rtg = home_rtg.rtg + home_rtg.on*3
                                    }
                                    if(home_rtg.off >= 0){
                                        home_rtg.rtg = home_rtg.rtg + home_rtg.off*2
                                    }
                                    if(home_rtg.cnr >= 0){
                                        home_rtg.rtg = home_rtg.rtg + home_rtg.cnr
                                    }
                                    if(home_rtg.da >= 0){
                                        home_rtg.rtg = home_rtg.rtg + home_rtg.da
                                    }
                                }
                                else{
                                    home_rtg.rtg = '-'
                                }
                                homeRS.push(home_rtg.rtg)
                            }
                        }
                        if(away_rtg_stats){
                            for(let c = 0; c < away_rtg_stats.length; c++){
                                let home_rtg = {
                                    'on': null,
                                    'off': null,
                                    'cnr': null,
                                    'da': null,
                                    'goal': null,
                                    'rtg': null
                                }
                                if(c <= 10){
                                    if(away_rtg_stats[c].shots != null){
                                        home_rtg.on = away_rtg_stats[c].shots.ongoal
                                        home_rtg.off = away_rtg_stats[c].shots.offgoal
                                    }
                                    if(away_rtg_stats[c].da != null){
                                        home_rtg.da = away_rtg_stats[c].da.dangerous_attacks
                                    }
                                    home_rtg.cnr = away_rtg_stats[c].cnr
                                    home_rtg.goal = away_rtg_stats[c].goals
                                }
                                else{
                                    if(away_rtg_stats[c - 10].shots != null){
                                        home_rtg.on = away_rtg_stats[c].shots.ongoal - away_rtg_stats[c - 10].shots.ongoal
                                        home_rtg.off = away_rtg_stats[c].shots.offgoal - away_rtg_stats[c - 10].shots.offgoal
                                    }
                                    if(away_rtg_stats[c - 10].da != null){
                                        home_rtg.da = away_rtg_stats[c].da.dangerous_attacks - away_rtg_stats[c - 10].da.dangerous_attacks
                                    }
                                    home_rtg.cnr = away_rtg_stats[c].cnr - away_rtg_stats[c - 10].cnr
                                    home_rtg.goal = away_rtg_stats[c].goals - away_rtg_stats[c - 10].goals
                                }

                                if((home_rtg.on >= 0) || (home_rtg.off >= 0) || (home_rtg.cnr >= 0) || (home_rtg.da > 0)){
                                    home_rtg.rtg = 0
                                    if(home_rtg.on >= 0){
                                        home_rtg.rtg = home_rtg.rtg + home_rtg.on*3
                                    }
                                    if(home_rtg.off >= 0){
                                        home_rtg.rtg = home_rtg.rtg + home_rtg.off*2
                                    }
                                    if(home_rtg.cnr >= 0){
                                        home_rtg.rtg = home_rtg.rtg + home_rtg.cnr
                                    }
                                    if(home_rtg.da >= 0){
                                        home_rtg.rtg = home_rtg.rtg + home_rtg.da
                                    }
                                }
                                else{
                                    home_rtg.rtg = '-'
                                }
                                awayRS.push(-home_rtg.rtg)
                            }
                        }
                    }
                    console.log('home&away season===>', home_season, away_season)
                    for(let i = 0 ; i < this.eventArray.length ; i++){
                        for(let j = 0 ; j < this.eventArray[i].events.length ; j++){
                            console.log('===>', this.eventArray[i].events[j].home.id, this.eventArray[i].events[j].away.id)
                            if(this.eventArray[i].events[j].home.id == home_id && this.eventArray[i].events[j].away.id == away_id){
                                this.historicModalData.home_season = Object.assign(home_season)
                                this.historicModalData.away_season = Object.assign(away_season)
                                this.historicModalData.home_p = home_p
                                this.historicModalData.away_p = away_p
                                // this.data[0].x = this.eventArray[i].events[j].chart.time
                                // this.data[1].x = this.eventArray[i].events[j].chart.time
                                // this.data[0].y = this.eventArray[i].events[j].chart.homeRTG
                                // this.data[1].y = this.eventArray[i].events[j].chart.awayRTG
                                this.data[0].x = rtgTime
                                this.data[1].x = rtgTime
                                this.data[0].y = homeRS
                                this.data[1].y = awayRS
                                this.data[0].name = this.eventArray[i].events[j].main_data.home_name
                                this.data[1].name = this.eventArray[i].events[j].main_data.away_name
                                this.historicModalData.eventName = this.eventArray[i].events[j].main_data.home_name + " v " + this.eventArray[i].events[j].main_data.away_name
                                console.log('this.historicModalData.eventName 1', this.historicModalData.eventName)
                                // this.eventArray[i].events[j].show = true
                            }
                        }
                    }

                    for(let i = 0 ; i < this.scheduleArray.length ; i++){
                        for(let j = 0 ; j < this.scheduleArray[i].events.length ; j++){
                            
                            if(this.scheduleArray[i].events[j].localTeamId == home_id && this.scheduleArray[i].events[j].visitorTeamId == away_id){
                                this.historicModalData.home_season = Object.assign(home_season)
                                this.historicModalData.away_season = Object.assign(away_season)
                                this.historicModalData.home_p = home_p
                                this.historicModalData.away_p = away_p
                                this.data[0].x = []
                                this.data[1].x = []
                                this.data[0].y = []
                                this.data[1].y = []
                                this.data[0].name = this.scheduleArray[i].events[j].localTeamName
                                this.data[1].name = this.scheduleArray[i].events[j].visitorTeamName
                                this.historicModalData.eventName = this.scheduleArray[i].events[j].localTeamName + " v " + this.scheduleArray[i].events[j].visitorTeamName
                                console.log('this.historicModalData.eventName 2', this.historicModalData.eventName)
                                // this.eventArray[i].events[j].show = true
                            }
                        }
                    }
                    console.log('this.historicModalData.eventName', this.historicModalData.eventName)
                    this.percallfunction()
                })
            },
            update5yStats() {
                if(this.reload_flag == false){
                    var check_new_total = 0;
                   
                    for(let j = 0 ; j < this.eventArray.length ; j++){
                        for(let k = 0 ; k < this.eventArray[j].events.length ; k++){
                            
                            check_new_total = check_new_total + 1
                            let current_event = this.eventArray[j].events[k]
                            let oddslines = this.eventArray[j].league5yearsStats.oddslines
                            let current_scorelines = this.eventArray[j].league5yearsStats.scorelines

                            let current_flatOdds = current_event.flatOdds

                            ////////////////////    5 years stats data    //////////////////////
                            var inplayOdds_home = current_event.homeT.homeodds
                            var inplayOdds_away = current_event.homeT.awayodds
                            var inplayOdds_draw = current_event.homeT.drawodds

                            var over_odds = []
                            var under_odds = []
                            
                            

                            var mark1 = (current_event.home.score + current_event.away.score + 0.5).toString()
                            var mark2 = (current_event.home.score + current_event.away.score + 1.5).toString()
                            var cur_score = current_event.home.score + '-' + current_event.away.score

                            var homewin_stat = '';
                            var awaywin_stat = '';
                            var drawwin_stat = '';
                            var homeT_homewin_stat = '';
                            var homeT_awaywin_stat = '';
                            var homeT_drawwin_stat = '';
                            var homeT_homewin_stat_tooltip_1 = null;
                            var homeT_homewin_stat_tooltip_2 = null;
                            var homeT_awaywin_stat_tooltip_1 = null;
                            var homeT_awaywin_stat_tooltip_2 = null;
                            var homeT_drawwin_stat_tooltip_1 = null;
                            var homeT_drawwin_stat_tooltip_2 = null;

                            var goal_1_plus = '';
                            var goal_2_plus = '';
                            var goal_1_minus = '';
                            var goal_2_minus = '';
                            var homeT_goal_1_plus = '';
                            var homeT_goal_2_plus = '';
                            var homeT_goal_1_minus = '';
                            var homeT_goal_2_minus = '';

                            var homeT_goalnexthome = ''
                            var homeT_goalnextaway = ''
                            var homeT_goalnextdraw  = ''

                            var homeT_goalyes = []

                            var homeT_homewin_stat_green = false;
                            var homeT_awaywin_stat_green = false;
                            var homeT_drawwin_stat_green = false;

                            var homeT_goal_1_plus_green = false;
                            var homeT_goal_1_minus_green = false;
                            var homeT_goal_2_plus_green = false;
                            var homeT_goal_2_minus_green = false;

                            var homeT_goal_1_plus_tooltip_1 = null;
                            var homeT_goal_1_plus_tooltip_2 = null;
                            var homeT_goal_1_minus_tooltip_1 = null;
                            var homeT_goal_1_minus_tooltip_2 = null;
                            var homeT_goal_2_plus_tooltip_1 = null;
                            var homeT_goal_2_plus_tooltip_2 = null;
                            var homeT_goal_2_minus_tooltip_1 = null;
                            var homeT_goal_2_minus_tooltip_2 = null;


                            var flatOdds_home = 100
                            var flatOdds_away = 100
                            var flatOdds_draw = 100
                            var event_oddsname = ''
                            
                            if (current_flatOdds) {
                                current_flatOdds.data.forEach((oItem) => {
                                    let mkt_id = oItem.market_id;
                                    if(oItem.bookmaker_id === 2) {
                                        let suffix;
                                        if(mkt_id === 1 || mkt_id === 12 || mkt_id === 976105  || mkt_id === 136703813 || mkt_id === 137918022 || mkt_id === 28077 || mkt_id === 1256989864) 
                                            suffix = 'FT';
                                        else if(mkt_id === 37 || mkt_id === 31379 || mkt_id === 975903 || mkt_id === 976226)
                                            suffix = 'HT';
                                        (oItem.odds || oItem.values).forEach((item) => {
                                            let label;
                                            if(item.label)
                                                label = `${item.label}${item.total ? ' - ' + item.total : ''}`;
                                            else if(item.team)
                                                label = item.team;
                                            else if(item.info) {
                                                label = item.info;
                                            }
                                            
                                            if(label === '1')
                                                label = "Home";
                                            else if(label === '2')
                                                label = 'Away';
                                            else if(label === 'X')
                                                label = 'Draw';
                                            if(!label.includes(",")) {              //except over 2.0,2.5 case
                                                label = `${label} - ${suffix}`
                                                if(label == 'Home - FT') {
                                                    flatOdds_home = parseFloat(item.value)
                                                }
                                                else if(label == 'Away - FT') {
                                                    
                                                    flatOdds_away = parseFloat(item.value)
                                                }
                                                else if(label == 'Draw - FT') {
                                                    
                                                    flatOdds_draw = parseFloat(item.value)
                                                }
                                            }
                                        });
                                    }
                                });
                            }

                            if (flatOdds_home <= 3 && flatOdds_away <= 3) {
                                event_oddsname = 'SuperCompetative'
                            }
                            else if (flatOdds_home <= 1.5) {
                                event_oddsname = 'H_StrongFav'
                            }
                            else if (flatOdds_home > 1.5 && flatOdds_home <= 2) {
                                event_oddsname = 'H_MediumFav'
                            }
                            else if (flatOdds_home > 2 && flatOdds_home <= 3) {
                                event_oddsname = 'H_SmallFav'
                            }
                            
                            else if (flatOdds_away <= 1.5) {
                                event_oddsname = 'A_StrongFav'
                            }
                            else if (flatOdds_away > 1.5 && flatOdds_away <= 2) {
                                event_oddsname = 'A_MediumFav'
                            }
                            else if (flatOdds_away > 2 && flatOdds_away <= 3) {
                                event_oddsname = 'A_SmallFav'
                            }

                            var cur_minute = current_event.homeT.minute
                            var mark_minute = ''
                            if (cur_minute >= 0 && cur_minute <= 30)
                                mark_minute = '15'
                            else if (cur_minute > 30 && cur_minute <= 45 && current_event.home.time != 'HT')
                                mark_minute = '30'
                            else if ((cur_minute > 45 && cur_minute <= 60) || (current_event.home.time == 'HT'))
                                mark_minute = '45'
                            else if (cur_minute > 60 && cur_minute <= 75)
                                mark_minute = '60'
                            else if (cur_minute > 75 && cur_minute <= 90)
                                mark_minute = '75'

                            var matched_events = 0
                            if (cur_minute >= 0 && cur_minute < 15 && cur_score == '0-0'){
                                if (event_oddsname != '') {
                                    
                                    var oddsline
                                    if (event_oddsname == 'H_StrongFav')
                                        oddsline = oddslines[0]
                                    else if (event_oddsname == 'H_MediumFav')
                                        oddsline = oddslines[1]
                                    else if (event_oddsname == 'H_SmallFav')
                                        oddsline = oddslines[2]
                                    else if (event_oddsname == 'SuperCompetative')
                                        oddsline = oddslines[3]
                                    else if (event_oddsname == 'A_StrongFav')
                                        oddsline = oddslines[4]
                                    else if (event_oddsname == 'A_MediumFav')
                                        oddsline = oddslines[5]
                                    else if (event_oddsname == 'A_SmallFav')
                                        oddsline = oddslines[6]

                                    matched_events = oddsline.total_matches
                                    if (oddsline.total_matches != 0) {
                                        homeT_homewin_stat = parseInt(oddsline.home_win_percent) + '%'
                                        homeT_awaywin_stat = parseInt(oddsline.away_win_percent) + '%'
                                        homeT_drawwin_stat = parseInt(oddsline.draw_win_percent) + '%'

                                        homewin_stat = parseInt(oddsline.home_win_percent)
                                        awaywin_stat = parseInt(oddsline.away_win_percent)
                                        drawwin_stat = parseInt(oddsline.draw_win_percent)

                                        homeT_goalnexthome = parseInt(oddsline.fts_h_percent) + '%'
                                        homeT_goalnextaway = parseInt(oddsline.fts_a_percent) + '%'
                                        homeT_goalnextdraw = parseInt(100 - parseInt(oddsline.fts_h_percent) - parseInt(oddsline.fts_a_percent)) + '%'
                                        homeT_goal_1_plus = parseInt(oddsline.full_05_percent) + '%'
                                        homeT_goal_2_plus = parseInt(oddsline.full_15_percent) + '%'
                                        homeT_goal_1_minus = (100 - parseInt(oddsline.full_05_percent)) + '%'
                                        homeT_goal_2_minus = (100 - parseInt(oddsline.full_15_percent)) + '%'

                                        goal_1_plus = parseInt(oddsline.full_05_percent)
                                        goal_2_plus = parseInt(oddsline.full_15_percent)
                                        goal_1_minus = (100 - parseInt(oddsline.full_05_percent))
                                        goal_2_minus = (100 - parseInt(oddsline.full_15_percent))
                                        
                                        
                                        if (cur_minute >= 0 && cur_minute <= 15){
                                            homeT_goalyes = [
                                                {
                                                    'mark': '0-15',
                                                    'value': parseInt(oddsline.goal_bands_15_percent) + '%',
                                                    'green': null,
                                                    'tooltip_1': null,
                                                    'tooltip_2': null
                                                },
                                                {
                                                    'mark': '16-30',
                                                    'value': parseInt(oddsline.goal_bands_30_percent) + '%',
                                                    'green': null,
                                                    'tooltip_1': null,
                                                    'tooltip_2': null
                                                }
                                            ]
                                            
                                        }
                                    }

                                }
                            }
                            else {
                                if (mark_minute != '' && event_oddsname != '') {
                                    
                                    var band15_isgoal = false;
                                    var band30_isgoal = false;
                                    var band45_isgoal = false;
                                    var band60_isgoal = false;
                                    var band75_isgoal = false;
                                    var band90_isgoal = false;
                                    if (current_event.goal_tooltip != ''){
                                        var goal_minutes = current_event.goal_tooltip.split(' ');
                                        goal_minutes.forEach((item) => {
                                            var goal_minute = parseInt(item.replace("'", ""))
                                            if ( goal_minute <= 15 )
                                                band15_isgoal = true;
                                            else if ( goal_minute <= 30 )
                                                band30_isgoal = true;
                                            else if ( goal_minute <= 45 )
                                                band45_isgoal = true;
                                            else if ( goal_minute <= 60 )
                                                band60_isgoal = true;
                                            else if ( goal_minute <= 75 )
                                                band75_isgoal = true;
                                            else if ( goal_minute <= 90 )
                                                band90_isgoal = true;
                                        })
                                    }
                                    var scorelines = current_scorelines[mark_minute][event_oddsname];
                                    if (cur_score in scorelines) {
                                        var scoreline = scorelines[cur_score];
                                        matched_events = scoreline.matches
                                        homeT_homewin_stat = parseInt(scoreline.homewin) + '%'
                                        homeT_awaywin_stat = parseInt(scoreline.awaywin) + '%'
                                        homeT_drawwin_stat = parseInt(scoreline.drawwin) + '%'

                                        homewin_stat = parseInt(scoreline.homewin)
                                        awaywin_stat = parseInt(scoreline.awaywin)
                                        drawwin_stat = parseInt(scoreline.drawwin)

                                        homeT_goalnexthome = parseInt(scoreline.goalnexthome) + '%'
                                        homeT_goalnextaway = parseInt(scoreline.goalnextaway) + '%'
                                        homeT_goalnextdraw = parseInt(100 - scoreline.goalnexthome - scoreline.goalnextaway) + '%'
                                        homeT_goal_1_plus = parseInt(scoreline.goal_1_plus) + '%'
                                        homeT_goal_2_plus = parseInt(scoreline.goal_2_plus) + '%'
                                        homeT_goal_1_minus = (100 - parseInt(scoreline.goal_1_plus)) + '%'
                                        homeT_goal_2_minus = (100 - parseInt(scoreline.goal_2_plus)) + '%'

                                        goal_1_plus = parseInt(scoreline.goal_1_plus)
                                        goal_2_plus = parseInt(scoreline.goal_2_plus)
                                        goal_1_minus = (100 - parseInt(scoreline.goal_1_plus))
                                        goal_2_minus = (100 - parseInt(scoreline.goal_2_plus))

                                        
                                        
                                        if (cur_minute >= 0 && cur_minute <= 15){
                                            if (band15_isgoal) {
                                                homeT_goalyes = [
                                                    {
                                                        'mark': '0-15',
                                                        'value': '-',
                                                        'green': null,
                                                        'tooltip_1': null,
                                                        'tooltip_2': null
                                                    },
                                                    {
                                                        'mark': '16-30',
                                                        'value': parseInt(scoreline.goalyes['30']) + '%',
                                                        'green': null,
                                                        'tooltip_1': null,
                                                        'tooltip_2': null
                                                    }
                                                ]
                                            }
                                            else {
                                                homeT_goalyes = [
                                                    {
                                                        'mark': '0-15',
                                                        'value': parseInt(scoreline.goalyes['15']) + '%',
                                                        'green': null,
                                                        'tooltip_1': null,
                                                        'tooltip_2': null
                                                    },
                                                    {
                                                        'mark': '16-30',
                                                        'value': parseInt(scoreline.goalyes['30']) + '%',
                                                        'green': null,
                                                        'tooltip_1': null,
                                                        'tooltip_2': null
                                                    }
                                                ]
                                            }
                                        }

                                        else if (cur_minute > 15 && cur_minute <= 30){
                                            if (band30_isgoal) {
                                                homeT_goalyes = [
                                                    {
                                                        'mark': '16-30',
                                                        'value': '-',
                                                        'green': null,
                                                        'tooltip_1': null,
                                                        'tooltip_2': null
                                                    },
                                                    {
                                                        'mark': '31-45',
                                                        'value': parseInt(scoreline.goalyes['45']) + '%',
                                                        'green': null,
                                                        'tooltip_1': null,
                                                        'tooltip_2': null
                                                    }
                                                ]
                                            }
                                            else {
                                                homeT_goalyes = [
                                                    {
                                                        'mark': '16-30',
                                                        'value': parseInt(scoreline.goalyes['30']) + '%',
                                                        'green': null,
                                                        'tooltip_1': null,
                                                        'tooltip_2': null
                                                    },
                                                    {
                                                        'mark': '31-45',
                                                        'value': parseInt(scoreline.goalyes['45']) + '%',
                                                        'green': null,
                                                        'tooltip_1': null,
                                                        'tooltip_2': null
                                                    }
                                                ]
                                            }
                                            
                                            
                                        }
                                        else if (cur_minute > 30 && cur_minute <= 45 && current_event.home.time != 'HT') {
                                            if (band45_isgoal) {
                                                homeT_goalyes = [
                                                    {
                                                        'mark': '31-45',
                                                        'value': '-',
                                                        'green': null,
                                                        'tooltip_1': null,
                                                        'tooltip_2': null
                                                    },
                                                    {
                                                        'mark': '46-60',
                                                        'value': parseInt(scoreline.goalyes['60']) + '%',
                                                        'green': null,
                                                        'tooltip_1': null,
                                                        'tooltip_2': null
                                                    },
                                                ]
                                            }
                                            else {
                                                homeT_goalyes = [
                                                    {
                                                        'mark': '31-45',
                                                        'value': parseInt(scoreline.goalyes['45']) + '%',
                                                        'green': null,
                                                        'tooltip_1': null,
                                                        'tooltip_2': null
                                                    },
                                                    {
                                                        'mark': '46-60',
                                                        'value': parseInt(scoreline.goalyes['60']) + '%',
                                                        'green': null,
                                                        'tooltip_1': null,
                                                        'tooltip_2': null
                                                    },
                                                ]
                                            }
                                            
                                            
                                        }
                                           
                                        else if ((cur_minute > 45 && cur_minute <= 60) || (current_event.home.time == 'HT')){
                                            if (band60_isgoal) {
                                                homeT_goalyes = [
                                                   {
                                                        'mark': '46-60',
                                                        'value': '-',
                                                        'green': null,
                                                        'tooltip_1': null,
                                                        'tooltip_2': null
                                                    }, 
                                                    {
                                                        'mark': '61-75',
                                                        'value': parseInt(scoreline.goalyes['75']) + '%',
                                                        'green': null,
                                                        'tooltip_1': null,
                                                        'tooltip_2': null
                                                    },
                                                ]
                                            }
                                            else {
                                                homeT_goalyes = [
                                                   {
                                                        'mark': '46-60',
                                                        'value': parseInt(scoreline.goalyes['60']) + '%',
                                                        'green': null,
                                                        'tooltip_1': null,
                                                        'tooltip_2': null
                                                    }, 
                                                    {
                                                        'mark': '61-75',
                                                        'value': parseInt(scoreline.goalyes['75']) + '%',
                                                        'green': null,
                                                        'tooltip_1': null,
                                                        'tooltip_2': null
                                                    },
                                                ]
                                            }
                                            
                                            
                                        }
                                        else if (cur_minute > 60 && cur_minute <= 75){
                                            if (band75_isgoal) {
                                                homeT_goalyes = [
                                                    {
                                                        'mark': '61-75',
                                                        'value': '-',
                                                        'green': null,
                                                        'tooltip_1': null,
                                                        'tooltip_2': null
                                                    },
                                                    {
                                                        'mark': '76-90',
                                                        'value': parseInt(scoreline.goalyes['90']) + '%',
                                                        'green': null,
                                                        'tooltip_1': null,
                                                        'tooltip_2': null
                                                    },
                                                ]
                                            }
                                            else {
                                                homeT_goalyes = [
                                                    {
                                                        'mark': '61-75',
                                                        'value': parseInt(scoreline.goalyes['75']) + '%',
                                                        'green': null,
                                                        'tooltip_1': null,
                                                        'tooltip_2': null
                                                    },
                                                    {
                                                        'mark': '76-90',
                                                        'value': parseInt(scoreline.goalyes['90']) + '%',
                                                        'green': null,
                                                        'tooltip_1': null,
                                                        'tooltip_2': null
                                                    },
                                                ]
                                            }
                                            
                                            
                                        }
                                        else if (cur_minute > 75 && cur_minute <= 90){
                                            if (band90_isgoal){
                                                homeT_goalyes = [
                                                    {
                                                        'mark': '76-90',
                                                        'value': '-',
                                                        'green': null,
                                                        'tooltip_1': null,
                                                        'tooltip_2': null
                                                    },
                                                ]   
                                            }
                                            else {
                                                homeT_goalyes = [
                                                    {
                                                        'mark': '76-90',
                                                        'value': parseInt(scoreline.goalyes['90']) + '%',
                                                        'green': null,
                                                        'tooltip_1': null,
                                                        'tooltip_2': null
                                                    },
                                                ] 
                                            }
                                        }
                                    }
                                }
                                
                            }

                           
                            if (inplayOdds_home !== '' && homewin_stat != '') {
                                var val = this.get_trueodds_value(inplayOdds_home, homewin_stat)
                                var true_odd = val[0]
                                var value = val[1]
                                homeT_homewin_stat_tooltip_1 = true_odd.toFixed(2)
                                homeT_homewin_stat_tooltip_2 = value.toFixed(2)
                                if (value > 10) {
                                    homeT_homewin_stat_green = true;
                                }
                            }

                            if (inplayOdds_draw !== '' && drawwin_stat != '') {
                                var val = this.get_trueodds_value(inplayOdds_draw, drawwin_stat)
                                var true_odd = val[0]
                                var value = val[1]
                                homeT_drawwin_stat_tooltip_1 = true_odd.toFixed(2)
                                homeT_drawwin_stat_tooltip_2 = value.toFixed(2)
                                if (value > 10) {
                                    homeT_drawwin_stat_green = true;
                                }
                            }

                            if (inplayOdds_away !== '' && awaywin_stat != '') {
                                var val = this.get_trueodds_value(inplayOdds_away, awaywin_stat)
                                var true_odd = val[0]
                                var value = val[1]
                                homeT_awaywin_stat_tooltip_1 = true_odd.toFixed(2)
                                homeT_awaywin_stat_tooltip_2 = value.toFixed(2)
                                if (value > 10) {
                                    homeT_awaywin_stat_green = true;
                                }
                            }

                            if (current_event.homeT.over_odds[0].mark) {
                                if (current_event.homeT.over_odds[0].value !== '' && goal_1_plus != '') {
                                    var val = this.get_trueodds_value(current_event.homeT.over_odds[0].value, goal_1_plus)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    homeT_goal_1_plus_tooltip_1 = true_odd.toFixed(2)
                                    homeT_goal_1_plus_tooltip_2 = value.toFixed(2)
                                    if (value > 10) {
                                        homeT_goal_1_plus_green = true;
                                    }
                                }
                                if (current_event.homeT.under_odds[0].value !== '' && goal_1_minus != '') {
                                    var val = this.get_trueodds_value(current_event.homeT.under_odds[0].value, goal_1_minus)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    homeT_goal_1_minus_tooltip_1 = true_odd.toFixed(2)
                                    homeT_goal_1_minus_tooltip_2 = value.toFixed(2)
                                    if (value > 10) {
                                        homeT_goal_1_minus_green = true;
                                    }
                                }

                            }
                            if (current_event.homeT.over_odds[1].mark) {
                                if (current_event.homeT.over_odds[1].value !== '' && goal_2_plus != '') {
                                    var val = this.get_trueodds_value(current_event.homeT.over_odds[1].value, goal_2_plus)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    homeT_goal_2_plus_tooltip_1 = true_odd.toFixed(2)
                                    homeT_goal_2_plus_tooltip_2 = value.toFixed(2)
                                    if (value > 10) {
                                        homeT_goal_2_plus_green = true;
                                    }
                                }
                                if (current_event.homeT.under_odds[1].value !== '' && goal_2_minus != '') {
                                    var val = this.get_trueodds_value(current_event.homeT.under_odds[1].value, goal_2_minus)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    homeT_goal_2_minus_tooltip_1 = true_odd.toFixed(2)
                                    homeT_goal_2_minus_tooltip_2 = value.toFixed(2)
                                    if (value > 10) {
                                        homeT_goal_2_minus_green = true;
                                    }
                                }

                            }

                            if (current_event.homeT.over_odds[0].mark) {
                                if (current_event.homeT.over_odds[0].value !== '') {
                                    for (var gb_index=0; gb_index < homeT_goalyes.length; gb_index++ ){
                                        if (homeT_goalyes[gb_index].value != '-' && homeT_goalyes[gb_index].value != '0%') {
                                            var val = this.get_trueodds_value(current_event.homeT.over_odds[0].value, parseInt(homeT_goalyes[gb_index].value.replace('%', '')))
                                            var true_odd = val[0]
                                            var value = val[1]

                                            homeT_goalyes[gb_index].tooltip_1 = true_odd.toFixed(2)
                                            homeT_goalyes[gb_index].tooltip_2 = value.toFixed(2)
                                            if (value > 10) {
                                                homeT_goalyes[gb_index].green = true;
                                            }
                                        }
                                    }
                                }
                            }


                            current_event.homeT.homewin_stat = homeT_homewin_stat
                            current_event.homeT.awaywin_stat =homeT_awaywin_stat
                            current_event.homeT.drawwin_stat =homeT_drawwin_stat
                            current_event.homeT.homewin_stat_tooltip_1 =homeT_homewin_stat_tooltip_1 
                            current_event.homeT.homewin_stat_tooltip_2 =homeT_homewin_stat_tooltip_2 
                            current_event.homeT.awaywin_stat_tooltip_1 =homeT_awaywin_stat_tooltip_1
                            current_event.homeT.awaywin_stat_tooltip_2 =homeT_awaywin_stat_tooltip_2
                            current_event.homeT.drawwin_stat_tooltip_1 =homeT_drawwin_stat_tooltip_1
                            current_event.homeT.drawwin_stat_tooltip_2 =homeT_drawwin_stat_tooltip_2

                            
                            current_event.homeT.goal_1_plus=homeT_goal_1_plus
                            current_event.homeT.goal_2_plus=homeT_goal_2_plus
                            current_event.homeT.goal_1_minus=homeT_goal_1_minus
                            current_event.homeT.goal_2_minus=homeT_goal_2_minus

                            current_event.homeT.goalnexthome=homeT_goalnexthome
                            current_event.homeT.goalnextaway=homeT_goalnextaway
                            current_event.homeT.goalnextdraw=homeT_goalnextdraw

                            current_event.homeT.goalyes=homeT_goalyes

                            current_event.homeT.homewin_stat_green=homeT_homewin_stat_green
                            current_event.homeT.awaywin_stat_green=homeT_awaywin_stat_green
                            current_event.homeT.drawwin_stat_green=homeT_drawwin_stat_green

                            current_event.homeT.goal_1_plus_green=homeT_goal_1_plus_green
                            current_event.homeT.goal_1_minus_green=homeT_goal_1_minus_green
                            current_event.homeT.goal_2_plus_green=homeT_goal_2_plus_green
                            current_event.homeT.goal_2_minus_green=homeT_goal_2_minus_green
                            current_event.homeT.goal_1_plus_tooltip_1=homeT_goal_1_plus_tooltip_1
                            current_event.homeT.goal_1_plus_tooltip_2=homeT_goal_1_plus_tooltip_2
                            current_event.homeT.goal_1_minus_tooltip_1=homeT_goal_1_minus_tooltip_1
                            current_event.homeT.goal_1_minus_tooltip_2=homeT_goal_1_minus_tooltip_2
                            current_event.homeT.goal_2_plus_tooltip_1=homeT_goal_2_plus_tooltip_1
                            current_event.homeT.goal_2_plus_tooltip_2=homeT_goal_2_plus_tooltip_2
                            current_event.homeT.goal_2_minus_tooltip_1=homeT_goal_2_minus_tooltip_1
                            current_event.homeT.goal_2_minus_tooltip_2=homeT_goal_2_minus_tooltip_2

                            current_event.homeT.number_of_matches = matched_events

                            ////////////////////////////////////////////////////
                            
                            this.eventArray[j].events[k] = current_event
                            
                        }
                    }
                    
                }
            },
            readData(){
                if(this.reload_flag == false){
                    this.reload_flag = true

                    if (!this.live_load_flag)
                        this.showModal();

                    var user_id = localStorage.getItem("user_id");
                    var post_data = {
                        "user_id": user_id
                    }
                    window.axios.post(`${process.env.VUE_APP_URL}getLiveStatsNew_origin`, post_data).then(({data})=> {
                        this.eventArray = data.data[0][0];
                        
                        this.liveNumbers = data.data[0][1];
                        this.scheduleLength = data.data[3];
                        this.finishedLength =  data.data[4];

                        if (!this.live_load_flag) {
                            this.hideModal();
                            this.live_load_flag = true;
                        }

                        let leagues = [];
                        data.data[5].forEach((oItem) => {
                            leagues.push(
                                {
                                    league_name: oItem.country_name +  " - " +  oItem.league_name,
                                    league_id: oItem.league_id

                                }
                            );                            
                        });
                        this.sortJSON(leagues,'league_name', '123')

                        this.leagueOptions[0].leagues = leagues;

                        this.reload_flag = false;
                        
                    })
                    .catch(error => {                      
                        console.error("There was an error!", error);
                        this.reload_flag = false;
                    });

                    

                }
            },
            readNewData(eventIds){
                if(this.reload_flag == false){
                    this.reload_flag = true;                   

                    var user_id = localStorage.getItem("user_id");
                    var post_data = {
                        user_id: user_id,
                        eventIds: eventIds
                    }
                    window.axios.post(`${process.env.VUE_APP_URL}getLiveStatsNew_new_origin`, post_data).then(({data})=> {
                        this.liveNumbers += data.data[0][1];
                        this.scheduleLength -= data.data[0][1];

                        let new_eventArray = data.data[0][0];
                        let current_leagueIds = this.eventArray.map( league => league.league_id );

                        for (var i = 0; i < new_eventArray.length; i++) {
                            let new_league = new_eventArray[i];
                            if ( current_leagueIds.includes(new_league.league_id) ) {
                                let league_index = this.eventArray.findIndex( league => league.league_id === new_league.league_id);
                                this.eventArray[league_index].events = [
                                    ...new_league.events,
                                    ...this.eventArray[league_index].events
                                ]
                            }
                            else {
                                this.eventArray.push(new_league);
                            }
                        }

                        let self = this;                        
                        this.sortJSON(self.eventArray, 'league', '123')
                        
                        this.reload_flag = false;
                        
                    })
                    .catch(error => {                      
                        console.error("There was an error!", error);
                        this.reload_flag = false
                    });

                }
            },
            sortJSON(data, key){
                return data.sort(function(a, b) {
                    var x = a[key]; var y = b[key];
                    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
                });
            },
            sort_filter(val){
                
                if(val === 1){
                    this.sort = 0
                    this.scheduleArray = this.scheduleArray1
                }
                else{
                    this.sort = 1
                    let temp0 =  JSON.stringify(this.scheduleArray)
                    let schedule0 = JSON.parse(temp0)
                    let newArray = []
                    for(let i = 0 ; i < schedule0.length; i++){
                        for(let j = 0 ; j < schedule0[i].events.length; j++){
                            newArray.push({"data": schedule0[i].events[j], "time": schedule0[i].events[j].time.starting_at.timestamp})
                        }
                    }
                    this.sortJSON(newArray,'time', '123')
                    let sortedNewArray = []
                    let k = 0
                    for(let i = 0 ; i < newArray.length - 1 ; i++){
                        let league1 = newArray[i].data.competitions[0].league
                        let league2 = newArray[i + 1].data.competitions[0].league
                        if(i === 0){
                            k++
                            sortedNewArray.push({'id': this.create_UUID(), "league": newArray[0].data.competitions[0].league, "events": [newArray[i].data]})
                        }
                        else{
                            if(league1 === league2){
                                sortedNewArray[k - 1].events.push(newArray[i + 1].data)
                            }
                            else{
                                k++
                                sortedNewArray.push({'id': this.create_UUID(),"league": league2, "events": [newArray[i + 1].data]})
                            }
                        }
                    }
                    
                    this.scheduleArray = sortedNewArray
                }
            },
            resetHomeAway(model, fav_team, under_team, win_team, lose_team) {
                let ha_option = model.ha_option;
                let operation_option = model.operation_option;

                if (ha_option ==='' || operation_option === '')
                    return false;

                let model_option;

                if (ha_option === "1"){
                    model_option = operation_option.replace("team1", "Home");
                    model_option = model_option.replace("team2", "Away");
                }
                else if (ha_option === "2"){
                    if ( !fav_team )
                        return false;
                    model_option = operation_option.replace("team1", fav_team);
                    model_option = model_option.replace("team2", under_team);
                }
                else if (ha_option === "3"){
                    if ( !win_team )
                        return false;
                    model_option = operation_option.replace("team1", win_team);
                    model_option = model_option.replace("team2", lose_team);
                }
                console.log(operation_option, model_option)
                return model_option;
            },
            check_one_filter(model_option,min, max, home, away) {
                if (min !== "" && min.includes(",") === false)
                    min = parseInt(min);
                if (max !== "" && max.includes(",") === false)
                    max = parseInt(max);

                if (model_option === 'Home, Away' || model_option === 'Away, Home' ) {
                    if (model_option === 'Home, Away'){
                        if (min !== "" && min.includes(",")){
                            let home_min = parseInt(min.split(",")[0]);
                            let away_min = parseInt(min.split(",")[1]);
                            if (home < home_min || away < away_min)
                                return false;
                        }
                        if (max !== "" && max.includes(",")){
                            let home_max = parseInt(max.split(",")[0]);
                            let away_max = parseInt(max.split(",")[1]);
                            if (home > home_max || away > away_max)
                                return false;
                        }
                    }
                    else if (model_option === 'Away, Home'){
                        if (min !== "" && min.includes(",")){
                            let home_min = parseInt(min.split(",")[1]);
                            let away_min = parseInt(min.split(",")[0]);
                            if (home < home_min || away < away_min)
                                return false;
                        }
                        if (max !== "" && max.includes(",")){
                            let home_max = parseInt(max.split(",")[1]);
                            let away_max = parseInt(max.split(",")[0]);
                            if (home > home_max || away > away_max)
                                return false;
                        }
                    }
                    
                }

                else if (model_option === 'Home') {
                    if (min !== '' && home < min)
                        return false;
                    if (max !== '' && home > max)
                        return false;
                }
                else if (model_option === 'Away') {
                    if (min !== '' && away < min)
                        return false;
                    if (max !== '' && away > max)
                        return false;
                }
                else if (model_option === 'Home OR Away' || model_option === 'Away OR Home') {
                    if ((min !== '' && home < min) && (min !== '' && away < min))
                        return false;
                    if ((max !== '' && home > max) && (max !== '' && away > max))
                        return false;
                }
                else if (model_option === 'Home AND Away' || model_option === 'Away AND Home') {
                    if ((min !== '' && home < min) || (min !== '' && away < min))
                        return false;
                    if ((max !== '' && home > max) || (max !== '' && away > max))
                        return false;
                }
                else if (model_option === 'Home > Away' || model_option === 'Away < Home') {
                    let diff = home - away;
                    if (diff <= 0)
                        return false;                       
                    
                    if (min !== '' && diff <= min)
                        return false;
                    if (max !== '' && diff >= max)
                        return false;
                }
                else if (model_option === 'Home < Away'  || model_option === 'Away > Home') {
                    let diff = away - home;
                    if (diff <= 0)
                        return false;                       
                    
                    if (min !== '' && diff <= min)
                        return false;
                    if (max !== '' && diff >= max)
                        return false;
                }

                else if (model_option === 'sum greater than') {
                    let sum = home + away;
                    if (min !== '' && sum <= min)
                        return false;
                    if (max !== '' && sum >= max)
                        return false;

                }
                else if (model_option === 'sum minor than') {
                    let sum = home + away;
                    if (min !== '' && sum <= min)
                        return false;
                    if (max !== '' && sum >= max)
                        return false;

                }
                else if (model_option === 'diff greater than') {
                    let diff = Math.abs(away - home);
                    if (min !== '' && diff <= min)
                        return false;
                    if (max !== '' && diff >= max)
                        return false;

                }
                else if (model_option === 'diff minor than') {
                    let diff = Math.abs(away - home);
                    if (min !== '' && diff <= min)
                        return false;
                    if (max !== '' && diff >= max)
                        return false;

                }

                else if (model_option === 'Home = Away'  || model_option === 'Away = Home') {
                    return home === away;
                }

                else if (model_option === 'Home OR Away > Home OR Away' || model_option === 'Away OR Home > Away OR Home') {
                    let diff = Math.abs(away - home);
                    if (diff == 0)
                        return false;                       
                    
                    if (min !== '' && diff <= min)
                        return false;
                    if (max !== '' && diff >= max)
                        return false;
                }
                
                return true;
            },
            checkSearchFilter(event) {

                //check Time
                if (this.search_model.time_min !== "" || this.search_model.time_max !== "") {
                    let event_minute = event.home.time;
                    event_minute = event_minute;
                    if (event_minute == "HT")
                        event_minute = 45;
                    else if (event_minute == "FT")
                        event_minute = 90;
                    event_minute = parseInt(event_minute);

                    if (this.search_model.time_min !== "") {
                        if (event_minute < parseInt(this.search_model.time_min))
                            return false;
                    }
                    if (this.search_model.time_max !== "") {
                        if (event_minute > parseInt(this.search_model.time_max))
                            return false;
                    }
                    
                }
                
                let fav_team = null;
                let under_team = null;
                let win_team = null;
                let lose_team = null;

                if (event.flatOdds_home < event.flatOdds_away){
                    fav_team = "Home";
                    under_team = "Away";
                }
                else if (event.flatOdds_home > event.flatOdds_away){

                    fav_team = "Away";
                    under_team = "Home";
                }

                if (event.home.score > event.away.score) {
                    win_team = "Home";
                    lose_team = "Away";
                }
                else if (event.home.score < event.away.score) {
                    win_team = "Away";
                    lose_team = "Home";
                }

                let model_option;
                let model;
                let home_val;
                let away_val;
                let check_val;

                //check Total 
                // rank
                if (this.search_model_total.rank.ha_option !== "" && this.search_model_total.rank.operation_option !== "") {
                    model = this.search_model_total.rank;
                    model_option = this.resetHomeAway(model, fav_team, under_team, win_team, lose_team);
                    if (!model_option)
                        return false;

                    home_val = event.main_data.home_rank;
                    away_val = event.main_data.away_rank;
                    if (home_val == null)
                        home_val = 0;
                    if (away_val == null)
                        away_val = 0;

                    check_val = this.check_one_filter(model_option, this.search_model_total.rank.min, this.search_model_total.rank.max, home_val, away_val);

                    if (!check_val)
                        return false;

                }
                //score
                if (this.search_model_total.score.ha_option !== "" && this.search_model_total.score.operation_option !== "") {
                    
                    model = this.search_model_total.score;
                    model_option = this.resetHomeAway(model, fav_team, under_team, win_team, lose_team);
                    if (!model_option)
                        return false;

                    home_val = event.home.score;
                    away_val = event.away.score;

                    check_val = this.check_one_filter(model_option, this.search_model_total.score.min, this.search_model_total.score.max, home_val, away_val);

                    if (!check_val)
                        return false;
                }
                //on, off, blk, in, out, cnr, da, poss, red, yel, sbst, nxt, rtg
                let keys;
                keys = ['on', 'off', 'blk', 'in', 'out', 'cnr', 'da', 'poss', 'red', 'yel', 'sbst', 'nxt', 'rtg'];
                for (var i=0; i<keys.length; i++) {
                    let key = keys[i];
                    if (this.search_model_total[key].ha_option !== "" && this.search_model_total[key].operation_option !== "") {
                        model = this.search_model_total[key];
                        model_option = this.resetHomeAway(model, fav_team, under_team, win_team, lose_team);
                        if (!model_option)
                            return false;

                        home_val = event.homeT[key];
                        away_val = event.awayT[key];

                        if (home_val == null)
                            home_val = 0;
                        if (away_val == null)
                            away_val = 0;

                        home_val = parseInt(home_val);
                        away_val = parseInt(away_val);

                        check_val = this.check_one_filter(model_option, this.search_model_total[key].min, this.search_model_total[key].max, home_val, away_val);

                        if (!check_val)
                            return false;
                    }
                }

                // 10 mins of on, off, blk, in, out, cnr, da, poss, red, yel, sbst, nxt, rtg
                keys = ['on', 'off', 'blk', 'in', 'out', 'cnr', 'da', 'poss', 'sbst', 'goal', 'rtg'];
                for (var i=0; i<keys.length; i++) {
                    let key = keys[i];
                    if (this.search_model_ten[key].ha_option !== "" && this.search_model_ten[key].operation_option !== "") {
                        model = this.search_model_ten[key];
                        model_option = this.resetHomeAway(model, fav_team, under_team, win_team, lose_team);
                        if (!model_option)
                            return false;

                        home_val = event.home[key];
                        away_val = event.away[key];

                        if (home_val == null)
                            home_val = 0;
                        if (away_val == null)
                            away_val = 0;
                        
                        home_val = parseInt(home_val);
                        away_val = parseInt(away_val);

                        check_val = this.check_one_filter(model_option, this.search_model_ten[key].min, this.search_model_ten[key].max, home_val, away_val);

                        if (!check_val)
                            return false;
                    }
                }

                return true;
            },
            getUserId() {
                var user_id = localStorage.getItem("user_id");
                return user_id;
                
            },
            handleCreatePreset() {
                this.showSaveFilter = !this.showSaveFilter;
                if (this.showSaveFilter)
                    this.showLoadFilter = false;
            },
            handleLoadPreset() {
                this.showLoadFilter = !this.showLoadFilter;
                if (this.showLoadFilter)
                    this.showSaveFilter = false;
            },
            handleSaveFilter() {
                let user_id = this.getUserId();
                if (user_id == 'undefined' || user_id == null) {                    
                    swal.fire("Alert!", "User not specified", "error");
                    return;
                }
                else {
                    console.log('---- user id  found ---');
                }
                this.save_filter = true;

                // let allLeagues = false;
                // if (this.search_filters.league.length === this.leagueOptions[0].leagues.length)
                //     allLeagues = true;
                let post_data = {
                    league: this.search_filters.league,
                    time_min: this.search_model.time_min,
                    time_max: this.search_model.time_max,
                    search_model_total: this.search_model_total,
                    search_model_ten: this.search_model_ten,
                    user_id: parseInt(user_id),
                    filter_name: this.filter_name,
                    // allLeagues: allLeagues
                };
                window.axios.post(`${process.env.VUE_APP_URL}post_liveStat_model`, post_data).then(({data})=> {
                    this.save_filter = false;

                   
                    this.getSavedFilters();
                    displaySuccess({message: "Filter saved successfully"});
                    this.init_liveStat_model();
                    this.filter_name = "";
                    this.showSaveFilter = false;

                    setTimeout(() => {
                        this.$nextTick(() => {
                            var el = document.querySelector("#top-element");
                            el.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center'
                            });
                        });
                    }, 500);
                });
            },
            handleUpdateFilter() {
                let user_id = this.getUserId();
                if (user_id == 'undefined' || user_id == null) {                    
                    swal.fire("Alert!", "User not specified", "error");
                    return;
                }
                else {
                    console.log('---- user id  found ---');
                }
                this.update_filter = true;

                let allLeagues = false;
                if (this.search_filters.league.length === this.leagueOptions[0].leagues.length)
                    allLeagues = true;

                let post_data = {
                    league: this.search_filters.league,
                    time_min: this.search_model.time_min,
                    time_max: this.search_model.time_max,
                    search_model_total: this.search_model_total,
                    search_model_ten: this.search_model_ten,
                    user_id: parseInt(user_id),
                    filter_name: this.edit_filter_name,
                    _id: this.liveStat_model_id,
                    allLeagues: allLeagues
                    
                };
                window.axios.post(`${process.env.VUE_APP_URL}post_liveStat_model`, post_data).then(({data})=> {
                    this.update_filter = false;
                    this.showEditFilter = false;
                    this.showSaveFilter = false;
                    this.liveStat_model_id = null;
                    
                    this.getSavedFilters();
                    displaySuccess({message: "Filter updated successfully"});
                    
                });
            },
            getSavedFilters() {
                let user_id = this.getUserId();
                if (user_id == 'undefined' || user_id == null) { 
                    return;
                }
                else {                    
                    let post_data = {                        
                        user_id: parseInt(user_id)                       
                    };
                    window.axios.post(`${process.env.VUE_APP_URL}get_liveStat_model`, post_data).then(({data})=> {
                        let models = data.data;
                        let saved_filters = [{value: "", label: this.$t("choose filters")}];
                        for (var i=0; i<models.length; i++) {
                            saved_filters.push({
                                label: models[i].filter_name,
                                value: models[i]._id
                            })
                            
                        }
                        this.saved_filters = saved_filters;
                    });
                }
                
            },
            handleLoadFilter() {
                let user_id = this.getUserId();
                if (user_id == 'undefined' || user_id == null) { 
                    return;
                }
                else {
                    if (this.selected_filter) {
                        this.load_filter = true;
                        let post_data = { 
                            user_id: parseInt(user_id),
                            _id: this.selected_filter
                        };
                        window.axios.post(`${process.env.VUE_APP_URL}get_liveStat_model`, post_data).then(({data})=> {
                            let models = data.data;
                            

                            this.search_filters.league = models[0].league;
                            this.search_model.time_min = models[0].time_min;
                            this.search_model.time_max = models[0].time_max;
                            this.search_model_total = models[0].search_model_total;
                            this.search_model_ten = models[0].search_model_ten;

                            this.load_filter = false;
                            displaySuccess({message: "Filter loaded successfully"});

                        });
                    }
                    
                }

            },
            handleDeleteFilter() {
                let user_id = this.getUserId();
                if (user_id == 'undefined' || user_id == null) { 
                    return;
                }
                else {
                    if (this.selected_filter) {
                        swal
                        .fire({
                            title: "Are you sure?",
                            text: "You won't be able to revert this!",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Yes, delete it!",
                        })
                        .then((result) => {
                            if (result.value) {
                                this.delete_filter = true;
                                let post_data = {                        
                                    user_id: parseInt(user_id),
                                    _id: this.selected_filter
                                };
                                window.axios.post(`${process.env.VUE_APP_URL}delete_liveStat_model`, post_data).then(({data})=> {
                                    let cIndex = this.saved_filters.findIndex( item => item.value == this.selected_filter);
                                    this.saved_filters.splice(cIndex, 1);
                                    this.delete_filter = false;
                                    this.selected_filter = "";

                                    this.init_liveStat_model();
                                    this.showEditFilter = false;
                                    this.showSaveFilter = false;
                                    this.liveStat_model_id = null;


                                    displaySuccess({message: "Filter deleted successfully"});
                                });
                            }
                        });

                        
                    }
                }

            },
            handleEditFilter() {
                let user_id = this.getUserId();
                if (user_id == 'undefined' || user_id == null) { 
                    return;
                }
                else {
                    if (this.selected_filter) {
                        this.edit_filter = true;
                        let post_data = {                        
                            user_id: parseInt(user_id),
                            _id: this.selected_filter
                        };
                        window.axios.post(`${process.env.VUE_APP_URL}get_liveStat_model`, post_data).then(({data})=> {
                            
                            let models = data.data;
                            this.search_filters.league = models[0].league;
                            this.search_model.time_min = models[0].time_min;
                            this.search_model.time_max = models[0].time_max;
                            this.search_model_total = models[0].search_model_total;
                            this.search_model_ten = models[0].search_model_ten;

                            if (models[0].allLeagues !== false){
                                this.search_filters.league = this.leagueOptions[0].leagues;
                            }
                            else{
                                let leagueList = [];
                                for (let i=0; i < models[0].league.length; i++) {
                                    let indexFound = this.leagueOptions[0].leagues.findIndex( dItem => dItem.league_name === models[0].league[i].league_name);
                                    if (indexFound > -1)
                                        leagueList.push(models[0].league[i])
                                }
                            }
                            
                            this.edit_filter = false;

                            this.showSaveFilter = false;
                            this.showEditFilter = true;


                            this.edit_filter_name = models[0].filter_name;
                            this.liveStat_model_id = models[0]._id;


                            console.log('   scrolling to top')
                            //window.scrollTo(0,0);

                            setTimeout(() => {
                                this.$nextTick(() => {
                                    var el = document.querySelector("#top-element");
                                    el.scrollIntoView({
                                        behavior: 'smooth',
                                        block: 'center'
                                    });
                                });
                            }, 500);
                        });

                    }
                }
            },
        },
        mounted: function (){
            this.$nextTick(function () {                
                if (!this.live_load_flag) {
                    this.readData()
                    // setInterval(() => this.readData(), 90 * 1000);
                    setInterval(() => this.update5yStats(), 90 * 1000);
                }

                this.getSavedFilters();

            })
                
        },
        created() {
            // this.percallfunction()
            this.refreshIndex++
            
            // let chatUrl = "http://34.242.166.202:5000/";
            let chatUrl = "http://51.38.80.182:5000/";

            

            this.socket = io(chatUrl, {        
            //force websockets only - it's optional
            transports: ["websocket"]
            });

                    
            
            //this.sockets.subscribe('UpdateStats', (data1) => {
            this.socket.on("UpdateStats", data1 => {
                
                if(this.reload_flag == false){
                    var d = new Date()
                    var hour = d.getHours()
                    var minute = d.getMinutes()
                    var second = d.getSeconds()
                    if(hour < 10){
                        hour = '0' + hour
                    }
                    if(minute < 10){
                        minute = '0' + minute
                    }
                    if(second < 10){
                        second = '0' + second
                    }
                    this.last_updated_time = hour + ":" + minute + ":" + second;

                    let new_eventIds = [];

                    let check_new_total = 0
                    for(let i = 0 ; i < data1.length ; i++){
                        if(data1[i].updateArray){
                            let stats = data1[i].updateArray.stats
                            let stats_ten = data1[i].updateArray.stats_ten
                            let goal_tooltip = data1[i].updateArray.goal_tooltip
                            let check_new  = 0
                            let current_main_data = {
                                "home_tip_shots": data1[i].updateArray.home_tip_shots,
                                "home_tip_cnr": data1[i].updateArray.home_tip_cnr,
                                "away_tip_shots": data1[i].updateArray.away_tip_shots,
                                "away_tip_cnr": data1[i].updateArray.away_tip_cnr,
                                "home_tooltip2": data1[i].updateArray.home_tooltip2,
                                "away_tooltip2": data1[i].updateArray.away_tooltip2,
                            }
                            for(let j = 0 ; j < this.eventArray.length ; j++){
                                for(let k = 0 ; k < this.eventArray[j].events.length ; k++){
                                    if(this.eventArray[j].events[k].fixtureId == data1[i].updateArray._id && data1[i].currentData.stats.length > 0){
                                        check_new = 1
                                        let current_event = this.eventArray[j].events[k]
                                        if(data1[i].currentData.time.status == "FT"){
                                            // this.readData()
                                            // return                                            
                                            
                                            let fixture_index = this.eventArray[j].events.findIndex( fixture => fixture.fixtureId === current_event.fixtureId);
                                            
                                            if (fixture_index > -1) {
                                                
                                                this.eventArray[j].events.splice(fixture_index, 1);
                                                this.finishedLength ++;
                                                this.liveNumbers --;
                                                break;
                                                
                                            }

                                            if (this.eventArray[j].events.length === 0) {
                                                this.eventArray.splice(j, 1);
                                            }
                                        }
                                        current_event.home.time = data1[i].currentData.time.minute

                                        if (data1[i].currentData.time.added_time !== null)
                                            current_event.home.added_time = data1[i].currentData.time.added_time + "'"
                                        else
                                            current_event.home.added_time = ""
                                        current_event.homeT.minute = data1[i].currentData.time.minute
                                        let tot_time = data1[i].currentData.time.minute
                                        if(data1[i].currentData.time.injury_time != null){
                                            current_event.home.time = data1[i].currentData.time.minute + '+' + data1[i].currentData.time.injury_time
                                            tot_time = data1[i].currentData.time.minute + data1[i].currentData.time.injury_time
                                        }
                                        if(data1[i].currentData.time.status == 'HT'){
                                            current_event.home.time = 'HT'
                                            tot_time = 45
                                        }
                                        if(data1[i].currentData.time.extra_minute > 0){
                                            current_event.home.time = data1[i].currentData.time.minute + data1[i].currentData.time.extra_minute + "'"
                                        }
                                        current_event.goal_tooltip = data1[i].updateArray.goal_tooltip
                                        let home_goal = data1[i].updateArray.scores.localteam_score
                                        let away_goal = data1[i].updateArray.scores.visitorteam_score
                                        //---------------------------------Last 10 Min--------------------------------------
                                        if(current_event.home.id === stats[0].team_id){
                                            current_event.home.score = data1[i].updateArray.scores.localteam_score
                                            current_event.away.score = data1[i].updateArray.scores.visitorteam_score
                                            if(stats[0].shots && stats_ten.length > 0){
                                                if(stats[0].shots.ongoal != null){
                                                    current_event.home.on = stats[0].shots.ongoal - stats_ten[0][0].shots.ongoal
                                                    current_event.away.on = stats[1].shots.ongoal - stats_ten[0][1].shots.ongoal
                                                }
                                                if(stats[0].shots.offgoal != null){
                                                    current_event.home.off = stats[0].shots.offgoal - stats_ten[0][0].shots.offgoal
                                                    current_event.away.off = stats[1].shots.offgoal - stats_ten[0][1].shots.offgoal
                                                }
                                                if(stats[0].shots.blocked != null){
                                                    current_event.home.blk = stats[0].shots.blocked - stats_ten[0][0].shots.blocked
                                                    current_event.away.blk = stats[1].shots.blocked - stats_ten[0][1].shots.blocked
                                                }
                                                if(stats[0].shots.insidebox != null){
                                                    current_event.home.in = stats[0].shots.insidebox - stats_ten[0][0].shots.insidebox
                                                    current_event.away.in = stats[1].shots.insidebox - stats_ten[0][1].shots.insidebox
                                                }
                                                if(stats[0].shots.outsidebox != null){
                                                    current_event.home.out = stats[0].shots.outsidebox - stats_ten[0][0].shots.outsidebox
                                                    current_event.away.out = stats[1].shots.outsidebox - stats_ten[0][1].shots.outsidebox
                                                }
                                            }
                                            if(stats[0].corners != null && stats_ten.length > 0){
                                                current_event.home.cnr = stats[0].corners - stats_ten[0][0].corners
                                                current_event.away.cnr = stats[1].corners - stats_ten[0][1].corners
                                            }

                                            if(stats[0].attacks && stats_ten[0][0].attacks != null){
                                                if(stats[0].attacks.dangerous_attacks != null){
                                                    current_event.home.da = stats[0].attacks.dangerous_attacks - stats_ten[0][0].attacks.dangerous_attacks
                                                    current_event.away.da = stats[1].attacks.dangerous_attacks - stats_ten[0][1].attacks.dangerous_attacks
                                                }
                                            }
                                            if(stats_ten[0][0].possessiontime != null){
                                                current_event.home.poss = stats_ten[0][0].possessiontime
                                                current_event.away.poss = stats_ten[0][1].possessiontime
                                            }

                                            if(stats[0].substitutions != null){
                                                current_event.home.sbst = stats[0].substitutions - stats_ten[0][0].substitutions
                                                current_event.away.sbst = stats[1].substitutions - stats_ten[0][1].substitutions
                                            }

                                            if(stats[0].goals > current_event.home.goal){
                                                current_event.home.flash = 1
                                            }
                                            else{
                                                current_event.home.flash = 0
                                            }

                                            if(stats[1].goals > current_event.away.goal){
                                                current_event.away.flash = 1
                                            }
                                            else{
                                                current_event.away.flash = 0
                                            }

                                            current_event.home.goal = stats[0].goals - stats_ten[0][0].goals
                                            current_event.away.goal = stats[1].goals - stats_ten[0][1].goals
                                        }
                                        else{
                                            current_event.home.score = data1[i].updateArray.scores.localteam_score
                                            current_event.away.score = data1[i].updateArray.scores.visitorteam_score
                                            if(stats[0].shots && stats_ten[0][0].shots){
                                                if(stats[0].shots.ongoal != null){
                                                    current_event.home.on = stats[1].shots.ongoal - stats_ten[0][1].shots.ongoal
                                                    current_event.away.on = stats[0].shots.ongoal - stats_ten[0][0].shots.ongoal
                                                }
                                                if(stats[0].shots.offgoal != null){
                                                    current_event.home.off = stats[1].shots.offgoal - stats_ten[0][1].shots.offgoal
                                                    current_event.away.off = stats[0].shots.offgoal - stats_ten[0][0].shots.offgoal
                                                }
                                                if(stats[0].shots.blocked != null){
                                                    current_event.home.blk = stats[1].shots.blocked - stats_ten[0][1].shots.blocked
                                                    current_event.away.blk = stats[0].shots.blocked - stats_ten[0][0].shots.blocked
                                                }
                                                if(stats[0].shots.insidebox != null){
                                                    current_event.home.in = stats[1].shots.insidebox - stats_ten[0][1].shots.insidebox
                                                    current_event.away.in = stats[0].shots.insidebox - stats_ten[0][0].shots.insidebox
                                                }
                                                if(stats[0].shots.outsidebox != null){
                                                    current_event.home.out = stats[1].shots.outsidebox - stats_ten[0][1].shots.outsidebox
                                                    current_event.away.out = stats[0].shots.outsidebox - stats_ten[0][0].shots.outsidebox
                                                }
                                            }
                                            if(stats[0].corners != null){
                                                current_event.home.cnr = stats[1].corners - stats_ten[0][1].corners
                                                current_event.away.cnr = stats[0].corners - stats_ten[0][0].corners
                                            }

                                            if(stats[0].attacks && stats_ten[0][0].attacks != null){
                                                if(stats[0].attacks.dangerous_attacks != null){
                                                    current_event.home.da = stats[1].attacks.dangerous_attacks - stats_ten[0][1].attacks.dangerous_attacks
                                                    current_event.away.da = stats[0].attacks.dangerous_attacks - stats_ten[0][0].attacks.dangerous_attacks
                                                }
                                            }
                                            if(stats_ten[0][0].possessiontime != null){
                                                current_event.home.poss = stats_ten[0][1].possessiontime
                                                current_event.away.poss = stats_ten[0][0].possessiontime
                                            }

                                            if(stats[0].substitutions != null){
                                                current_event.home.sbst = stats[1].substitutions - stats_ten[0][1].substitutions
                                                current_event.away.sbst = stats[0].substitutions - stats_ten[0][0].substitutions
                                            }

                                            if(stats[0].goals > current_event.home.goal){
                                                current_event.home.flash = 1
                                            }
                                            else{
                                                current_event.home.flash = 0
                                            }

                                            if(stats[1].goals > current_event.away.goal){
                                                current_event.away.flash = 1
                                            }
                                            else{
                                                current_event.away.flash = 0
                                            }

                                            current_event.home.goal = stats[1].goals - stats_ten[0][1].goals
                                            current_event.away.goal = stats[0].goals - stats_ten[0][0].goals
                                        }

                                        current_event.home.rtg = 0
                                        current_event.away.rtg = 0
                                        if((current_event.home.on >= 0) || (current_event.home.off >= 0) || (current_event.home.cnr >= 0) || (current_event.home.da > 0)){
                                            if(current_event.home.on >= 0){
                                                current_event.home.rtg = current_event.home.rtg + current_event.home.on*3
                                            }
                                            if(current_event.home.off >= 0){
                                                current_event.home.rtg = current_event.home.rtg + current_event.home.off*2
                                            }
                                            if(current_event.home.cnr >= 0){
                                                current_event.home.rtg = current_event.home.rtg + current_event.home.cnr
                                            }
                                            if(current_event.home.da >= 0){
                                                current_event.home.rtg = current_event.home.rtg + current_event.home.da
                                            }
                                        }
                                        else{
                                            current_event.home.rtg = '-'
                                        }

                                        if((current_event.away.on >= 0) || (current_event.away.off >= 0) || (current_event.away.cnr >= 0) || (current_event.away.da > 0)){
                                            if(current_event.away.on >= 0){
                                                current_event.away.rtg = current_event.away.rtg + current_event.away.on*3
                                            }
                                            if(current_event.away.off >= 0){
                                                current_event.away.rtg = current_event.away.rtg + current_event.away.off*2
                                            }
                                            if(current_event.away.cnr >= 0){
                                                current_event.away.rtg = current_event.away.rtg + current_event.away.cnr
                                            }
                                            if(current_event.away.da >= 0){
                                                current_event.away.rtg = current_event.away.rtg + current_event.away.da
                                            }
                                        }
                                        else{
                                            current_event.away.rtg = '-'
                                        }

                                        if(current_event.home.last_goal > 0){
                                            current_event.home.gdr = 0
                                            if(current_event.home.last_on > 0){
                                                current_event.home.gdr = current_event.home.gdr + ((100*current_event.home.on/current_event.home.last_goal/current_event.home.last_on/9)*current_event.home.on)
                                            }
                                            if(current_event.home.last_off > 0){
                                                current_event.home.gdr = current_event.home.gdr + ( ( 100*current_event.home.off/current_event.home.last_goal/current_event.home.last_off/ 9 )*current_event.home.off )
                                            }
                                            if(current_event.home.last_cnr > 0){
                                                current_event.home.gdr = current_event.home.gdr + ((100*current_event.home.cnr/current_event.home.last_goal/current_event.home.last_cnr/9)*current_event.home.cnr )
                                            }
                                            if(current_event.home.last_da > 0){
                                                current_event.home.gdr = current_event.home.gdr + ((100*current_event.home.da/current_event.home.last_goal/current_event.home.last_da/9)*current_event.home.da )
                                            }

                                            if(home_goal === 0){
                                                current_event.homeT.nxt = 0
                                                if(current_event.home.last_goal > 0 && current_event.home.last_on > 0){
                                                    current_event.homeT.nxt = current_event.homeT.nxt + ((current_event.homeT.on*90/tot_time/(current_event.home.last_on*current_event.home.last_goal/current_event.home.last_goal)))
                                                }
                                                if(current_event.home.last_goal > 0 && current_event.home.last_off > 0){
                                                    current_event.homeT.nxt = current_event.homeT.nxt + ((current_event.homeT.off*90/tot_time/(current_event.home.last_off*current_event.home.last_goal/current_event.home.last_goal)))
                                                }
                                                if(current_event.home.last_goal > 0 && current_event.home.last_cnr > 0){
                                                    current_event.homeT.nxt = current_event.homeT.nxt + ((current_event.homeT.cnr*90/tot_time/(current_event.home.last_cnr*current_event.home.last_goal/current_event.home.last_goal)))
                                                }
                                                if(current_event.home.last_goal > 0 && current_event.home.last_da > 0){
                                                    current_event.homeT.nxt = current_event.homeT.nxt + ((current_event.homeT.da*90/tot_time/(current_event.home.last_da*current_event.home.last_goal/current_event.home.last_goal)))
                                                }
                                                current_event.homeT.nxt = (current_event.homeT.nxt*100/4).toFixed(0)
                                                current_event.homeT.nxt = -1 * current_event.homeT.nxt
                                            }
                                            else if(home_goal > 0){
                                                current_event.homeT.nxt = 0
                                                if(current_event.home.last_goal > 0 && current_event.home.last_on > 0){
                                                    current_event.homeT.nxt = current_event.homeT.nxt + ((current_event.homeT.on*90/tot_time/(current_event.home.last_on*home_goal/current_event.home.last_goal)))
                                                }
                                                if(current_event.home.last_goal > 0 && current_event.home.last_off > 0){
                                                    current_event.homeT.nxt = current_event.homeT.nxt + ((current_event.homeT.off*90/tot_time/(current_event.home.last_off*home_goal/current_event.home.last_goal)))
                                                }
                                                if(current_event.home.last_goal > 0 && current_event.home.last_cnr > 0){
                                                    current_event.homeT.nxt = current_event.homeT.nxt + ((current_event.homeT.cnr*90/tot_time/(current_event.home.last_cnr*home_goal/current_event.home.last_goal)))
                                                }
                                                if(current_event.home.last_goal > 0 && current_event.home.last_da > 0){
                                                    current_event.homeT.nxt = current_event.homeT.nxt + ((current_event.homeT.da*90/tot_time/(current_event.home.last_da*home_goal/current_event.home.last_goal)))
                                                }
                                                current_event.homeT.nxt = (current_event.homeT.nxt*100/4 - 100).toFixed(0)
                                                current_event.homeT.nxt = -1 * current_event.homeT.nxt
                                            }
                                            
                                        }
                                        if(current_event.away.last_goal > 0){
                                            current_event.away.gdr = 0
                                            if(current_event.away.last_on > 0){
                                                current_event.away.gdr = current_event.away.gdr + ((100*current_event.away.on/current_event.away.last_goal/current_event.away.last_on/9)*current_event.away.on)
                                            }
                                            if(current_event.away.last_off > 0){
                                                current_event.away.gdr = current_event.away.gdr + ( ( 100*current_event.away.off/current_event.away.last_goal/current_event.away.last_off/ 9 )*current_event.away.off )
                                            }
                                            if(current_event.away.last_cnr > 0){
                                                current_event.away.gdr = current_event.away.gdr + ((100*current_event.away.cnr/current_event.away.last_goal/current_event.away.last_cnr/9)*current_event.away.cnr )
                                            }
                                            if(current_event.away.last_da > 0){
                                                current_event.away.gdr = current_event.away.gdr + ((100*current_event.away.da/current_event.away.last_goal/current_event.away.last_da/9)*current_event.away.da )
                                            }

                                            if(away_goal === 0){
                                                current_event.awayT.nxt = 0
                                                if(current_event.away.last_goal > 0 && current_event.away.last_on > 0){
                                                    current_event.awayT.nxt = current_event.awayT.nxt + ((current_event.awayT.on*90/tot_time/(current_event.away.last_on*current_event.away.last_goal/current_event.away.last_goal)))
                                                }
                                                if(current_event.away.last_goal > 0 && current_event.away.last_off > 0){
                                                    current_event.awayT.nxt = current_event.awayT.nxt + ((current_event.awayT.off*90/tot_time/(current_event.away.last_off*current_event.away.last_goal/current_event.away.last_goal)))
                                                }
                                                if(current_event.away.last_goal > 0 && current_event.away.last_cnr > 0){
                                                    current_event.awayT.nxt = current_event.awayT.nxt + ((current_event.awayT.cnr*90/tot_time/(current_event.away.last_cnr*current_event.away.last_goal/current_event.away.last_goal)))
                                                }
                                                if(current_event.away.last_goal > 0 && current_event.away.last_da > 0){
                                                    current_event.awayT.nxt = current_event.awayT.nxt + ((current_event.awayT.da*90/tot_time/(current_event.away.last_da*current_event.away.last_goal/current_event.away.last_goal)))
                                                }
                                                current_event.awayT.nxt = (current_event.awayT.nxt*100/4).toFixed(0)
                                                current_event.awayT.nxt = -1 * current_event.awayT.nxt
                                            }
                                            else if(away_goal > 0){
                                                current_event.awayT.nxt = 0
                                                if(current_event.away.last_goal > 0 && current_event.away.last_on > 0){
                                                    current_event.awayT.nxt = current_event.awayT.nxt + ((current_event.awayT.on*90/tot_time/(current_event.away.last_on*away_goal/current_event.away.last_goal)))
                                                }
                                                if(current_event.away.last_goal > 0 && current_event.away.last_off > 0){
                                                    current_event.awayT.nxt = current_event.awayT.nxt + ((current_event.awayT.off*90/tot_time/(current_event.away.last_off*away_goal/current_event.away.last_goal)))
                                                }
                                                if(current_event.away.last_goal > 0 && current_event.away.last_cnr > 0){
                                                    current_event.awayT.nxt = current_event.awayT.nxt + ((current_event.awayT.cnr*90/tot_time/(current_event.away.last_cnr*away_goal/current_event.away.last_goal)))
                                                }
                                                if(current_event.away.last_goal > 0 && current_event.away.last_da > 0){
                                                    current_event.awayT.nxt = current_event.awayT.nxt + ((current_event.awayT.da*90/tot_time/(current_event.away.last_da*away_goal/current_event.away.last_goal)))
                                                }
                                                current_event.awayT.nxt = (current_event.awayT.nxt*100/4 - 100).toFixed(0)
                                                current_event.awayT.nxt = -1 * current_event.awayT.nxt
                                            }

                                            
                                        }
                                        if(current_event.home.gdr > 0){
                                            current_event.home.gdr = current_event.home.gdr.toFixed(0)
                                        }
                                        if(current_event.away.gdr > 0){
                                            current_event.away.gdr = current_event.away.gdr.toFixed(0)
                                        }
                                        //----------------------------------goal notification-------------------------------
                                        if(current_event.home.id === stats[0].team_id){
                                            if(stats_ten.length > 1){
                                                if(stats_ten[stats_ten.length - 1][0].goals - stats_ten[stats_ten.length - 2][0].goals > 0){
                                                    current_event.home.flash = 1
                                                }
                                                else{
                                                    current_event.home.flash = 0
                                                }
                                                if(stats_ten[stats_ten.length - 1][1].goals - stats_ten[stats_ten.length - 2][1].goals > 0){
                                                    current_event.away.flash = 1
                                                }
                                                else{
                                                    current_event.away.flash = 0
                                                }
                                            }
                                        }
                                        else{
                                            if(stats_ten.length > 1){
                                                if(stats_ten[stats_ten.length - 1][1].goals - stats_ten[stats_ten.length - 2][1].goals > 0){
                                                    current_event.home.flash = 1
                                                }
                                                else{
                                                    current_event.home.flash = 0
                                                }
                                                if(stats_ten[stats_ten.length - 1][0].goals - stats_ten[stats_ten.length - 2][0].goals > 0){
                                                    current_event.away.flash = 1
                                                }
                                                else{
                                                    current_event.away.flash = 0
                                                }
                                            }
                                        }

                                        current_event.home.goal = stats[0].goals - stats_ten[0][0].goals
                                        current_event.away.goal = stats[1].goals - stats_ten[0][1].goals
                                        //---------------------------------------Total Part---------------------------------
                                        if(current_event.home.id === stats[0].team_id){
                                            if(stats[0].shots){
                                                if(stats[0].shots.ongoal != null){
                                                    current_event.homeT.on = stats[0].shots.ongoal
                                                    current_event.awayT.on = stats[1].shots.ongoal
                                                }
                                                if(stats[0].shots.offgoal != null){
                                                    current_event.homeT.off = stats[0].shots.offgoal
                                                    current_event.awayT.off = stats[1].shots.offgoal
                                                }
                                                if(stats[0].shots.blocked != null){
                                                    current_event.homeT.blk = stats[0].shots.blocked
                                                    current_event.awayT.blk = stats[1].shots.blocked
                                                }
                                                if(stats[0].shots.insidebox != null){
                                                    current_event.homeT.in = stats[0].shots.insidebox
                                                    current_event.awayT.in = stats[1].shots.insidebox
                                                }
                                                if(stats[0].shots.outsidebox != null){
                                                    current_event.homeT.out = stats[0].shots.outsidebox
                                                    current_event.awayT.out = stats[1].shots.outsidebox
                                                }
                                            }
                                            if(stats[0].corners != null){
                                                current_event.homeT.cnr = stats[0].corners
                                                current_event.awayT.cnr = stats[1].corners
                                            }

                                            if(stats[0].attacks != null){
                                                if(stats[0].attacks.dangerous_attacks != null){
                                                    current_event.homeT.da = stats[0].attacks.dangerous_attacks
                                                    current_event.awayT.da = stats[1].attacks.dangerous_attacks
                                                }
                                            }
                                            if(stats[0].goals != null){
                                                current_event.homeT.goal = stats[0].goals
                                                current_event.awayT.goal = stats[1].goals
                                            }
                                            if(stats[0].possessiontime != null){
                                                current_event.homeT.poss = stats[0].possessiontime
                                                current_event.awayT.poss = stats[1].possessiontime
                                            }
                                            if(stats[0].substitutions != null){
                                                current_event.homeT.sbst = stats[0].substitutions
                                                current_event.awayT.sbst = stats[1].substitutions
                                            }
                                            if(stats[0].redcards != null){
                                                current_event.homeT.red = stats[0].redcards
                                                current_event.awayT.red = stats[1].redcards
                                            }
                                            if(stats[0].yellowcards != null){
                                                current_event.homeT.yel = stats[0].yellowcards
                                                current_event.awayT.yel = stats[1].yellowcards
                                            }
                                        }
                                        else{
                                            if(stats[0].shots){
                                                if(stats[0].shots.ongoal != null){
                                                    current_event.homeT.on = stats[1].shots.ongoal
                                                    current_event.awayT.on = stats[0].shots.ongoal
                                                }
                                                if(stats[0].shots.offgoal != null){
                                                    current_event.homeT.off = stats[1].shots.offgoal
                                                    current_event.awayT.off = stats[0].shots.offgoal
                                                }
                                                if(stats[0].shots.blocked != null){
                                                    current_event.homeT.blk = stats[1].shots.blocked
                                                    current_event.awayT.blk = stats[0].shots.blocked
                                                }
                                                if(stats[0].shots.insidebox != null){
                                                    current_event.homeT.in = stats[1].shots.insidebox
                                                    current_event.awayT.in = stats[0].shots.insidebox
                                                }
                                                if(stats[0].shots.outsidebox != null){
                                                    current_event.homeT.out = stats[1].shots.outsidebox
                                                    current_event.awayT.out = stats[0].shots.outsidebox
                                                }
                                            }
                                            if(stats[0].corners != null){
                                                current_event.homeT.cnr = stats[1].corners
                                                current_event.awayT.cnr = stats[0].corners
                                            }

                                            if(stats[0].attacks != null){
                                                if(stats[0].attacks.dangerous_attacks != null){
                                                    current_event.homeT.da = stats[1].attacks.dangerous_attacks
                                                    current_event.awayT.da = stats[0].attacks.dangerous_attacks
                                                }
                                            }
                                            if(stats[0].goals != null){
                                                current_event.homeT.goal = stats[1].goals
                                                current_event.awayT.goal = stats[0].goals
                                            }
                                            if(stats[0].possessiontime != null){
                                                current_event.homeT.poss = stats[1].possessiontime
                                                current_event.awayT.poss = stats[0].possessiontime
                                            }
                                            if(stats[0].substitutions != null){
                                                current_event.homeT.sbst = stats[1].substitutions
                                                current_event.awayT.sbst = stats[0].substitutions
                                            }
                                            if(stats[0].redcards != null){
                                                current_event.homeT.red = stats[1].redcards
                                                current_event.awayT.red = stats[0].redcards
                                            }
                                            if(stats[0].yellowcards != null){
                                                current_event.homeT.yel = stats[1].yellowcards
                                                current_event.awayT.yel = stats[0].yellowcards
                                            }
                                        }

                                        if(current_event.home.last_on > 0 || current_event.home.last_off > 0 || current_event.home.last_cnr > 0 || current_event.home.last_da > 0){
                                            current_event.homeT.rtg = 0
                                            if(home_goal > 0){
                                                if(tot_time > 0 && current_event.home.last_on > 0 && current_event.homeT.on > 0){
                                                    current_event.homeT.rtg = current_event.homeT.rtg + current_event.homeT.on*90/tot_time/current_event.home.last_on
                                                }
                                                if(tot_time > 0 && current_event.home.last_off > 0 && current_event.homeT.off > 0){
                                                    current_event.homeT.rtg = current_event.homeT.rtg + current_event.homeT.off*90/tot_time/current_event.home.last_off
                                                }
                                                if(tot_time > 0 && current_event.home.last_cnr > 0 && current_event.homeT.cnr > 0){
                                                    current_event.homeT.rtg = current_event.homeT.rtg + current_event.homeT.cnr*90/tot_time/current_event.home.last_cnr
                                                }
                                                if(tot_time > 0 && current_event.home.last_da > 0 && current_event.homeT.da > 0){
                                                    current_event.homeT.rtg = current_event.homeT.rtg + current_event.homeT.da*90/tot_time/current_event.home.last_da
                                                }
                                                if(tot_time > 0 && current_event.home.last_goal > 0){
                                                    current_event.homeT.rtg = current_event.homeT.rtg + home_goal*90/tot_time/current_event.home.last_goal
                                                }
                                                current_event.homeT.rtg = (current_event.homeT.rtg*20 - 100).toFixed(0)
                                            }
                                            else{
                                                if(tot_time > 0 && current_event.home.last_on > 0 && current_event.homeT.on > 0){
                                                    current_event.homeT.rtg = current_event.homeT.rtg + current_event.homeT.on*90/tot_time/current_event.home.last_on
                                                }
                                                if(tot_time > 0 && current_event.home.last_off > 0 && current_event.homeT.off > 0){
                                                    current_event.homeT.rtg = current_event.homeT.rtg + current_event.homeT.off*90/tot_time/current_event.home.last_off
                                                }
                                                if(tot_time > 0 && current_event.home.last_cnr > 0 && current_event.homeT.cnr > 0){
                                                    current_event.homeT.rtg = current_event.homeT.rtg + current_event.homeT.cnr*90/tot_time/current_event.home.last_cnr
                                                }
                                                if(tot_time > 0 && current_event.home.last_da > 0 && current_event.homeT.da > 0){
                                                    current_event.homeT.rtg = current_event.homeT.rtg + current_event.homeT.da*90/tot_time/current_event.home.last_da
                                                }
                                                current_event.homeT.rtg = (current_event.homeT.rtg*20 - 100).toFixed(0)
                                            }
                                        }
                                        else{
                                            current_event.homeT.rtg = '-'
                                        }
                                        if(current_event.away.last_on > 0 || current_event.away.last_off > 0 || current_event.away.last_cnr > 0 || current_event.away.last_da > 0){
                                            current_event.awayT.rtg = 0
                                            if(away_goal > 0){
                                                if(tot_time > 0 && current_event.away.last_on > 0 && current_event.awayT.on > 0){
                                                    current_event.awayT.rtg = current_event.awayT.rtg + current_event.awayT.on*90/tot_time/current_event.away.last_on
                                                }
                                                if(tot_time > 0 && current_event.away.last_off > 0 && current_event.awayT.off > 0){
                                                    current_event.awayT.rtg = current_event.awayT.rtg + current_event.awayT.off*90/tot_time/current_event.away.last_off
                                                }
                                                if(tot_time > 0 && current_event.away.last_cnr > 0 && current_event.awayT.cnr > 0){
                                                    current_event.awayT.rtg = current_event.awayT.rtg + current_event.awayT.cnr*90/tot_time/current_event.away.last_cnr
                                                }
                                                if(tot_time > 0 && current_event.away.last_da > 0 && current_event.awayT.da > 0){
                                                    current_event.awayT.rtg = current_event.awayT.rtg + current_event.awayT.da*90/tot_time/current_event.away.last_da
                                                }
                                                if(tot_time > 0 && current_event.away.last_goal > 0){
                                                    current_event.awayT.rtg = current_event.awayT.rtg + away_goal*90/tot_time/current_event.away.last_goal
                                                }
                                                current_event.awayT.rtg = (current_event.awayT.rtg*20 - 100).toFixed(0)
                                            }
                                            else{
                                                if(tot_time > 0 && current_event.away.last_on > 0 && current_event.awayT.on > 0){
                                                    current_event.awayT.rtg = current_event.awayT.rtg + current_event.awayT.on*90/tot_time/current_event.away.last_on
                                                }
                                                if(tot_time > 0 && current_event.away.last_off > 0 && current_event.awayT.off > 0){
                                                    current_event.awayT.rtg = current_event.awayT.rtg + current_event.awayT.off*90/tot_time/current_event.away.last_off
                                                }
                                                if(tot_time > 0 && current_event.away.last_cnr > 0 && current_event.awayT.cnr > 0){
                                                    current_event.awayT.rtg = current_event.awayT.rtg + current_event.awayT.cnr*90/tot_time/current_event.away.last_cnr
                                                }
                                                if(tot_time > 0 && current_event.away.last_da > 0 && current_event.awayT.da > 0){
                                                    current_event.awayT.rtg = current_event.awayT.rtg + current_event.awayT.da*90/tot_time/current_event.away.last_da
                                                }
                                                current_event.awayT.rtg = (current_event.awayT.rtg*20 - 100).toFixed(0)
                                            }
                                        }
                                        else{
                                            current_event.awayT.rtg = '-'
                                        }

                                        let home_tip_array = {
                                            'on': '',
                                            'off': '',
                                            'in': '',
                                            'out': '',
                                            'blk': '',
                                            'cnr': ''
                                        }
                                        let away_tip_array = {
                                            'on': '',
                                            'off': '',
                                            'in': '',
                                            'out': '',
                                            'blk': '',
                                            'cnr': ''
                                        }

                                        if(current_main_data.home_tip_shots){
                                            for(let n = 0 ; n < current_main_data.home_tip_shots.length - 1 ; n++){
                                                if(current_main_data.home_tip_shots[n].shots != null){
                                                    if(n === 0 && current_main_data.home_tip_shots[n].shots.ongoal != 0 && current_main_data.home_tip_shots[n].shots.ongoal != null){
                                                        let time = current_main_data.home_tip_shots[n].time.minute
                                                        if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                            time = time + "+" + current_main_data.home_tip_shots[n].time.extra_time + "'"
                                                        }
                                                        home_tip_array.on = home_tip_array.on + " " + time
                                                    }
                                                    else{
                                                        let time = current_main_data.home_tip_shots[n + 1].time.minute
                                                        if(current_main_data.home_tip_shots[n + 1].time.extra_time > 0){
                                                            time = time + "+" + current_main_data.home_tip_shots[n + 1].time.extra_time + "'"
                                                        }
                                                        if(current_main_data.home_tip_shots[n + 1].shots.ongoal >= 0 && current_main_data.home_tip_shots[n].shots.ongoal === null){
                                                            current_main_data.home_tip_shots[n].shots.ongoal = 0
                                                        }
                                                        let check1 = current_main_data.home_tip_shots[n + 1].shots.ongoal - current_main_data.home_tip_shots[n].shots.ongoal
                                                        let check2 = 0
                                                        if(n >= 1){
                                                            if(current_main_data.home_tip_shots[n].shots.ongoal >= 0 && current_main_data.home_tip_shots[n - 1].shots.ongoal === null){
                                                                current_main_data.home_tip_shots[n - 1].shots.ongoal = 0
                                                            }
                                                            check2 = current_main_data.home_tip_shots[n].shots.ongoal - current_main_data.home_tip_shots[n - 1].shots.ongoal
                                                        }
                                                        if(check1 < 0){
                                                            current_main_data.home_tip_shots[n + 1].shots.ongoal = current_main_data.home_tip_shots[n].shots.ongoal
                                                        }

                                                        if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                            home_tip_array.on = home_tip_array.on + " " + time
                                                        }
                                                        else if(check1 > 1 && check2 >= 0){
                                                            home_tip_array.on = home_tip_array.on + " " + time + "(" + check1 + ")"
                                                        }
                                                    }

                                                    if(n === 0 && current_main_data.home_tip_shots[n].shots.offgoal != 0 && current_main_data.home_tip_shots[n].shots.offgoal != null){
                                                        let time = current_main_data.home_tip_shots[n].time.minute
                                                        if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                            time = time + "+" + current_main_data.home_tip_shots[n].time.extra_time + "'"
                                                        }
                                                        home_tip_array.off = home_tip_array.off + " " + time
                                                    }
                                                    else{
                                                        let time = current_main_data.home_tip_shots[n + 1].time.minute
                                                        if(current_main_data.home_tip_shots[n + 1].time.extra_time > 0){
                                                            time = time + "+" + current_main_data.home_tip_shots[n + 1].time.extra_time + "'"
                                                        }
                                                        if(current_main_data.home_tip_shots[n + 1].shots.offgoal >= 0 && current_main_data.home_tip_shots[n].shots.offgoal === null){
                                                            current_main_data.home_tip_shots[n].shots.offgoal = 0
                                                        }
                                                        let check1 = current_main_data.home_tip_shots[n + 1].shots.offgoal - current_main_data.home_tip_shots[n].shots.offgoal
                                                        let check2 = 0
                                                        if(n >= 1){
                                                            if(current_main_data.home_tip_shots[n].shots.offgoal >= 0 && current_main_data.home_tip_shots[n - 1].shots.offgoal === null){
                                                                current_main_data.home_tip_shots[n - 1].shots.offgoal = 0
                                                            }
                                                            check2 = current_main_data.home_tip_shots[n].shots.offgoal - current_main_data.home_tip_shots[n - 1].shots.offgoal
                                                        }
                                                        if(check1 < 0){
                                                            current_main_data.home_tip_shots[n + 1].shots.offgoal = current_main_data.home_tip_shots[n].shots.offgoal
                                                        }
                                                        if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                            home_tip_array.off = home_tip_array.off + " " + time
                                                        }
                                                        else if(check1 > 1 && check2 >= 0){
                                                            home_tip_array.off = home_tip_array.off + " " + time + "(" + check1 + ")"
                                                        }
                                                    }

                                                    if(n === 0 && current_main_data.home_tip_shots[n].shots.insidebox != 0 && current_main_data.home_tip_shots[n].shots.insidebox != null){
                                                        let time = current_main_data.home_tip_shots[n].time.minute
                                                        if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                            time = time + "+" + current_main_data.home_tip_shots[n].time.extra_time + "'"
                                                        }
                                                        home_tip_array.in = home_tip_array.in + " " + time
                                                    }
                                                    else{
                                                        let time = current_main_data.home_tip_shots[n + 1].time.minute
                                                        if(current_main_data.home_tip_shots[n + 1].time.extra_time > 0){
                                                            time = time + "+" + current_main_data.home_tip_shots[n + 1].time.extra_time + "'"
                                                        }
                                                        if(current_main_data.home_tip_shots[n + 1].shots.insidebox >= 0 && current_main_data.home_tip_shots[n].shots.insidebox === null){
                                                            current_main_data.home_tip_shots[n].shots.insidebox = 0
                                                        }
                                                        let check1 = current_main_data.home_tip_shots[n + 1].shots.insidebox - current_main_data.home_tip_shots[n].shots.insidebox
                                                        let check2 = 0
                                                        if(n >= 1){
                                                            if(current_main_data.home_tip_shots[n].shots.insidebox >= 0 && current_main_data.home_tip_shots[n - 1].shots.insidebox === null){
                                                                current_main_data.home_tip_shots[n - 1].shots.insidebox = 0
                                                            }
                                                            check2 = current_main_data.home_tip_shots[n].shots.insidebox - current_main_data.home_tip_shots[n - 1].shots.insidebox
                                                        }
                                                        if(check1 < 0){
                                                            current_main_data.home_tip_shots[n + 1].shots.insidebox = current_main_data.home_tip_shots[n].shots.insidebox
                                                        }
                                                        if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                            home_tip_array.in = home_tip_array.in + " " + time
                                                        }
                                                        else if(check1 > 1 && check2 >= 0){
                                                            home_tip_array.in = home_tip_array.in + " " + time + "(" + check1 + ")"
                                                        }
                                                    }

                                                    if(n === 0 && current_main_data.home_tip_shots[n].shots.outsidebox != 0 && current_main_data.home_tip_shots[n].shots.outsidebox != null){
                                                        let time = current_main_data.home_tip_shots[n].time.minute
                                                        if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                            time = time + "+" + current_main_data.home_tip_shots[n].time.extra_time + "'"
                                                        }
                                                        home_tip_array.out = home_tip_array.out + " " + time
                                                    }
                                                    else{
                                                        let time = current_main_data.home_tip_shots[n + 1].time.minute
                                                        if(current_main_data.home_tip_shots[n + 1].time.extra_time > 0){
                                                            time = time + "+" + current_main_data.home_tip_shots[n + 1].time.extra_time + "'"
                                                        }
                                                        if(current_main_data.home_tip_shots[n + 1].shots.outsidebox >= 0 && current_main_data.home_tip_shots[n].shots.outsidebox === null){
                                                            current_main_data.home_tip_shots[n].shots.outsidebox = 0
                                                        }
                                                        let check1 = current_main_data.home_tip_shots[n + 1].shots.outsidebox - current_main_data.home_tip_shots[n].shots.outsidebox
                                                        let check2 = 0
                                                        if(n >= 1){
                                                            if(current_main_data.home_tip_shots[n].shots.outsidebox >= 0 && current_main_data.home_tip_shots[n - 1].shots.outsidebox === null){
                                                                current_main_data.home_tip_shots[n - 1].shots.outsidebox = 0
                                                            }
                                                            check2 = current_main_data.home_tip_shots[n].shots.outsidebox - current_main_data.home_tip_shots[n - 1].shots.outsidebox
                                                        }
                                                        if(check1 < 0){
                                                            current_main_data.home_tip_shots[n + 1].shots.outsidebox = current_main_data.home_tip_shots[n].shots.outsidebox
                                                        }
                                                        if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                            home_tip_array.out = home_tip_array.out + " " + time
                                                        }
                                                        else if(check1 > 1 && check2 >= 0){
                                                            home_tip_array.out = home_tip_array.out + " " + time + "(" + check1 + ")"
                                                        }
                                                    }

                                                    if(n === 0 && current_main_data.home_tip_shots[n].shots.blocked != 0 && current_main_data.home_tip_shots[n].shots.blocked != null){
                                                        let time = current_main_data.home_tip_shots[n].time.minute
                                                        if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                            time = time + "+" + current_main_data.home_tip_shots[n].time.extra_time + "'"
                                                        }
                                                        home_tip_array.blk = home_tip_array.blk + " " + time
                                                    }
                                                    else{
                                                        let time = current_main_data.home_tip_shots[n + 1].time.minute
                                                        if(current_main_data.home_tip_shots[n + 1].time.extra_time > 0){
                                                            time = time + "+" + current_main_data.home_tip_shots[n + 1].time.extra_time + "'"
                                                        }
                                                        if(current_main_data.home_tip_shots[n + 1].shots.blocked >= 0 && current_main_data.home_tip_shots[n].shots.blocked === null){
                                                            current_main_data.home_tip_shots[n].shots.blocked = 0
                                                        }
                                                        let check1 = current_main_data.home_tip_shots[n + 1].shots.blocked - current_main_data.home_tip_shots[n].shots.blocked

                                                        let check2 = 0
                                                        if(n >= 1){
                                                            if(current_main_data.home_tip_shots[n].shots.blocked >= 0 && current_main_data.home_tip_shots[n - 1].shots.blocked === null ){
                                                                current_main_data.home_tip_shots[n - 1].shots.blocked = 0
                                                            }
                                                            check2 = current_main_data.home_tip_shots[n].shots.blocked - current_main_data.home_tip_shots[n - 1].shots.blocked
                                                        }
                                                        if(check1 < 0){
                                                            current_main_data.home_tip_shots[n + 1].shots.blocked = current_main_data.home_tip_shots[n].shots.blocked
                                                        }
                                                        if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                            home_tip_array.blk = home_tip_array.blk + " " + time
                                                        }
                                                        else if(check1 > 1 && check2 >= 0){
                                                            home_tip_array.blk = home_tip_array.blk + " " + time + "(" + check1 + ")"
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        if(current_main_data.home_tip_cnr){
                                            for(let n = 0 ; n < current_main_data.home_tip_cnr.length - 1 ; n++){
                                                let time = current_main_data.home_tip_cnr[n].time.minute
                                                if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                    time = time + "+" + current_main_data.home_tip_cnr[n].time.extra_time + "'"
                                                }
                                                if(n === 0 && current_main_data.home_tip_cnr[n].shots != 0 && current_main_data.home_tip_cnr[n].shots != null){
                                                    home_tip_array.cnr = home_tip_array.cnr + " " + time
                                                }
                                                else{
                                                    if(current_main_data.home_tip_cnr[n + 1].shots >= 0 && current_main_data.home_tip_cnr[n].shots === null){
                                                        current_main_data.home_tip_cnr[n].shots = 0
                                                    }
                                                    let check1 = current_main_data.home_tip_cnr[n + 1].shots - current_main_data.home_tip_cnr[n].shots
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.home_tip_cnr[n].shots >= 0 && current_main_data.home_tip_cnr[n - 1].shots === null){
                                                            current_main_data.home_tip_cnr[n - 1].shots = 0
                                                        }
                                                        check2 = current_main_data.home_tip_cnr[n].shots - current_main_data.home_tip_cnr[n - 1].shots
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.home_tip_cnr[n + 1].shots =  current_main_data.home_tip_cnr[n].shots
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        home_tip_array.cnr = home_tip_array.cnr + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        home_tip_array.cnr = home_tip_array.cnr + " " + time + "(" + check1 + ")"
                                                    }
                                                }
                                            }
                                        }
                                        if(current_main_data.away_tip_shots){
                                            for(let n = 0 ; n < current_main_data.away_tip_shots.length - 1 ; n++){
                                                if(current_main_data.away_tip_shots[n].shots != null){

                                                    if(n === 0 && current_main_data.away_tip_shots[n].shots.ongoal != 0 && current_main_data.away_tip_shots[n].shots.ongoal != null){
                                                        let time = current_main_data.away_tip_shots[n].time.minute
                                                        if(current_main_data.away_tip_shots[n].time.extra_time > 0){
                                                            time = time + "+" + current_main_data.away_tip_shots[n].time.extra_time + "'"
                                                        }
                                                        away_tip_array.on = away_tip_array.on + " " + time
                                                    }
                                                    else{
                                                        let time = current_main_data.away_tip_shots[n + 1].time.minute
                                                        if(current_main_data.away_tip_shots[n + 1].time.extra_time > 0){
                                                            time = time + "+" + current_main_data.away_tip_shots[n + 1].time.extra_time + "'"
                                                        }
                                                        if(current_main_data.away_tip_shots[n + 1].shots.ongoal >= 0 && current_main_data.away_tip_shots[n].shots.ongoal === null){
                                                            current_main_data.away_tip_shots[n].shots.ongoal = 0
                                                        }
                                                        let check1 = current_main_data.away_tip_shots[n + 1].shots.ongoal - current_main_data.away_tip_shots[n].shots.ongoal
                                                        let check2 = 0
                                                        if(n >= 1){
                                                            if(current_main_data.away_tip_shots[n].shots.ongoal >= 0 && current_main_data.away_tip_shots[n - 1].shots.ongoal === null){
                                                                current_main_data.away_tip_shots[n - 1].shots.ongoal = 0
                                                            }
                                                            check2 = current_main_data.away_tip_shots[n].shots.ongoal - current_main_data.away_tip_shots[n - 1].shots.ongoal
                                                        }
                                                        if(check1 < 0){
                                                            current_main_data.away_tip_shots[n + 1].shots.ongoal = current_main_data.away_tip_shots[n].shots.ongoal
                                                        }
                                                        if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                            away_tip_array.on = away_tip_array.on + " " + time
                                                        }
                                                        else if(check1 > 1 && check2 >= 0){
                                                            away_tip_array.on = away_tip_array.on + " " + time + "(" + check1 + ")"
                                                        }
                                                    }

                                                    if(n === 0 && current_main_data.away_tip_shots[n].shots.offgoal != 0 && current_main_data.away_tip_shots[n].shots.offgoal != null){
                                                        let time = current_main_data.away_tip_shots[n].time.minute
                                                        if(current_main_data.away_tip_shots[n].time.extra_time > 0){
                                                            time = time + "+" + current_main_data.away_tip_shots[n].time.extra_time + "'"
                                                        }
                                                        away_tip_array.off = away_tip_array.off + " " + time
                                                    }
                                                    else{
                                                        let time = current_main_data.away_tip_shots[n + 1].time.minute
                                                        if(current_main_data.away_tip_shots[n + 1].time.extra_time > 0){
                                                            time = time + "+" + current_main_data.away_tip_shots[n + 1].time.extra_time + "'"
                                                        }
                                                        if(current_main_data.away_tip_shots[n + 1].shots.offgoal >= 0 && current_main_data.away_tip_shots[n].shots.offgoal === null){
                                                            current_main_data.away_tip_shots[n].shots.offgoal = 0
                                                        }
                                                        let check1 = current_main_data.away_tip_shots[n + 1].shots.offgoal - current_main_data.away_tip_shots[n].shots.offgoal
                                                        let check2 = 0
                                                        if(n >= 1){
                                                            if(current_main_data.away_tip_shots[n].shots.offgoal >= 0 && current_main_data.away_tip_shots[n - 1].shots.offgoal === null){
                                                                current_main_data.away_tip_shots[n - 1].shots.offgoal = 0
                                                            }
                                                            check2 = current_main_data.away_tip_shots[n].shots.offgoal - current_main_data.away_tip_shots[n - 1].shots.offgoal
                                                        }
                                                        if(check1 < 0){
                                                            current_main_data.away_tip_shots[n + 1].shots.offgoal = current_main_data.away_tip_shots[n].shots.offgoal
                                                        }
                                                        if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                            away_tip_array.off = away_tip_array.off + " " + time
                                                        }
                                                        else if(check1 > 1 && check2 >= 0){
                                                            away_tip_array.off = away_tip_array.off + " " + time + "(" + check1 + ")"
                                                        }
                                                    }

                                                    if(n === 0 && current_main_data.away_tip_shots[n].shots.insidebox != 0 && current_main_data.away_tip_shots[n].shots.insidebox != null){
                                                        let time = current_main_data.away_tip_shots[n].time.minute
                                                        if(current_main_data.away_tip_shots[n].time.extra_time > 0){
                                                            time = time + "+" + current_main_data.away_tip_shots[n].time.extra_time + "'"
                                                        }
                                                        away_tip_array.in = away_tip_array.in + " " + time
                                                    }
                                                    else{
                                                        let time = current_main_data.away_tip_shots[n + 1].time.minute
                                                        if(current_main_data.away_tip_shots[n + 1].time.extra_time > 0){
                                                            time = time + "+" + current_main_data.away_tip_shots[n + 1].time.extra_time + "'"
                                                        }
                                                        if(current_main_data.away_tip_shots[n + 1].shots.insidebox >= 0 && current_main_data.away_tip_shots[n].shots.insidebox === null){
                                                            current_main_data.away_tip_shots[n].shots.insidebox = 0
                                                        }
                                                        let check1 = current_main_data.away_tip_shots[n + 1].shots.insidebox - current_main_data.away_tip_shots[n].shots.insidebox
                                                        let check2 = 0
                                                        if(n >= 1){
                                                            if(current_main_data.away_tip_shots[n].shots.insidebox >= 0 && current_main_data.away_tip_shots[n - 1].shots.insidebox === null){
                                                                current_main_data.away_tip_shots[n - 1].shots.insidebox = 0
                                                            }
                                                            check2 = current_main_data.away_tip_shots[n].shots.insidebox - current_main_data.away_tip_shots[n - 1].shots.insidebox
                                                        }
                                                        if(check1 < 0){
                                                            current_main_data.away_tip_shots[n + 1].shots.insidebox = current_main_data.away_tip_shots[n].shots.insidebox
                                                        }
                                                        if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                            away_tip_array.in = away_tip_array.in + " " + time
                                                        }
                                                        else if(check1 > 1 && check2 >= 0){
                                                            away_tip_array.in = away_tip_array.in + " " + time + "(" + check1 + ")"
                                                        }
                                                    }

                                                    if(n === 0 && current_main_data.away_tip_shots[n].shots.outsidebox != 0 && current_main_data.away_tip_shots[n].shots.outsidebox != null){
                                                        let time = current_main_data.away_tip_shots[n].time.minute
                                                        if(current_main_data.away_tip_shots[n].time.extra_time > 0){
                                                            time = time + "+" + current_main_data.away_tip_shots[n].time.extra_time + "'"
                                                        }
                                                        away_tip_array.out = away_tip_array.out + " " + time
                                                    }
                                                    else{
                                                        let time = current_main_data.away_tip_shots[n + 1].time.minute
                                                        if(current_main_data.away_tip_shots[n + 1].time.extra_time > 0){
                                                            time = time + "+" + current_main_data.away_tip_shots[n + 1].time.extra_time + "'"
                                                        }
                                                        if(current_main_data.away_tip_shots[n + 1].shots.outsidebox >= 0 && current_main_data.away_tip_shots[n].shots.outsidebox === null){
                                                            current_main_data.away_tip_shots[n].shots.outsidebox = 0
                                                        }
                                                        let check1 = current_main_data.away_tip_shots[n + 1].shots.outsidebox - current_main_data.away_tip_shots[n].shots.outsidebox
                                                        let check2 = 0
                                                        if(n >= 1){
                                                            if(current_main_data.away_tip_shots[n].shots.outsidebox >= 0 && current_main_data.away_tip_shots[n - 1].shots.outsidebox === null){
                                                                current_main_data.away_tip_shots[n - 1].shots.outsidebox = 0
                                                            }
                                                            check2 = current_main_data.away_tip_shots[n].shots.outsidebox - current_main_data.away_tip_shots[n - 1].shots.outsidebox
                                                        }
                                                        if(check1 < 0){
                                                            current_main_data.away_tip_shots[n + 1].shots.outsidebox = current_main_data.away_tip_shots[n].shots.outsidebox
                                                        }
                                                        if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                            away_tip_array.out = away_tip_array.out + " " + time
                                                        }
                                                        else if(check1 > 1 && check2 >= 0){
                                                            away_tip_array.out = away_tip_array.out + " " + time + "(" + check1 + ")"
                                                        }
                                                    }

                                                    if(n === 0 && current_main_data.away_tip_shots[n].shots.blocked != 0 && current_main_data.away_tip_shots[n].shots.blocked != null){
                                                        let time = current_main_data.away_tip_shots[n].time.minute
                                                        if(current_main_data.away_tip_shots[n].time.extra_time > 0){
                                                            time = time + "+" + current_main_data.away_tip_shots[n].time.extra_time + "'"
                                                        }
                                                        away_tip_array.blk = away_tip_array.blk + " " + time
                                                    }
                                                    else{
                                                        let time = current_main_data.away_tip_shots[n + 1].time.minute
                                                        if(current_main_data.away_tip_shots[n + 1].time.extra_time > 0){
                                                            time = time + "+" + current_main_data.away_tip_shots[n + 1].time.extra_time + "'"
                                                        }
                                                        if(current_main_data.away_tip_shots[n + 1].shots.blocked >= 0 && current_main_data.away_tip_shots[n].shots.blocked === null){
                                                            current_main_data.away_tip_shots[n].shots.blocked = 0
                                                        }
                                                        let check1 = current_main_data.away_tip_shots[n + 1].shots.blocked - current_main_data.away_tip_shots[n].shots.blocked
                                                        let check2 = 0
                                                        if(n >= 1){
                                                            if(current_main_data.away_tip_shots[n].shots.blocked >= 0 && current_main_data.away_tip_shots[n - 1].shots.blocked === null){
                                                                current_main_data.away_tip_shots[n - 1].shots.blocked = 0
                                                            }
                                                            check2 = current_main_data.away_tip_shots[n].shots.blocked - current_main_data.away_tip_shots[n - 1].shots.blocked
                                                        }
                                                        if(check1 < 0){
                                                            current_main_data.away_tip_shots[n + 1].shots.blocked = current_main_data.away_tip_shots[n].shots.blocked
                                                        }
                                                        if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                            away_tip_array.blk = away_tip_array.blk + " " + time
                                                        }
                                                        else if(check1 > 1 && check2 >= 0){
                                                            away_tip_array.blk = away_tip_array.blk + " " + time + "(" + check1 + ")"
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        if(current_main_data.away_tip_cnr){
                                            for(let n = 0 ; n < current_main_data.away_tip_cnr.length - 1 ; n++){
                                                let time = current_main_data.away_tip_cnr[n].time.minute
                                                if(current_main_data.away_tip_cnr[n].time.extra_time > 0){
                                                    time = time + "+" + current_main_data.away_tip_cnr[n].time.extra_time + "'"
                                                }
                                                if(n === 0 && current_main_data.away_tip_cnr[n].shots != 0 && current_main_data.away_tip_cnr[n].shots != null){
                                                    away_tip_array.cnr = away_tip_array.cnr + " " + time
                                                }
                                                else{
                                                    if(current_main_data.away_tip_cnr[n + 1].shots >= 0 && current_main_data.away_tip_cnr[n].shots === null){
                                                        current_main_data.away_tip_cnr[n].shots = 0
                                                    }
                                                    let check1  = current_main_data.away_tip_cnr[n + 1].shots - current_main_data.away_tip_cnr[n].shots
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.away_tip_cnr[n].shots >= 0 && current_main_data.away_tip_cnr[n - 1].shots === null){
                                                            current_main_data.away_tip_cnr[n - 1].shots = 0
                                                        }
                                                        check2  = current_main_data.away_tip_cnr[n].shots - current_main_data.away_tip_cnr[n - 1].shots
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.away_tip_cnr[n + 1].shots = current_main_data.away_tip_cnr[n].shots
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        away_tip_array.cnr = away_tip_array.cnr + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        away_tip_array.cnr = away_tip_array.cnr + " " + time + "(" + check1 + ")"
                                                    }
                                                }
                                            }
                                        }

                                        if(current_event.home_tooltip.on != home_tip_array.on && home_tip_array.on != ''){
                                            current_event.home_tooltip.onKey = this.create_UUID()
                                            current_event.home_tooltip.on = home_tip_array.on
                                        }
                                        if(current_event.home_tooltip.off != home_tip_array.off && home_tip_array.off != ''){
                                            current_event.home_tooltip.offKey = this.create_UUID()
                                            current_event.home_tooltip.off = home_tip_array.off
                                        }
                                        if(current_event.home_tooltip.in != home_tip_array.in && home_tip_array.in != ''){
                                            current_event.home_tooltip.inKey = this.create_UUID()
                                            current_event.home_tooltip.in = home_tip_array.in
                                        }
                                        if(current_event.home_tooltip.out != home_tip_array.out && home_tip_array.out != ''){
                                            current_event.home_tooltip.outKey = this.create_UUID()
                                            current_event.home_tooltip.out = home_tip_array.out
                                        }
                                        if(current_event.home_tooltip.blk != home_tip_array.blk && home_tip_array.blk != ''){
                                            current_event.home_tooltip.blkKey = this.create_UUID()
                                            current_event.home_tooltip.blk = home_tip_array.blk
                                        }
                                        if(current_event.home_tooltip.cnr != home_tip_array.cnr && home_tip_array.cnr != ''){
                                            current_event.home_tooltip.cnrKey = this.create_UUID()
                                            current_event.home_tooltip.cnr = home_tip_array.cnr
                                        }

                                        if(current_event.away_tooltip.on != away_tip_array.on && away_tip_array.on != ''){
                                            current_event.away_tooltip.onKey = this.create_UUID()
                                            current_event.away_tooltip.on = away_tip_array.on
                                        }
                                        if(current_event.away_tooltip.off != away_tip_array.off && away_tip_array.off != ''){
                                            current_event.away_tooltip.offKey = this.create_UUID()
                                            current_event.away_tooltip.off = away_tip_array.off
                                        }
                                        if(current_event.away_tooltip.in != away_tip_array.in && away_tip_array.in != ''){
                                            current_event.away_tooltip.inKey = this.create_UUID()
                                            current_event.away_tooltip.in = away_tip_array.in
                                        }
                                        if(current_event.away_tooltip.out != away_tip_array.out && away_tip_array.out != ''){
                                            current_event.away_tooltip.outKey = this.create_UUID()
                                            current_event.away_tooltip.out = away_tip_array.out
                                        }
                                        if(current_event.away_tooltip.blk != away_tip_array.blk && away_tip_array.blk != ''){
                                            current_event.away_tooltip.blkKey = this.create_UUID()
                                            current_event.away_tooltip.blk = away_tip_array.blk
                                        }
                                        if(current_event.away_tooltip.cnr != away_tip_array.cnr && away_tip_array.cnr != ''){
                                            current_event.away_tooltip.cnrKey = this.create_UUID()
                                            current_event.away_tooltip.cnr = away_tip_array.cnr
                                        }
                                        if(current_event.goal_tooltip != goal_tooltip && goal_tooltip != ''){
                                            current_event.goalKey = this.create_UUID()
                                            current_event.goal_tooltip = goal_tooltip
                                        }

                                        ////         red yellow tooltip   
                                        if(current_event.home_tooltip.red != current_main_data.home_tooltip2.redCard && current_main_data.home_tooltip2.redCard != ''){
                                            current_event.home_tooltip.redKey = this.create_UUID()
                                            current_event.home_tooltip.red = current_main_data.home_tooltip2.redCard
                                        }
                                        if(current_event.home_tooltip.yel != current_main_data.home_tooltip2.yelCard && current_main_data.home_tooltip2.yelCard != ''){
                                            current_event.home_tooltip.yelKey = this.create_UUID()
                                            current_event.home_tooltip.yel = current_main_data.home_tooltip2.yelCard
                                        }
                                        if(current_event.home_tooltip.sbst != current_main_data.home_tooltip2.subs && current_main_data.home_tooltip2.subs != ''){
                                            current_event.home_tooltip.sbstKey = this.create_UUID()
                                            current_event.home_tooltip.sbst = current_main_data.home_tooltip2.subs
                                        }

                                        if(current_event.away_tooltip.red != current_main_data.away_tooltip2.redCard && current_main_data.away_tooltip2.redCard != ''){
                                            current_event.away_tooltip.redKey = this.create_UUID()
                                            current_event.away_tooltip.red = current_main_data.away_tooltip2.redCard
                                        }
                                        if(current_event.away_tooltip.yel != current_main_data.away_tooltip2.yelCard && current_main_data.away_tooltip2.yelCard != ''){
                                            current_event.away_tooltip.yelKey = this.create_UUID()
                                            current_event.away_tooltip.yel = current_main_data.away_tooltip2.yelCard
                                        }
                                        if(current_event.away_tooltip.sbst != current_main_data.away_tooltip2.subs && current_main_data.away_tooltip2.subs != ''){
                                            current_event.away_tooltip.sbstKey = this.create_UUID()
                                            current_event.away_tooltip.sbst = current_main_data.away_tooltip2.subs
                                        }
                                        //console.log("color check!=>", current_event.home, current_event.home_season, current_event.home1)
                                        if(current_event.home.on > current_event.home_season.on/9/(current_event.home_season.p + 0.00000001)){ current_event.home1.on = 'green'}
                                        else{ current_event.home1.on = 'red'}
                                        if(current_event.home.off > current_event.home_season.off/9/(current_event.home_season.p + 0.00000001)){ current_event.home1.off = 'green'}
                                        else{ current_event.home1.off = 'red'}
                                        if(current_event.home.blk > current_event.home_season.block/9/(current_event.home_season.p + 0.00000001)){ current_event.home1.blk = 'green'}
                                        else{ current_event.home1.blk = 'red'}
                                        if(current_event.home.in > current_event.home_season.in/9/(current_event.home_season.p + 0.00000001)){ current_event.home1.in = 'green'}
                                        else{ current_event.home1.in = 'red'}
                                        if(current_event.home.out > current_event.home_season.out/9/(current_event.home_season.p + 0.00000001)){ current_event.home1.out = 'green'}
                                        else{ current_event.home1.out = 'red'}
                                        if(current_event.home.cnr > current_event.home_season.cnr/9/(current_event.home_season.p + 0.00000001)){ current_event.home1.cnr = 'green'}
                                        else{ current_event.home1.cnr = 'red'}
                                        if(current_event.home.da > current_event.home_season.da/9/(current_event.home_season.p + 0.00000001)){ current_event.home1.da = 'green'}
                                        else{ current_event.home1.da = 'red'}
                                        if(current_event.home.poss > current_event.home_season.pos/(current_event.home_season.p + 0.00000001)){ current_event.home1.poss = 'green'}
                                        else{ current_event.home1.poss = 'red'}

                                        if(current_event.away.on > current_event.away_season.on/9/(current_event.away_season.p + 0.00000001)){ current_event.away1.on = 'green'}
                                        else{ current_event.away1.on = 'red' }
                                        if(current_event.away.off > current_event.away_season.off/9/(current_event.away_season.p + 0.00000001)){ current_event.away1.off = 'green'}
                                        else{ current_event.away1.off = 'red' }
                                        if(current_event.away.blk > current_event.away_season.block/9/(current_event.away_season.p + 0.00000001)){ current_event.away1.blk = 'green'}
                                        else{ current_event.away1.blk = 'red' }
                                        if(current_event.away.in > current_event.away_season.in/9/(current_event.away_season.p + 0.00000001)){ current_event.away1.in = 'green'}
                                        else{ current_event.away1.in = 'red' }
                                        if(current_event.away.out > current_event.away_season.out/9/(current_event.away_season.p + 0.00000001)){ current_event.away1.out = 'green'}
                                        else{ current_event.away1.out = 'red' }
                                        if(current_event.away.cnr > current_event.away_season.cnr/9/(current_event.away_season.p + 0.00000001)){ current_event.away1.cnr = 'green'}
                                        else{ current_event.away1.cnr = 'red' }
                                        if(current_event.away.da > current_event.away_season.da/9/(current_event.away_season.p + 0.00000001)){ current_event.away1.da = 'green'}
                                        else{ current_event.away1.da = 'red' }
                                        if(current_event.away.poss > current_event.away_season.pos/(current_event.away_season.p + 0.00000001)){ current_event.away1.poss = 'green'}
                                        else{ current_event.away1.poss = 'red' }

                                        if(current_event.home_season.p == 0){
                                            current_event.home1 = {
                                                'on': 'black',
                                                'off': 'black',
                                                'blk': 'black',
                                                'in': 'black',
                                                'out': 'black',
                                                'cnr': 'black',
                                                'da': 'black',
                                                'poss': 'black',
                                            }
                                        }
                                        if(current_event.away_season.p == 0){
                                            current_event.away1 = {
                                                'on': 'black',
                                                'off': 'black',
                                                'blk': 'black',
                                                'in': 'black',
                                                'out': 'black',
                                                'cnr': 'black',
                                                'da': 'black',
                                                'poss': 'black',
                                            }
                                        }
                                        this.eventArray[j].events[k] = current_event
                                    }
                                }
                            }
                            if(check_new == 0 && data1[i].updateArray.time.status == 'LIVE' && stats.length > 0){
                                // console.log("new item==>", data1[i].updateArray._id)
                                check_new_total = 1;
                                new_eventIds.push(data1[i].updateArray._id);
                            }
                        }
                    }
                    
                    if(check_new_total == 1){
                        // this.readData();
                        this.readNewData(new_eventIds);
                        //this.mygames_tab()
                        
                    }
                }
            })

            this.socket.on("UpdateStats_inplayodds", data1 => {
                if(this.reload_flag == false){
                    var d = new Date()
                    var hour = d.getHours()
                    var minute = d.getMinutes()
                    var second = d.getSeconds()
                    if(hour < 10){
                        hour = '0' + hour
                    }
                    if(minute < 10){
                        minute = '0' + minute
                    }
                    if(second < 10){
                        second = '0' + second
                    }
                    this.last_updated_time = hour + ":" + minute + ":" + second                

                    let check_new_total = 0
                    for(let i = 0 ; i < data1.length ; i++){
                        if(data1[i].currentData){
                            
                            for(let j = 0 ; j < this.eventArray.length ; j++){
                                for(let k = 0 ; k < this.eventArray[j].events.length ; k++){
                                    if(this.eventArray[j].events[k].fixtureId == data1[i].currentData._id && data1[i].currentData.inplayOdds.data.length > 0){
                                        check_new_total = check_new_total + 1
                                        let current_event = this.eventArray[j].events[k]


                                        var inplayOdds_home = ''
                                        var inplayOdds_away = ''
                                        var inplayOdds_draw = ''

                                        var over_odds = []
                                        var under_odds = []
                                        var homeT_over_odds = []
                                        var homeT_under_odds = [] 
                                            
                                        data1[i].currentData.inplayOdds.data.forEach((oItem) => {
                                            let mkt_id = oItem.market_id;
                                            if(oItem.bookmaker_id === 2) {
                                                let suffix;
                                                if(mkt_id === 1 || mkt_id === 12 || mkt_id === 976105  || mkt_id === 136703813 || mkt_id === 137918022 || mkt_id === 28077 || mkt_id === 1256989864) 
                                                    suffix = 'FT';
                                                else if(mkt_id === 37 || mkt_id === 31379 || mkt_id === 975903 || mkt_id === 976226)
                                                    suffix = 'HT';
                                                (oItem.odds || oItem.values).forEach((item) => {
                                                    let label;
                                                    if(item.label)
                                                        label = `${item.label}${item.total ? ' - ' + item.total : ''}`;
                                                    else if(item.team)
                                                        label = item.team;
                                                    else if(item.info) {
                                                        label = item.info;
                                                    }
                                                    
                                                    if(label === '1')
                                                        label = "Home";
                                                    else if(label === '2')
                                                        label = 'Away';
                                                    else if(label === 'X')
                                                        label = 'Draw';
                                                    if(!label.includes(",")) {              //except over 2.0,2.5 case
                                                        label = `${label} - ${suffix}`
                                                        if(label == 'Home - FT') {
                                                            inplayOdds_home = parseFloat(item.value)
                                                        }
                                                        else if(label == 'Away - FT') {
                                                            
                                                            inplayOdds_away = parseFloat(item.value)
                                                        }
                                                        else if(label == 'Draw - FT') {
                                                            
                                                            inplayOdds_draw = parseFloat(item.value)
                                                        }

                                                        else if (label.includes('Over') && label.includes('FT')) {                                                                    
                                                            over_odds.push({
                                                                'mark': label.replace('Over', '').replace('FT', '').replaceAll('-', '').trim(),
                                                                'value': parseFloat(item.value)
                                                            })
                                                        }

                                                        else if (label.includes('Under') && label.includes('FT')) {
                                                            under_odds.push({
                                                                'mark': label.replace('Under', '').replace('FT', '').replaceAll('-', '').trim(),
                                                                'value': parseFloat(item.value)
                                                            })
                                                        }

                                                    }
                                                });
                                            }
                                        });
                                            

                                        var mark1 = (current_event.home.score + current_event.away.score + 0.5).toString()
                                        var mark2 = (current_event.home.score + current_event.away.score + 1.5).toString()

                                        for (var m_index = 0; m_index < over_odds.length; m_index++ ){
                                            if (over_odds[m_index].mark == mark1){
                                                homeT_over_odds.push(over_odds[m_index])
                                                break
                                            }
                                        }
                                        if (homeT_over_odds.length == 0) {
                                            homeT_over_odds.push({
                                                'mark': null,
                                                'value': ''
                                            })
                                        }

                                        for (var m_index = 0; m_index < over_odds.length; m_index++ ){
                                            if (over_odds[m_index].mark == mark2){
                                                homeT_over_odds.push(over_odds[m_index])
                                                break
                                            }
                                        }
                                        if (homeT_over_odds.length == 1) {
                                            homeT_over_odds.push({
                                                'mark': null,
                                                'value': ''
                                            })
                                        }

                                        for (var m_index = 0; m_index < under_odds.length; m_index++ ){
                                            if (under_odds[m_index].mark == mark1){
                                                homeT_under_odds.push(under_odds[m_index])
                                                break
                                            }
                                        }
                                        if (homeT_under_odds.length == 0) {
                                            homeT_under_odds.push({
                                                'mark': null,
                                                'value': ''
                                            })
                                        }

                                        for (var m_index = 0; m_index < under_odds.length; m_index++ ){
                                            if (under_odds[m_index].mark == mark2){
                                                homeT_under_odds.push(under_odds[m_index])
                                                break
                                            }
                                        }
                                        if (homeT_under_odds.length == 1) {
                                            homeT_under_odds.push({
                                                'mark': null,
                                                'value': ''
                                            })
                                        }

                                        current_event.homeT.homeodds = inplayOdds_home
                                        current_event.homeT.awayodds = inplayOdds_away
                                        current_event.homeT.drawodds = inplayOdds_draw
                                        current_event.homeT.over_odds = homeT_over_odds
                                        current_event.homeT.under_odds = homeT_under_odds
                                        current_event.flatOdds = data1[i].currentData.flatOdds
                                        this.eventArray[j].events[k] = current_event
                                    }
                                }
                            }
                            
                        }
                    }
                   
                }
                
            })
        },
        beforeDestroy() {           
            this.eventArray = []
            this.socket.off('UpdateStats');
            // this.socket.off('UpdateStats_inplayodds');
        },
        computed: {           

            filtered_eventArray() {
                if (this.apply_filter){
                    let eventArray = [];
                    for(let i = 0 ; i < this.eventArray.length ; i++){
                        let item = this.eventArray[i];

                        let league_list = this.search_filters.league;
                        if (league_list.filter(item_league => item_league.league_name === item.league).length === 0)
                            continue;

                        let events = [];

                        for(let j = 0 ; j < item.events.length ; j++){
                            let event = item.events[j];
                            let pass_filter = this.checkSearchFilter(event);
                            if (pass_filter)
                                events.push(event);

                        }

                        if (events.length > 0) {
                            let new_item = {
                                league: item.league,
                                league_id: item.league_id,
                                events: events
                            }
                            eventArray.push(new_item);
                        }
                        
                    }
                    
                    return eventArray;

                }
                else{
                    return this.eventArray;
                }
                
            },

            counted_events() {
                if (this.apply_filter){
                    let counter = 0;
                    for(let i = 0 ; i < this.filtered_eventArray.length ; i++){
                        let item = this.filtered_eventArray[i];
                        counter += item.events.length;
                    }
                    
                    return counter;
                }
                else{
                    return 0;
                }
            }
        },
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .Odds-label{
        background: #6c757d;
        color: white;
        width: 40px;
        text-align: center;
        border-radius: 3px;
        padding: 0;
        height: 15px;
        margin: 0;
    }
    .green-label {
        background: green;
        color: white;
        width: 40px;
        text-align: center;
        border-radius: 3px;
        padding: 0;
        height: 15px;
        margin: 0;
        margin-left:  1px;
        margin-top: 1px;
    }
    .stats-label {
        padding-left:  5px;
    }
    .filter{
        float: left;
        margin-top: 20px;
    }
    .filter label{
        font-weight: bold;
        color: red;
        float: left;
        margin-bottom: 0px;
        margin-top: 5px;
        margin-left: 10px;
        margin-right: 15px;
        font-size: 14px;
    }
    .card.drag, .card .drag {
        cursor: crosshair;
    }
    .modal-dialog {
        max-width: 820px!important;
    }
    .modal-backdrop {
        background-color: #000!important;
        opacity: 0.2!important;
    }
    .season-detail{
        width: 5%!important;
        min-width: 30px!important;
        font-size: 12px!important;
    }
    .bottom-part.bottom-part1 .detail{
        width: 11%!important;
    }
    .bottom-part.bottom-part1 .index_detail{
        width: 14%!important;
    }
    .live-stats-container .nav-item a {
        height: 100%;
        margin-bottom: 1px;
        padding-top: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    @media (max-width: 425px){
        .live-stats-container .nav-item a {
            font-size: 12px;
        }
    }
    .c-subheader{
        padding: 0;
        height: 30px!important;
        min-height: 30px!important;
    }
    .breadcrumb{
        padding: 0!important;
        padding-top: 4px!important;
    }
    .season-part .detail{
        width: 5%;
    }
    .c-header-nav {
        min-height: 45px!important;
        height: 45px!important;
    }
    @media (min-width: 992px){
        html:not([dir="rtl"]) .c-sidebar.c-sidebar-lg-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper, html:not([dir="rtl"]) .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper {
            margin-left: 194px;
        }
    }
    .c-sidebar{
        width: 194px;
    }
    @media (min-width: 992px){
        .c-sidebar-minimized.c-sidebar-fixed {
            z-index: 1031;
            width: 56px;
        }
    }
    @media (min-width: 992px){
        html:not([dir="rtl"]) .c-sidebar.c-sidebar-lg-show:not(.c-sidebar-right), html:not([dir="rtl"]) .c-sidebar.c-sidebar-show:not(.c-sidebar-right) {
            margin-left: 0;
        }
    }
    @media (min-width: 992px){
        html:not([dir="rtl"]) .c-sidebar.c-sidebar-lg-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper, html:not([dir="rtl"]) .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper {
            margin-left: 56px;
        }
    }

    .live-stats-container .nav-item{
        font-size: 14px!important;
    }
    .live-stats-container .card{
        width: 100%;
        border: none;
    }
    .live-stats-container div{
        font-size: 12px!important;
    }
    .live-stats-container .season-detail{
        font-size: 12px!important;
    }
    .live-stats-container .card-body{
        padding: 5px;
    }
    .c-main{
        padding: 0;
        overflow-x: visible;
    }
    .c-main .container-fluid{
        padding: 0;
    }
    .live-stats-container .nav-item{
        width: 25%;
        text-align: center;
        font-size: 16px;
    }
    .live-stats-container .tab-content {
        padding: 0px;
    }
    .live-stats-container .tab-content .tab-pane .tab-pane-wrapper {
        width: 100%;
    }
    @media (min-width: 769px){
        .live-stats-container {
            min-width: 1256px;
            max-height: 70vh;
        }
    }
    @media (max-width: 768px) {
        .live-stats-container .tab-content .tab-pane .tab-pane-wrapper {
           overflow-x: auto;
        }
        .live-stats-container .tab-content .tab-pane .tab-pane-table-content {
            min-width: 1236px;
        }
    }
    /* schedule tab */
    .shedule-number-column {
        display: grid;
        grid-template-columns: auto auto auto;
        grid-column-gap: 3px;
    }
    .shedule-tab-match-number {
        text-align: center;
        width: 40px;
    }
    .header .header-content{
        height: 50px;
        font-size: 13px;
        font-weight: 600;
        padding: 4px 4px 2px;
        text-align: center;
        background: #cecece;
    }
    .detail{
        width: 7%;
        min-width: 26px;
        float: left;
        padding:0;
        text-align: center;
        font-size: 12px;
    }
    .detail_gb{
        width: 16%;
        min-width: 26px;
        float: left;
        padding:0;
        text-align: center;
        font-size: 12px;
    }
    .detail1{
        width: 8.6%;
        min-width: 26px;
        float: left;
        padding:0;
        text-align: center;
        font-size: 12px;
    }
    .detail_total .detail{
        min-width: 26px;
    }
    .finished-tab .detail{
        width: 7.5%;
    }
    .index_detail{
        width: 14%!important;
    }
    .time_manner{
        animation: splash infinite 1s;
    }
    .goal_manner{
        animation: splash1 infinite 1s;
    }

    /* modal */
    .modal-dialog {
        display: flex;
        justify-content: center;
    }
    .modal-content {
        width: calc(100% - 20px) !important;
    }
    .modal-tab-content {
        display: block; 
        width: 100%; 
        height: 127px; 
        overflow-x: scroll;
        height: -webkit-fill-available;
    }
    .modal-tab-content::-webkit-scrollbar {
        -webkit-appearance: none !important;
    }
    .modal-tab-content::-webkit-scrollbar:horizontal {
        height: 20px !important;
    }
    .modal-tab-content::-webkit-scrollbar:vertical {
        width: 0px;
    }
    .modal-tab-content::-webkit-scrollbar-thumb {
        background-color: rgba(104, 102, 102, 0.5);
        border-radius: 5px;
        border: 2px solid #ffffff;
    }
    .modal-tab-content::-webkit-scrollbar-track {
        display: block !important;
        border-radius: 5px;
        background-color: #ffffff;
    }

    /* custom style */
    .column-header-checkbox {
        height: 50px; 
        position: absolute; 
        padding-top: 1px;
        left: 5px;
        z-index: 1000;
    }
    .column-league-header {
        width: 15%;
        float: left;
        font-weight: bold !important;
        padding-left: 25px !important;
    }
    .time_manner p {
        margin-bottom: 0;
    }
    .column-league-content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        /* padding: 2px 1px 3px 0; */
        word-break: break-all;
    }
    .column-league-name {
        height: 40px;
        display: flex;
        align-items: center;
        line-height: 13px;
        font-size: 11px !important;
    }
    .column-league-content-links-wrapper {
        position: absolute;
        top: 29px;
        left: 55%;
        display: flex;
        justify-content: flex-end;
    }
    .column-league-content-links {
        display: flex;
        width: 95px;
        justify-content: flex-start;
    }
    .column-league-content-link {
        margin-left: 2px;
        z-index: 1000;
    }
    .column-league-content-link img {
        width: 17px;
        cursor: pointer;
        outline: none;
    }
    .column-result-header {
        width: 4%; 
        min-width: 30px; 
        float: left; 
        border-left: 1px solid whitesmoke; 
        font-weight: bold !important;
    }
    .column-result {
        width: 4%; 
        height: 80px; 
        float: left; 
        border-left: 1px solid #e2e2e2;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .column-result p {
        padding: 0;
        margin: 0;
    }
    .column-total-game-header-wrapper {
        width: 29%; 
        float: left; 
        border-left: 1px solid whitesmoke;  
        font-weight: bold !important;
        padding: 4px 0px 2px !important;
    }
    .column-total-game-header {
        display: grid;
        grid-template-columns: auto auto auto auto auto auto auto auto auto auto auto auto auto ;
        padding: 5px 5px 5px 2px;
    }
    .column-total-game-wrapper {
        width: 29%;
        height: 40px !important;
        float: left; 
        border-left: 1px solid #e2e2e2;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .column-total-game {
        display: grid;
        grid-template-columns: auto auto auto auto auto auto auto auto auto auto auto auto auto ;
        width: 100%; 
        padding-right: 7px;
        padding-left: 3px;
    }
    .column-last-10-header-wrapper {
        width: 25%; 
        float: left; 
        border-left: 1px solid whitesmoke;  
        font-weight: bold !important;
    }
    .column-last-10-header {
        display: grid;
        grid-template-columns: auto auto auto auto auto auto auto auto auto auto auto;
        padding: 5px 5px 5px 1px;
    }
    .column-last-10-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        float: left;
        width: 25%; 
        height: 40px;
        border-left: 1px solid #e2e2e2;
    }
    .column-last-10 {
        display: grid;
        grid-template-columns: auto auto auto auto auto auto auto auto auto auto auto;
        width: 100%; 
        padding-right: 5px;
        padding-left: 5px;
    }
    .column-odds-header {
        padding-top: 6px;
    }
    .column-odds {
        display: flex;
        justify-content: center;
    }
    .column-odds-right, .column-odds-left {
        width: 55%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .column-odds-left {
        width: 45%;
    }
    .column-next-goal-header {
        width: 4%; 
        float: left; 
        border-left: 1px solid whitesmoke;
    }
    .column-next-goal {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 4%; 
        float: left;
        height: 80px; 
        border-left: 1px solid #e2e2e2;
    }
    .column-next-goal-content {
        display: inline-block;
    }
    .column-next-goal-content label {
        margin-bottom: 0 !important;
        margin-left: 1px;
    }
    .column-gb-percent-header {
        width: 4%; 
        float: left;
        border-left: 1px solid whitesmoke;
        height: 50px;
    }
    .column-gb-percent {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 4%; 
        height: 80px; 
        float: left; 
        border-left: 1px solid #e2e2e2;
    }
    .column-gb-percent label {
        margin-bottom: 0;
    }
    .last-update-bottom-bar {
        clear: left; 
        width: 100%; 
        border: 1px solid lightgray; 
        text-align: center;
        height: 30px;
        background: #e6eef5;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .last-update-bottom-bar label {
        margin-bottom: 0;
    }

    /* mobile horizontal view */
    /* @media (max-width: 768px){
        .live-stats-container div {
            font-size: 9px !important;
        }

        .header .header-content {
            font-size: 9px !important;
        }

        .detail_total .detail {
            width: 19px !important;
            min-width: 19px !important;
        }
        .detail1 {
            width: 20px !important;
            min-width: 20px !important;
        }

        .column-league-header {
            width: 10%;
            padding: 0 !important;
            padding-left: 23px !important;
        }
        .column-result-header {
            width: 3%;
        }
        .column-total-game-header-wrapper { 
            width: 20%;
            padding: 6px 0 !important;
        }
        .column-total-game-header, .column-last-10-header {
            display: flex;
            align-items: space-between;
            padding: 10px 0px;
        }

        .column-last-10-header-wrapper {
            width: 17%;
            padding: 6px 0 !important;
        }
    } */

    @keyframes splash {
        0% {
            color: white;
        }
        50% {
            color: #fa050d;
        }
        100%{
            color:white;
        }
    }
    @keyframes splash1 {
        0% {
            color: white;
        }
        25% {
            color: #16ad57;
        }
        50% {
            color: #199e69;
        }
        70%{
            color: #28b06f;
        }
        100%{
            color:white;
        }
    }
    .slide-fade-enter-active {
        -webkit-animation-name: example;
        -webkit-animation-duration: 3s;
        -webkit-animation-iteration-count: 1;
        animation-name: example;
        animation-duration: 3s;
        animation-iteration-count: 1;
    }

    .livenow {
        -webkit-animation-name: example;
        -webkit-animation-duration: 3s;
        -webkit-animation-iteration-count: 1;
        animation-name: example;
        animation-duration: 3s;
        animation-iteration-count: 1;
    }
    .goalcelebration {
        -webkit-animation-name: example1;
        -webkit-animation-duration: 3s;
        -webkit-animation-iteration-count: 10;
        animation-name: example1;
        animation-duration: 3s;
        animation-iteration-count: 10;
    }
    .pre-formatted {
      white-space: pre;
    }
    @keyframes example {
        0% {
            background-color: rgba(166, 216, 255, 0.53);
        }
        50% {
            background-color: rgba(18, 18, 18, 0.34);
        }
        100% {
            background-color: rgba(250, 201, 209, 0.53);
        }
        100% {
            background-color: rgba(243, 196, 0, 0.5)!important;
        }
    }
    @keyframes example1 {
        0% {
            color: rgba(76, 175, 80, 0.5);
        }
        50% {
            color: rgba(76, 175, 80, 1);
        }
        100% {
            color: rgba(76, 175, 80, 0.5);
        }
        100% {
            color: rgba(76, 175, 80, 1) !important;
        }
    }
    @media screen and (max-width: 600px) {
        .table-cell input{
            max-width: 44px;
        }
        
    }
    
    @media screen and (max-width: 2000px) {
        .column-league-content-links-wrapper {
            left: 50%;
        }
    }
    @media screen and (max-width: 1500px) {
        .column-league-content-links-wrapper {
            left: 45%;
        }
    }
    @media screen and (max-width: 1256px) {
        .column-league-content-links-wrapper {
            left: 40%;
        }
    }
    
    .advanced_search{
        margin-top: 20px;
    }
    .advanced_search input {
        height: 35px !important;
    }

    .postTipBtn {
        margin-left: 2px;
        background-color: orangered;
        color: white;
        cursor: pointer;
        border-radius: 20%;
        width:  30px;
        text-align: center;
    }
    
</style>
